import { __assign, __awaiter, __generator, __read } from "tslib";
import { HttpRequest as __HttpRequest } from "@aws-sdk/protocol-http";
import { decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectInt32 as __expectInt32, expectLong as __expectLong, expectNonNull as __expectNonNull, expectNumber as __expectNumber, expectObject as __expectObject, expectString as __expectString, expectUnion as __expectUnion, extendedEncodeURIComponent as __extendedEncodeURIComponent, limitedParseDouble as __limitedParseDouble, parseEpochTimestamp as __parseEpochTimestamp, serializeFloat as __serializeFloat, } from "@aws-sdk/smithy-client";
import { v4 as generateIdempotencyToken } from "uuid";
import { IoTServiceException as __BaseException } from "../models/IoTServiceException";
import { AssetPropertyVariant, CertificateStateException, CertificateValidationException, ConflictException, ConflictingResourceUpdateException, DeleteConflictException, IndexNotReadyException, InternalException, InternalFailureException, InvalidAggregationException, InvalidQueryException, InvalidRequestException, InvalidStateTransitionException, LimitExceededException, MalformedPolicyException, ResourceAlreadyExistsException, ResourceNotFoundException, ServiceUnavailableException, SqlParseException, ThrottlingException, TransferAlreadyCompletedException, UnauthorizedException, VersionConflictException, VersionsLimitExceededException, } from "../models/models_0";
import { InternalServerException, NotConfiguredException, } from "../models/models_1";
import { CertificateConflictException, InvalidResponseException, RegistrationCodeValidationException, ResourceRegistrationFailureException, TaskAlreadyExistsException, TransferConflictException, } from "../models/models_2";
export var serializeAws_restJson1AcceptCertificateTransferCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/accept-certificate-transfer/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                query = __assign({}, (input.setAsActive !== undefined && { setAsActive: input.setAsActive.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1AddThingToBillingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/billing-groups/addThingToBillingGroup";
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.billingGroupArn !== undefined &&
                    input.billingGroupArn !== null && { billingGroupArn: input.billingGroupArn })), (input.billingGroupName !== undefined &&
                    input.billingGroupName !== null && { billingGroupName: input.billingGroupName })), (input.thingArn !== undefined && input.thingArn !== null && { thingArn: input.thingArn })), (input.thingName !== undefined && input.thingName !== null && { thingName: input.thingName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1AddThingToThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups/addThingToThingGroup";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.overrideDynamicGroups !== undefined &&
                    input.overrideDynamicGroups !== null && { overrideDynamicGroups: input.overrideDynamicGroups })), (input.thingArn !== undefined && input.thingArn !== null && { thingArn: input.thingArn })), (input.thingGroupArn !== undefined && input.thingGroupArn !== null && { thingGroupArn: input.thingGroupArn })), (input.thingGroupName !== undefined &&
                    input.thingGroupName !== null && { thingGroupName: input.thingGroupName })), (input.thingName !== undefined && input.thingName !== null && { thingName: input.thingName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1AssociateTargetsWithJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs/{jobId}/targets";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                query = __assign({}, (input.namespaceId !== undefined && { namespaceId: input.namespaceId }));
                body = JSON.stringify(__assign(__assign({}, (input.comment !== undefined && input.comment !== null && { comment: input.comment })), (input.targets !== undefined &&
                    input.targets !== null && { targets: serializeAws_restJson1JobTargets(input.targets, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1AttachPolicyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/target-policies/{policyName}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                body = JSON.stringify(__assign({}, (input.target !== undefined && input.target !== null && { target: input.target })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1AttachPrincipalPolicyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = __assign({}, (isSerializableHeaderValue(input.principal) && { "x-amzn-iot-principal": input.principal }));
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/principal-policies/{policyName}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1AttachSecurityProfileCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/security-profiles/{securityProfileName}/targets";
                if (input.securityProfileName !== undefined) {
                    labelValue = input.securityProfileName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: securityProfileName.");
                    }
                    resolvedPath = resolvedPath.replace("{securityProfileName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: securityProfileName.");
                }
                query = __assign({}, (input.securityProfileTargetArn !== undefined && { securityProfileTargetArn: input.securityProfileTargetArn }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1AttachThingPrincipalCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = __assign({}, (isSerializableHeaderValue(input.principal) && { "x-amzn-principal": input.principal }));
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}/principals";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CancelAuditMitigationActionsTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/audit/mitigationactions/tasks/{taskId}/cancel";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CancelAuditTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/tasks/{taskId}/cancel";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CancelCertificateTransferCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/cancel-certificate-transfer/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CancelDetectMitigationActionsTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/detect/mitigationactions/tasks/{taskId}/cancel";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CancelJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs/{jobId}/cancel";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                query = __assign({}, (input.force !== undefined && { force: input.force.toString() }));
                body = JSON.stringify(__assign(__assign({}, (input.comment !== undefined && input.comment !== null && { comment: input.comment })), (input.reasonCode !== undefined && input.reasonCode !== null && { reasonCode: input.reasonCode })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CancelJobExecutionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}/jobs/{jobId}/cancel";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                query = __assign({}, (input.force !== undefined && { force: input.force.toString() }));
                body = JSON.stringify(__assign(__assign({}, (input.expectedVersion !== undefined &&
                    input.expectedVersion !== null && { expectedVersion: input.expectedVersion })), (input.statusDetails !== undefined &&
                    input.statusDetails !== null && {
                    statusDetails: serializeAws_restJson1DetailsMap(input.statusDetails, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ClearDefaultAuthorizerCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/default-authorizer";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ConfirmTopicRuleDestinationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/confirmdestination/{confirmationToken+}";
                if (input.confirmationToken !== undefined) {
                    labelValue = input.confirmationToken;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: confirmationToken.");
                    }
                    resolvedPath = resolvedPath.replace("{confirmationToken+}", labelValue
                        .split("/")
                        .map(function (segment) { return __extendedEncodeURIComponent(segment); })
                        .join("/"));
                }
                else {
                    throw new Error("No value provided for input HTTP label: confirmationToken.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateAuditSuppressionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _d.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/suppressions/create";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.checkName !== undefined && input.checkName !== null && { checkName: input.checkName })), { clientRequestToken: (_c = input.clientRequestToken) !== null && _c !== void 0 ? _c : generateIdempotencyToken() }), (input.description !== undefined && input.description !== null && { description: input.description })), (input.expirationDate !== undefined &&
                    input.expirationDate !== null && { expirationDate: Math.round(input.expirationDate.getTime() / 1000) })), (input.resourceIdentifier !== undefined &&
                    input.resourceIdentifier !== null && {
                    resourceIdentifier: serializeAws_restJson1ResourceIdentifier(input.resourceIdentifier, context),
                })), (input.suppressIndefinitely !== undefined &&
                    input.suppressIndefinitely !== null && { suppressIndefinitely: input.suppressIndefinitely })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateAuthorizerCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/authorizer/{authorizerName}";
                if (input.authorizerName !== undefined) {
                    labelValue = input.authorizerName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: authorizerName.");
                    }
                    resolvedPath = resolvedPath.replace("{authorizerName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: authorizerName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.authorizerFunctionArn !== undefined &&
                    input.authorizerFunctionArn !== null && { authorizerFunctionArn: input.authorizerFunctionArn })), (input.enableCachingForHttp !== undefined &&
                    input.enableCachingForHttp !== null && { enableCachingForHttp: input.enableCachingForHttp })), (input.signingDisabled !== undefined &&
                    input.signingDisabled !== null && { signingDisabled: input.signingDisabled })), (input.status !== undefined && input.status !== null && { status: input.status })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.tokenKeyName !== undefined && input.tokenKeyName !== null && { tokenKeyName: input.tokenKeyName })), (input.tokenSigningPublicKeys !== undefined &&
                    input.tokenSigningPublicKeys !== null && {
                    tokenSigningPublicKeys: serializeAws_restJson1PublicKeyMap(input.tokenSigningPublicKeys, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateBillingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/billing-groups/{billingGroupName}";
                if (input.billingGroupName !== undefined) {
                    labelValue = input.billingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: billingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{billingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: billingGroupName.");
                }
                body = JSON.stringify(__assign(__assign({}, (input.billingGroupProperties !== undefined &&
                    input.billingGroupProperties !== null && {
                    billingGroupProperties: serializeAws_restJson1BillingGroupProperties(input.billingGroupProperties, context),
                })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateCertificateFromCsrCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificates";
                query = __assign({}, (input.setAsActive !== undefined && { setAsActive: input.setAsActive.toString() }));
                body = JSON.stringify(__assign({}, (input.certificateSigningRequest !== undefined &&
                    input.certificateSigningRequest !== null && { certificateSigningRequest: input.certificateSigningRequest })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateCustomMetricCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _d.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/custom-metric/{metricName}";
                if (input.metricName !== undefined) {
                    labelValue = input.metricName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: metricName.");
                    }
                    resolvedPath = resolvedPath.replace("{metricName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: metricName.");
                }
                body = JSON.stringify(__assign(__assign(__assign({ clientRequestToken: (_c = input.clientRequestToken) !== null && _c !== void 0 ? _c : generateIdempotencyToken() }, (input.displayName !== undefined && input.displayName !== null && { displayName: input.displayName })), (input.metricType !== undefined && input.metricType !== null && { metricType: input.metricType })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateDimensionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _d.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/dimensions/{name}";
                if (input.name !== undefined) {
                    labelValue = input.name;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: name.");
                    }
                    resolvedPath = resolvedPath.replace("{name}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: name.");
                }
                body = JSON.stringify(__assign(__assign(__assign({ clientRequestToken: (_c = input.clientRequestToken) !== null && _c !== void 0 ? _c : generateIdempotencyToken() }, (input.stringValues !== undefined &&
                    input.stringValues !== null && {
                    stringValues: serializeAws_restJson1DimensionStringValues(input.stringValues, context),
                })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.type !== undefined && input.type !== null && { type: input.type })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateDomainConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/domainConfigurations/{domainConfigurationName}";
                if (input.domainConfigurationName !== undefined) {
                    labelValue = input.domainConfigurationName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: domainConfigurationName.");
                    }
                    resolvedPath = resolvedPath.replace("{domainConfigurationName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: domainConfigurationName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.authorizerConfig !== undefined &&
                    input.authorizerConfig !== null && {
                    authorizerConfig: serializeAws_restJson1AuthorizerConfig(input.authorizerConfig, context),
                })), (input.domainName !== undefined && input.domainName !== null && { domainName: input.domainName })), (input.serverCertificateArns !== undefined &&
                    input.serverCertificateArns !== null && {
                    serverCertificateArns: serializeAws_restJson1ServerCertificateArns(input.serverCertificateArns, context),
                })), (input.serviceType !== undefined && input.serviceType !== null && { serviceType: input.serviceType })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.validationCertificateArn !== undefined &&
                    input.validationCertificateArn !== null && { validationCertificateArn: input.validationCertificateArn })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateDynamicThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/dynamic-thing-groups/{thingGroupName}";
                if (input.thingGroupName !== undefined) {
                    labelValue = input.thingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingGroupName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.thingGroupProperties !== undefined &&
                    input.thingGroupProperties !== null && {
                    thingGroupProperties: serializeAws_restJson1ThingGroupProperties(input.thingGroupProperties, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateFleetMetricCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/fleet-metric/{metricName}";
                if (input.metricName !== undefined) {
                    labelValue = input.metricName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: metricName.");
                    }
                    resolvedPath = resolvedPath.replace("{metricName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: metricName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.aggregationField !== undefined &&
                    input.aggregationField !== null && { aggregationField: input.aggregationField })), (input.aggregationType !== undefined &&
                    input.aggregationType !== null && {
                    aggregationType: serializeAws_restJson1AggregationType(input.aggregationType, context),
                })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.period !== undefined && input.period !== null && { period: input.period })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.unit !== undefined && input.unit !== null && { unit: input.unit })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs/{jobId}";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.abortConfig !== undefined &&
                    input.abortConfig !== null && { abortConfig: serializeAws_restJson1AbortConfig(input.abortConfig, context) })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.document !== undefined && input.document !== null && { document: input.document })), (input.documentParameters !== undefined &&
                    input.documentParameters !== null && {
                    documentParameters: serializeAws_restJson1ParameterMap(input.documentParameters, context),
                })), (input.documentSource !== undefined &&
                    input.documentSource !== null && { documentSource: input.documentSource })), (input.jobExecutionsRetryConfig !== undefined &&
                    input.jobExecutionsRetryConfig !== null && {
                    jobExecutionsRetryConfig: serializeAws_restJson1JobExecutionsRetryConfig(input.jobExecutionsRetryConfig, context),
                })), (input.jobExecutionsRolloutConfig !== undefined &&
                    input.jobExecutionsRolloutConfig !== null && {
                    jobExecutionsRolloutConfig: serializeAws_restJson1JobExecutionsRolloutConfig(input.jobExecutionsRolloutConfig, context),
                })), (input.jobTemplateArn !== undefined &&
                    input.jobTemplateArn !== null && { jobTemplateArn: input.jobTemplateArn })), (input.namespaceId !== undefined && input.namespaceId !== null && { namespaceId: input.namespaceId })), (input.presignedUrlConfig !== undefined &&
                    input.presignedUrlConfig !== null && {
                    presignedUrlConfig: serializeAws_restJson1PresignedUrlConfig(input.presignedUrlConfig, context),
                })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.targetSelection !== undefined &&
                    input.targetSelection !== null && { targetSelection: input.targetSelection })), (input.targets !== undefined &&
                    input.targets !== null && { targets: serializeAws_restJson1JobTargets(input.targets, context) })), (input.timeoutConfig !== undefined &&
                    input.timeoutConfig !== null && {
                    timeoutConfig: serializeAws_restJson1TimeoutConfig(input.timeoutConfig, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateJobTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/job-templates/{jobTemplateId}";
                if (input.jobTemplateId !== undefined) {
                    labelValue = input.jobTemplateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobTemplateId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobTemplateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobTemplateId.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.abortConfig !== undefined &&
                    input.abortConfig !== null && { abortConfig: serializeAws_restJson1AbortConfig(input.abortConfig, context) })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.document !== undefined && input.document !== null && { document: input.document })), (input.documentSource !== undefined &&
                    input.documentSource !== null && { documentSource: input.documentSource })), (input.jobArn !== undefined && input.jobArn !== null && { jobArn: input.jobArn })), (input.jobExecutionsRetryConfig !== undefined &&
                    input.jobExecutionsRetryConfig !== null && {
                    jobExecutionsRetryConfig: serializeAws_restJson1JobExecutionsRetryConfig(input.jobExecutionsRetryConfig, context),
                })), (input.jobExecutionsRolloutConfig !== undefined &&
                    input.jobExecutionsRolloutConfig !== null && {
                    jobExecutionsRolloutConfig: serializeAws_restJson1JobExecutionsRolloutConfig(input.jobExecutionsRolloutConfig, context),
                })), (input.presignedUrlConfig !== undefined &&
                    input.presignedUrlConfig !== null && {
                    presignedUrlConfig: serializeAws_restJson1PresignedUrlConfig(input.presignedUrlConfig, context),
                })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.timeoutConfig !== undefined &&
                    input.timeoutConfig !== null && {
                    timeoutConfig: serializeAws_restJson1TimeoutConfig(input.timeoutConfig, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateKeysAndCertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/keys-and-certificate";
                query = __assign({}, (input.setAsActive !== undefined && { setAsActive: input.setAsActive.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateMitigationActionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/mitigationactions/actions/{actionName}";
                if (input.actionName !== undefined) {
                    labelValue = input.actionName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: actionName.");
                    }
                    resolvedPath = resolvedPath.replace("{actionName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: actionName.");
                }
                body = JSON.stringify(__assign(__assign(__assign({}, (input.actionParams !== undefined &&
                    input.actionParams !== null && {
                    actionParams: serializeAws_restJson1MitigationActionParams(input.actionParams, context),
                })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateOTAUpdateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/otaUpdates/{otaUpdateId}";
                if (input.otaUpdateId !== undefined) {
                    labelValue = input.otaUpdateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: otaUpdateId.");
                    }
                    resolvedPath = resolvedPath.replace("{otaUpdateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: otaUpdateId.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.additionalParameters !== undefined &&
                    input.additionalParameters !== null && {
                    additionalParameters: serializeAws_restJson1AdditionalParameterMap(input.additionalParameters, context),
                })), (input.awsJobAbortConfig !== undefined &&
                    input.awsJobAbortConfig !== null && {
                    awsJobAbortConfig: serializeAws_restJson1AwsJobAbortConfig(input.awsJobAbortConfig, context),
                })), (input.awsJobExecutionsRolloutConfig !== undefined &&
                    input.awsJobExecutionsRolloutConfig !== null && {
                    awsJobExecutionsRolloutConfig: serializeAws_restJson1AwsJobExecutionsRolloutConfig(input.awsJobExecutionsRolloutConfig, context),
                })), (input.awsJobPresignedUrlConfig !== undefined &&
                    input.awsJobPresignedUrlConfig !== null && {
                    awsJobPresignedUrlConfig: serializeAws_restJson1AwsJobPresignedUrlConfig(input.awsJobPresignedUrlConfig, context),
                })), (input.awsJobTimeoutConfig !== undefined &&
                    input.awsJobTimeoutConfig !== null && {
                    awsJobTimeoutConfig: serializeAws_restJson1AwsJobTimeoutConfig(input.awsJobTimeoutConfig, context),
                })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.files !== undefined &&
                    input.files !== null && { files: serializeAws_restJson1OTAUpdateFiles(input.files, context) })), (input.protocols !== undefined &&
                    input.protocols !== null && { protocols: serializeAws_restJson1Protocols(input.protocols, context) })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.targetSelection !== undefined &&
                    input.targetSelection !== null && { targetSelection: input.targetSelection })), (input.targets !== undefined &&
                    input.targets !== null && { targets: serializeAws_restJson1Targets(input.targets, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreatePolicyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/policies/{policyName}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                body = JSON.stringify(__assign(__assign({}, (input.policyDocument !== undefined &&
                    input.policyDocument !== null && { policyDocument: input.policyDocument })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreatePolicyVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/policies/{policyName}/version";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                query = __assign({}, (input.setAsDefault !== undefined && { setAsDefault: input.setAsDefault.toString() }));
                body = JSON.stringify(__assign({}, (input.policyDocument !== undefined &&
                    input.policyDocument !== null && { policyDocument: input.policyDocument })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateProvisioningClaimCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/provisioning-templates/{templateName}/provisioning-claim";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateProvisioningTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/provisioning-templates";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.description !== undefined && input.description !== null && { description: input.description })), (input.enabled !== undefined && input.enabled !== null && { enabled: input.enabled })), (input.preProvisioningHook !== undefined &&
                    input.preProvisioningHook !== null && {
                    preProvisioningHook: serializeAws_restJson1ProvisioningHook(input.preProvisioningHook, context),
                })), (input.provisioningRoleArn !== undefined &&
                    input.provisioningRoleArn !== null && { provisioningRoleArn: input.provisioningRoleArn })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.templateBody !== undefined && input.templateBody !== null && { templateBody: input.templateBody })), (input.templateName !== undefined && input.templateName !== null && { templateName: input.templateName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateProvisioningTemplateVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/provisioning-templates/{templateName}/versions";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                query = __assign({}, (input.setAsDefault !== undefined && { setAsDefault: input.setAsDefault.toString() }));
                body = JSON.stringify(__assign({}, (input.templateBody !== undefined && input.templateBody !== null && { templateBody: input.templateBody })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateRoleAliasCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/role-aliases/{roleAlias}";
                if (input.roleAlias !== undefined) {
                    labelValue = input.roleAlias;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: roleAlias.");
                    }
                    resolvedPath = resolvedPath.replace("{roleAlias}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: roleAlias.");
                }
                body = JSON.stringify(__assign(__assign(__assign({}, (input.credentialDurationSeconds !== undefined &&
                    input.credentialDurationSeconds !== null && { credentialDurationSeconds: input.credentialDurationSeconds })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateScheduledAuditCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/audit/scheduledaudits/{scheduledAuditName}";
                if (input.scheduledAuditName !== undefined) {
                    labelValue = input.scheduledAuditName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: scheduledAuditName.");
                    }
                    resolvedPath = resolvedPath.replace("{scheduledAuditName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: scheduledAuditName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.dayOfMonth !== undefined && input.dayOfMonth !== null && { dayOfMonth: input.dayOfMonth })), (input.dayOfWeek !== undefined && input.dayOfWeek !== null && { dayOfWeek: input.dayOfWeek })), (input.frequency !== undefined && input.frequency !== null && { frequency: input.frequency })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.targetCheckNames !== undefined &&
                    input.targetCheckNames !== null && {
                    targetCheckNames: serializeAws_restJson1TargetAuditCheckNames(input.targetCheckNames, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateSecurityProfileCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/security-profiles/{securityProfileName}";
                if (input.securityProfileName !== undefined) {
                    labelValue = input.securityProfileName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: securityProfileName.");
                    }
                    resolvedPath = resolvedPath.replace("{securityProfileName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: securityProfileName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.additionalMetricsToRetain !== undefined &&
                    input.additionalMetricsToRetain !== null && {
                    additionalMetricsToRetain: serializeAws_restJson1AdditionalMetricsToRetainList(input.additionalMetricsToRetain, context),
                })), (input.additionalMetricsToRetainV2 !== undefined &&
                    input.additionalMetricsToRetainV2 !== null && {
                    additionalMetricsToRetainV2: serializeAws_restJson1AdditionalMetricsToRetainV2List(input.additionalMetricsToRetainV2, context),
                })), (input.alertTargets !== undefined &&
                    input.alertTargets !== null && { alertTargets: serializeAws_restJson1AlertTargets(input.alertTargets, context) })), (input.behaviors !== undefined &&
                    input.behaviors !== null && { behaviors: serializeAws_restJson1Behaviors(input.behaviors, context) })), (input.securityProfileDescription !== undefined &&
                    input.securityProfileDescription !== null && { securityProfileDescription: input.securityProfileDescription })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateStreamCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/streams/{streamId}";
                if (input.streamId !== undefined) {
                    labelValue = input.streamId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: streamId.");
                    }
                    resolvedPath = resolvedPath.replace("{streamId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: streamId.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.description !== undefined && input.description !== null && { description: input.description })), (input.files !== undefined &&
                    input.files !== null && { files: serializeAws_restJson1StreamFiles(input.files, context) })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateThingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                body = JSON.stringify(__assign(__assign(__assign({}, (input.attributePayload !== undefined &&
                    input.attributePayload !== null && {
                    attributePayload: serializeAws_restJson1AttributePayload(input.attributePayload, context),
                })), (input.billingGroupName !== undefined &&
                    input.billingGroupName !== null && { billingGroupName: input.billingGroupName })), (input.thingTypeName !== undefined && input.thingTypeName !== null && { thingTypeName: input.thingTypeName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups/{thingGroupName}";
                if (input.thingGroupName !== undefined) {
                    labelValue = input.thingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingGroupName.");
                }
                body = JSON.stringify(__assign(__assign(__assign({}, (input.parentGroupName !== undefined &&
                    input.parentGroupName !== null && { parentGroupName: input.parentGroupName })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.thingGroupProperties !== undefined &&
                    input.thingGroupProperties !== null && {
                    thingGroupProperties: serializeAws_restJson1ThingGroupProperties(input.thingGroupProperties, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateThingTypeCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-types/{thingTypeName}";
                if (input.thingTypeName !== undefined) {
                    labelValue = input.thingTypeName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingTypeName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingTypeName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingTypeName.");
                }
                body = JSON.stringify(__assign(__assign({}, (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.thingTypeProperties !== undefined &&
                    input.thingTypeProperties !== null && {
                    thingTypeProperties: serializeAws_restJson1ThingTypeProperties(input.thingTypeProperties, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateTopicRuleCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = __assign({ "content-type": "application/json" }, (isSerializableHeaderValue(input.tags) && { "x-amz-tagging": input.tags }));
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/rules/{ruleName}";
                if (input.ruleName !== undefined) {
                    labelValue = input.ruleName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ruleName.");
                    }
                    resolvedPath = resolvedPath.replace("{ruleName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ruleName.");
                }
                if (input.topicRulePayload !== undefined) {
                    body = serializeAws_restJson1TopicRulePayload(input.topicRulePayload, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1CreateTopicRuleDestinationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/destinations";
                body = JSON.stringify(__assign({}, (input.destinationConfiguration !== undefined &&
                    input.destinationConfiguration !== null && {
                    destinationConfiguration: serializeAws_restJson1TopicRuleDestinationConfiguration(input.destinationConfiguration, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteAccountAuditConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/configuration";
                query = __assign({}, (input.deleteScheduledAudits !== undefined && { deleteScheduledAudits: input.deleteScheduledAudits.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteAuditSuppressionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/suppressions/delete";
                body = JSON.stringify(__assign(__assign({}, (input.checkName !== undefined && input.checkName !== null && { checkName: input.checkName })), (input.resourceIdentifier !== undefined &&
                    input.resourceIdentifier !== null && {
                    resourceIdentifier: serializeAws_restJson1ResourceIdentifier(input.resourceIdentifier, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteAuthorizerCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/authorizer/{authorizerName}";
                if (input.authorizerName !== undefined) {
                    labelValue = input.authorizerName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: authorizerName.");
                    }
                    resolvedPath = resolvedPath.replace("{authorizerName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: authorizerName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteBillingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/billing-groups/{billingGroupName}";
                if (input.billingGroupName !== undefined) {
                    labelValue = input.billingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: billingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{billingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: billingGroupName.");
                }
                query = __assign({}, (input.expectedVersion !== undefined && { expectedVersion: input.expectedVersion.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteCACertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/cacertificate/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteCertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificates/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                query = __assign({}, (input.forceDelete !== undefined && { forceDelete: input.forceDelete.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteCustomMetricCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/custom-metric/{metricName}";
                if (input.metricName !== undefined) {
                    labelValue = input.metricName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: metricName.");
                    }
                    resolvedPath = resolvedPath.replace("{metricName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: metricName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteDimensionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/dimensions/{name}";
                if (input.name !== undefined) {
                    labelValue = input.name;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: name.");
                    }
                    resolvedPath = resolvedPath.replace("{name}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: name.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteDomainConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/domainConfigurations/{domainConfigurationName}";
                if (input.domainConfigurationName !== undefined) {
                    labelValue = input.domainConfigurationName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: domainConfigurationName.");
                    }
                    resolvedPath = resolvedPath.replace("{domainConfigurationName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: domainConfigurationName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteDynamicThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/dynamic-thing-groups/{thingGroupName}";
                if (input.thingGroupName !== undefined) {
                    labelValue = input.thingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingGroupName.");
                }
                query = __assign({}, (input.expectedVersion !== undefined && { expectedVersion: input.expectedVersion.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteFleetMetricCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/fleet-metric/{metricName}";
                if (input.metricName !== undefined) {
                    labelValue = input.metricName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: metricName.");
                    }
                    resolvedPath = resolvedPath.replace("{metricName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: metricName.");
                }
                query = __assign({}, (input.expectedVersion !== undefined && { expectedVersion: input.expectedVersion.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs/{jobId}";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                query = __assign(__assign({}, (input.force !== undefined && { force: input.force.toString() })), (input.namespaceId !== undefined && { namespaceId: input.namespaceId }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteJobExecutionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/things/{thingName}/jobs/{jobId}/executionNumber/{executionNumber}";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                if (input.executionNumber !== undefined) {
                    labelValue = input.executionNumber.toString();
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: executionNumber.");
                    }
                    resolvedPath = resolvedPath.replace("{executionNumber}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: executionNumber.");
                }
                query = __assign(__assign({}, (input.force !== undefined && { force: input.force.toString() })), (input.namespaceId !== undefined && { namespaceId: input.namespaceId }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteJobTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/job-templates/{jobTemplateId}";
                if (input.jobTemplateId !== undefined) {
                    labelValue = input.jobTemplateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobTemplateId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobTemplateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobTemplateId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteMitigationActionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/mitigationactions/actions/{actionName}";
                if (input.actionName !== undefined) {
                    labelValue = input.actionName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: actionName.");
                    }
                    resolvedPath = resolvedPath.replace("{actionName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: actionName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteOTAUpdateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/otaUpdates/{otaUpdateId}";
                if (input.otaUpdateId !== undefined) {
                    labelValue = input.otaUpdateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: otaUpdateId.");
                    }
                    resolvedPath = resolvedPath.replace("{otaUpdateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: otaUpdateId.");
                }
                query = __assign(__assign({}, (input.deleteStream !== undefined && { deleteStream: input.deleteStream.toString() })), (input.forceDeleteAWSJob !== undefined && { forceDeleteAWSJob: input.forceDeleteAWSJob.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeletePolicyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/policies/{policyName}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeletePolicyVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/policies/{policyName}/version/{policyVersionId}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                if (input.policyVersionId !== undefined) {
                    labelValue = input.policyVersionId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyVersionId.");
                    }
                    resolvedPath = resolvedPath.replace("{policyVersionId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyVersionId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteProvisioningTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/provisioning-templates/{templateName}";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteProvisioningTemplateVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/provisioning-templates/{templateName}/versions/{versionId}";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                if (input.versionId !== undefined) {
                    labelValue = input.versionId.toString();
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: versionId.");
                    }
                    resolvedPath = resolvedPath.replace("{versionId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: versionId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteRegistrationCodeCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/registrationcode";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteRoleAliasCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/role-aliases/{roleAlias}";
                if (input.roleAlias !== undefined) {
                    labelValue = input.roleAlias;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: roleAlias.");
                    }
                    resolvedPath = resolvedPath.replace("{roleAlias}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: roleAlias.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteScheduledAuditCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/audit/scheduledaudits/{scheduledAuditName}";
                if (input.scheduledAuditName !== undefined) {
                    labelValue = input.scheduledAuditName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: scheduledAuditName.");
                    }
                    resolvedPath = resolvedPath.replace("{scheduledAuditName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: scheduledAuditName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteSecurityProfileCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/security-profiles/{securityProfileName}";
                if (input.securityProfileName !== undefined) {
                    labelValue = input.securityProfileName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: securityProfileName.");
                    }
                    resolvedPath = resolvedPath.replace("{securityProfileName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: securityProfileName.");
                }
                query = __assign({}, (input.expectedVersion !== undefined && { expectedVersion: input.expectedVersion.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteStreamCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/streams/{streamId}";
                if (input.streamId !== undefined) {
                    labelValue = input.streamId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: streamId.");
                    }
                    resolvedPath = resolvedPath.replace("{streamId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: streamId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteThingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                query = __assign({}, (input.expectedVersion !== undefined && { expectedVersion: input.expectedVersion.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups/{thingGroupName}";
                if (input.thingGroupName !== undefined) {
                    labelValue = input.thingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingGroupName.");
                }
                query = __assign({}, (input.expectedVersion !== undefined && { expectedVersion: input.expectedVersion.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteThingTypeCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-types/{thingTypeName}";
                if (input.thingTypeName !== undefined) {
                    labelValue = input.thingTypeName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingTypeName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingTypeName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingTypeName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteTopicRuleCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/rules/{ruleName}";
                if (input.ruleName !== undefined) {
                    labelValue = input.ruleName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ruleName.");
                    }
                    resolvedPath = resolvedPath.replace("{ruleName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ruleName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteTopicRuleDestinationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/destinations/{arn+}";
                if (input.arn !== undefined) {
                    labelValue = input.arn;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: arn.");
                    }
                    resolvedPath = resolvedPath.replace("{arn+}", labelValue
                        .split("/")
                        .map(function (segment) { return __extendedEncodeURIComponent(segment); })
                        .join("/"));
                }
                else {
                    throw new Error("No value provided for input HTTP label: arn.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeleteV2LoggingLevelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/v2LoggingLevel";
                query = __assign(__assign({}, (input.targetType !== undefined && { targetType: input.targetType })), (input.targetName !== undefined && { targetName: input.targetName }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DeprecateThingTypeCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-types/{thingTypeName}/deprecate";
                if (input.thingTypeName !== undefined) {
                    labelValue = input.thingTypeName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingTypeName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingTypeName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingTypeName.");
                }
                body = JSON.stringify(__assign({}, (input.undoDeprecate !== undefined && input.undoDeprecate !== null && { undoDeprecate: input.undoDeprecate })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeAccountAuditConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/configuration";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeAuditFindingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/findings/{findingId}";
                if (input.findingId !== undefined) {
                    labelValue = input.findingId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: findingId.");
                    }
                    resolvedPath = resolvedPath.replace("{findingId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: findingId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeAuditMitigationActionsTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/mitigationactions/tasks/{taskId}";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeAuditSuppressionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/suppressions/describe";
                body = JSON.stringify(__assign(__assign({}, (input.checkName !== undefined && input.checkName !== null && { checkName: input.checkName })), (input.resourceIdentifier !== undefined &&
                    input.resourceIdentifier !== null && {
                    resourceIdentifier: serializeAws_restJson1ResourceIdentifier(input.resourceIdentifier, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeAuditTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/tasks/{taskId}";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeAuthorizerCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/authorizer/{authorizerName}";
                if (input.authorizerName !== undefined) {
                    labelValue = input.authorizerName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: authorizerName.");
                    }
                    resolvedPath = resolvedPath.replace("{authorizerName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: authorizerName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeBillingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/billing-groups/{billingGroupName}";
                if (input.billingGroupName !== undefined) {
                    labelValue = input.billingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: billingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{billingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: billingGroupName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeCACertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/cacertificate/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeCertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificates/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeCustomMetricCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/custom-metric/{metricName}";
                if (input.metricName !== undefined) {
                    labelValue = input.metricName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: metricName.");
                    }
                    resolvedPath = resolvedPath.replace("{metricName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: metricName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeDefaultAuthorizerCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/default-authorizer";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeDetectMitigationActionsTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/detect/mitigationactions/tasks/{taskId}";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeDimensionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/dimensions/{name}";
                if (input.name !== undefined) {
                    labelValue = input.name;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: name.");
                    }
                    resolvedPath = resolvedPath.replace("{name}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: name.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeDomainConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/domainConfigurations/{domainConfigurationName}";
                if (input.domainConfigurationName !== undefined) {
                    labelValue = input.domainConfigurationName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: domainConfigurationName.");
                    }
                    resolvedPath = resolvedPath.replace("{domainConfigurationName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: domainConfigurationName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeEndpointCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/endpoint";
                query = __assign({}, (input.endpointType !== undefined && { endpointType: input.endpointType }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeEventConfigurationsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/event-configurations";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeFleetMetricCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/fleet-metric/{metricName}";
                if (input.metricName !== undefined) {
                    labelValue = input.metricName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: metricName.");
                    }
                    resolvedPath = resolvedPath.replace("{metricName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: metricName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeIndexCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indices/{indexName}";
                if (input.indexName !== undefined) {
                    labelValue = input.indexName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: indexName.");
                    }
                    resolvedPath = resolvedPath.replace("{indexName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: indexName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs/{jobId}";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeJobExecutionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}/jobs/{jobId}";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                query = __assign({}, (input.executionNumber !== undefined && { executionNumber: input.executionNumber.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeJobTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/job-templates/{jobTemplateId}";
                if (input.jobTemplateId !== undefined) {
                    labelValue = input.jobTemplateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobTemplateId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobTemplateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobTemplateId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeManagedJobTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/managed-job-templates/{templateName}";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                query = __assign({}, (input.templateVersion !== undefined && { templateVersion: input.templateVersion }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeMitigationActionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/mitigationactions/actions/{actionName}";
                if (input.actionName !== undefined) {
                    labelValue = input.actionName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: actionName.");
                    }
                    resolvedPath = resolvedPath.replace("{actionName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: actionName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeProvisioningTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/provisioning-templates/{templateName}";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeProvisioningTemplateVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/provisioning-templates/{templateName}/versions/{versionId}";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                if (input.versionId !== undefined) {
                    labelValue = input.versionId.toString();
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: versionId.");
                    }
                    resolvedPath = resolvedPath.replace("{versionId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: versionId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeRoleAliasCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/role-aliases/{roleAlias}";
                if (input.roleAlias !== undefined) {
                    labelValue = input.roleAlias;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: roleAlias.");
                    }
                    resolvedPath = resolvedPath.replace("{roleAlias}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: roleAlias.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeScheduledAuditCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/audit/scheduledaudits/{scheduledAuditName}";
                if (input.scheduledAuditName !== undefined) {
                    labelValue = input.scheduledAuditName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: scheduledAuditName.");
                    }
                    resolvedPath = resolvedPath.replace("{scheduledAuditName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: scheduledAuditName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeSecurityProfileCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/security-profiles/{securityProfileName}";
                if (input.securityProfileName !== undefined) {
                    labelValue = input.securityProfileName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: securityProfileName.");
                    }
                    resolvedPath = resolvedPath.replace("{securityProfileName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: securityProfileName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeStreamCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/streams/{streamId}";
                if (input.streamId !== undefined) {
                    labelValue = input.streamId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: streamId.");
                    }
                    resolvedPath = resolvedPath.replace("{streamId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: streamId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeThingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups/{thingGroupName}";
                if (input.thingGroupName !== undefined) {
                    labelValue = input.thingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingGroupName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeThingRegistrationTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-registration-tasks/{taskId}";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DescribeThingTypeCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-types/{thingTypeName}";
                if (input.thingTypeName !== undefined) {
                    labelValue = input.thingTypeName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingTypeName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingTypeName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingTypeName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DetachPolicyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/target-policies/{policyName}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                body = JSON.stringify(__assign({}, (input.target !== undefined && input.target !== null && { target: input.target })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DetachPrincipalPolicyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = __assign({}, (isSerializableHeaderValue(input.principal) && { "x-amzn-iot-principal": input.principal }));
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/principal-policies/{policyName}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DetachSecurityProfileCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/security-profiles/{securityProfileName}/targets";
                if (input.securityProfileName !== undefined) {
                    labelValue = input.securityProfileName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: securityProfileName.");
                    }
                    resolvedPath = resolvedPath.replace("{securityProfileName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: securityProfileName.");
                }
                query = __assign({}, (input.securityProfileTargetArn !== undefined && { securityProfileTargetArn: input.securityProfileTargetArn }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DetachThingPrincipalCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = __assign({}, (isSerializableHeaderValue(input.principal) && { "x-amzn-principal": input.principal }));
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}/principals";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1DisableTopicRuleCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/rules/{ruleName}/disable";
                if (input.ruleName !== undefined) {
                    labelValue = input.ruleName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ruleName.");
                    }
                    resolvedPath = resolvedPath.replace("{ruleName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ruleName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1EnableTopicRuleCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/rules/{ruleName}/enable";
                if (input.ruleName !== undefined) {
                    labelValue = input.ruleName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ruleName.");
                    }
                    resolvedPath = resolvedPath.replace("{ruleName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ruleName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetBehaviorModelTrainingSummariesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/behavior-model-training/summaries";
                query = __assign(__assign(__assign({}, (input.securityProfileName !== undefined && { securityProfileName: input.securityProfileName })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetBucketsAggregationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indices/buckets";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.aggregationField !== undefined &&
                    input.aggregationField !== null && { aggregationField: input.aggregationField })), (input.bucketsAggregationType !== undefined &&
                    input.bucketsAggregationType !== null && {
                    bucketsAggregationType: serializeAws_restJson1BucketsAggregationType(input.bucketsAggregationType, context),
                })), (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetCardinalityCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indices/cardinality";
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.aggregationField !== undefined &&
                    input.aggregationField !== null && { aggregationField: input.aggregationField })), (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetEffectivePoliciesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/effective-policies";
                query = __assign({}, (input.thingName !== undefined && { thingName: input.thingName }));
                body = JSON.stringify(__assign(__assign({}, (input.cognitoIdentityPoolId !== undefined &&
                    input.cognitoIdentityPoolId !== null && { cognitoIdentityPoolId: input.cognitoIdentityPoolId })), (input.principal !== undefined && input.principal !== null && { principal: input.principal })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetIndexingConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indexing/config";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetJobDocumentCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs/{jobId}/job-document";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetLoggingOptionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/loggingOptions";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetOTAUpdateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/otaUpdates/{otaUpdateId}";
                if (input.otaUpdateId !== undefined) {
                    labelValue = input.otaUpdateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: otaUpdateId.");
                    }
                    resolvedPath = resolvedPath.replace("{otaUpdateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: otaUpdateId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetPercentilesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indices/percentiles";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.aggregationField !== undefined &&
                    input.aggregationField !== null && { aggregationField: input.aggregationField })), (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.percents !== undefined &&
                    input.percents !== null && { percents: serializeAws_restJson1PercentList(input.percents, context) })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetPolicyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/policies/{policyName}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetPolicyVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/policies/{policyName}/version/{policyVersionId}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                if (input.policyVersionId !== undefined) {
                    labelValue = input.policyVersionId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyVersionId.");
                    }
                    resolvedPath = resolvedPath.replace("{policyVersionId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyVersionId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetRegistrationCodeCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/registrationcode";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetStatisticsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indices/statistics";
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.aggregationField !== undefined &&
                    input.aggregationField !== null && { aggregationField: input.aggregationField })), (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetTopicRuleCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/rules/{ruleName}";
                if (input.ruleName !== undefined) {
                    labelValue = input.ruleName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ruleName.");
                    }
                    resolvedPath = resolvedPath.replace("{ruleName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ruleName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetTopicRuleDestinationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/destinations/{arn+}";
                if (input.arn !== undefined) {
                    labelValue = input.arn;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: arn.");
                    }
                    resolvedPath = resolvedPath.replace("{arn+}", labelValue
                        .split("/")
                        .map(function (segment) { return __extendedEncodeURIComponent(segment); })
                        .join("/"));
                }
                else {
                    throw new Error("No value provided for input HTTP label: arn.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1GetV2LoggingOptionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/v2LoggingOptions";
                body = "";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListActiveViolationsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/active-violations";
                query = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.thingName !== undefined && { thingName: input.thingName })), (input.securityProfileName !== undefined && { securityProfileName: input.securityProfileName })), (input.behaviorCriteriaType !== undefined && { behaviorCriteriaType: input.behaviorCriteriaType })), (input.listSuppressedAlerts !== undefined && { listSuppressedAlerts: input.listSuppressedAlerts.toString() })), (input.verificationState !== undefined && { verificationState: input.verificationState })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListAttachedPoliciesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/attached-policies/{target}";
                if (input.target !== undefined) {
                    labelValue = input.target;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: target.");
                    }
                    resolvedPath = resolvedPath.replace("{target}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: target.");
                }
                query = __assign(__assign(__assign({}, (input.recursive !== undefined && { recursive: input.recursive.toString() })), (input.marker !== undefined && { marker: input.marker })), (input.pageSize !== undefined && { pageSize: input.pageSize.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListAuditFindingsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/findings";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.checkName !== undefined && input.checkName !== null && { checkName: input.checkName })), (input.endTime !== undefined &&
                    input.endTime !== null && { endTime: Math.round(input.endTime.getTime() / 1000) })), (input.listSuppressedFindings !== undefined &&
                    input.listSuppressedFindings !== null && { listSuppressedFindings: input.listSuppressedFindings })), (input.maxResults !== undefined && input.maxResults !== null && { maxResults: input.maxResults })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.resourceIdentifier !== undefined &&
                    input.resourceIdentifier !== null && {
                    resourceIdentifier: serializeAws_restJson1ResourceIdentifier(input.resourceIdentifier, context),
                })), (input.startTime !== undefined &&
                    input.startTime !== null && { startTime: Math.round(input.startTime.getTime() / 1000) })), (input.taskId !== undefined && input.taskId !== null && { taskId: input.taskId })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListAuditMitigationActionsExecutionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/mitigationactions/executions";
                query = __assign(__assign(__assign(__assign(__assign({}, (input.taskId !== undefined && { taskId: input.taskId })), (input.actionStatus !== undefined && { actionStatus: input.actionStatus })), (input.findingId !== undefined && { findingId: input.findingId })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListAuditMitigationActionsTasksCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/mitigationactions/tasks";
                query = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.auditTaskId !== undefined && { auditTaskId: input.auditTaskId })), (input.findingId !== undefined && { findingId: input.findingId })), (input.taskStatus !== undefined && { taskStatus: input.taskStatus })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.startTime !== undefined && { startTime: (input.startTime.toISOString().split(".")[0] + "Z").toString() })), (input.endTime !== undefined && { endTime: (input.endTime.toISOString().split(".")[0] + "Z").toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListAuditSuppressionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/suppressions/list";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.ascendingOrder !== undefined &&
                    input.ascendingOrder !== null && { ascendingOrder: input.ascendingOrder })), (input.checkName !== undefined && input.checkName !== null && { checkName: input.checkName })), (input.maxResults !== undefined && input.maxResults !== null && { maxResults: input.maxResults })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.resourceIdentifier !== undefined &&
                    input.resourceIdentifier !== null && {
                    resourceIdentifier: serializeAws_restJson1ResourceIdentifier(input.resourceIdentifier, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListAuditTasksCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/tasks";
                query = __assign(__assign(__assign(__assign(__assign(__assign({}, (input.startTime !== undefined && { startTime: (input.startTime.toISOString().split(".")[0] + "Z").toString() })), (input.endTime !== undefined && { endTime: (input.endTime.toISOString().split(".")[0] + "Z").toString() })), (input.taskType !== undefined && { taskType: input.taskType })), (input.taskStatus !== undefined && { taskStatus: input.taskStatus })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListAuthorizersCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/authorizers";
                query = __assign(__assign(__assign(__assign({}, (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.marker !== undefined && { marker: input.marker })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() })), (input.status !== undefined && { status: input.status }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListBillingGroupsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/billing-groups";
                query = __assign(__assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.namePrefixFilter !== undefined && { namePrefixFilter: input.namePrefixFilter }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListCACertificatesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/cacertificates";
                query = __assign(__assign(__assign({}, (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.marker !== undefined && { marker: input.marker })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListCertificatesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificates";
                query = __assign(__assign(__assign({}, (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.marker !== undefined && { marker: input.marker })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListCertificatesByCACommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificates-by-ca/{caCertificateId}";
                if (input.caCertificateId !== undefined) {
                    labelValue = input.caCertificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: caCertificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{caCertificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: caCertificateId.");
                }
                query = __assign(__assign(__assign({}, (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.marker !== undefined && { marker: input.marker })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListCustomMetricsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/custom-metrics";
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListDetectMitigationActionsExecutionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/detect/mitigationactions/executions";
                query = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.taskId !== undefined && { taskId: input.taskId })), (input.violationId !== undefined && { violationId: input.violationId })), (input.thingName !== undefined && { thingName: input.thingName })), (input.startTime !== undefined && { startTime: (input.startTime.toISOString().split(".")[0] + "Z").toString() })), (input.endTime !== undefined && { endTime: (input.endTime.toISOString().split(".")[0] + "Z").toString() })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListDetectMitigationActionsTasksCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/detect/mitigationactions/tasks";
                query = __assign(__assign(__assign(__assign({}, (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.startTime !== undefined && { startTime: (input.startTime.toISOString().split(".")[0] + "Z").toString() })), (input.endTime !== undefined && { endTime: (input.endTime.toISOString().split(".")[0] + "Z").toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListDimensionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/dimensions";
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListDomainConfigurationsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/domainConfigurations";
                query = __assign(__assign(__assign({}, (input.marker !== undefined && { marker: input.marker })), (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.serviceType !== undefined && { serviceType: input.serviceType }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListFleetMetricsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/fleet-metrics";
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListIndicesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indices";
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListJobExecutionsForJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs/{jobId}/things";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                query = __assign(__assign(__assign({}, (input.status !== undefined && { status: input.status })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListJobExecutionsForThingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}/jobs";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                query = __assign(__assign(__assign(__assign(__assign({}, (input.status !== undefined && { status: input.status })), (input.namespaceId !== undefined && { namespaceId: input.namespaceId })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.jobId !== undefined && { jobId: input.jobId }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListJobsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs";
                query = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.status !== undefined && { status: input.status })), (input.targetSelection !== undefined && { targetSelection: input.targetSelection })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.thingGroupName !== undefined && { thingGroupName: input.thingGroupName })), (input.thingGroupId !== undefined && { thingGroupId: input.thingGroupId })), (input.namespaceId !== undefined && { namespaceId: input.namespaceId }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListJobTemplatesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/job-templates";
                query = __assign(__assign({}, (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListManagedJobTemplatesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/managed-job-templates";
                query = __assign(__assign(__assign({}, (input.templateName !== undefined && { templateName: input.templateName })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListMetricValuesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/metric-values";
                query = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.thingName !== undefined && { thingName: input.thingName })), (input.metricName !== undefined && { metricName: input.metricName })), (input.dimensionName !== undefined && { dimensionName: input.dimensionName })), (input.dimensionValueOperator !== undefined && { dimensionValueOperator: input.dimensionValueOperator })), (input.startTime !== undefined && { startTime: (input.startTime.toISOString().split(".")[0] + "Z").toString() })), (input.endTime !== undefined && { endTime: (input.endTime.toISOString().split(".")[0] + "Z").toString() })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListMitigationActionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/mitigationactions/actions";
                query = __assign(__assign(__assign({}, (input.actionType !== undefined && { actionType: input.actionType })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListOTAUpdatesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/otaUpdates";
                query = __assign(__assign(__assign({}, (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.otaUpdateStatus !== undefined && { otaUpdateStatus: input.otaUpdateStatus }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListOutgoingCertificatesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificates-out-going";
                query = __assign(__assign(__assign({}, (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.marker !== undefined && { marker: input.marker })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListPoliciesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/policies";
                query = __assign(__assign(__assign({}, (input.marker !== undefined && { marker: input.marker })), (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListPolicyPrincipalsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = __assign({}, (isSerializableHeaderValue(input.policyName) && { "x-amzn-iot-policy": input.policyName }));
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/policy-principals";
                query = __assign(__assign(__assign({}, (input.marker !== undefined && { marker: input.marker })), (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListPolicyVersionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/policies/{policyName}/version";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListPrincipalPoliciesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = __assign({}, (isSerializableHeaderValue(input.principal) && { "x-amzn-iot-principal": input.principal }));
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/principal-policies";
                query = __assign(__assign(__assign({}, (input.marker !== undefined && { marker: input.marker })), (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListPrincipalThingsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = __assign({}, (isSerializableHeaderValue(input.principal) && { "x-amzn-principal": input.principal }));
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/principals/things";
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListProvisioningTemplatesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/provisioning-templates";
                query = __assign(__assign({}, (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListProvisioningTemplateVersionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/provisioning-templates/{templateName}/versions";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                query = __assign(__assign({}, (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListRoleAliasesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/role-aliases";
                query = __assign(__assign(__assign({}, (input.pageSize !== undefined && { pageSize: input.pageSize.toString() })), (input.marker !== undefined && { marker: input.marker })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListScheduledAuditsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/scheduledaudits";
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListSecurityProfilesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/security-profiles";
                query = __assign(__assign(__assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.dimensionName !== undefined && { dimensionName: input.dimensionName })), (input.metricName !== undefined && { metricName: input.metricName }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListSecurityProfilesForTargetCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/security-profiles-for-target";
                query = __assign(__assign(__assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.recursive !== undefined && { recursive: input.recursive.toString() })), (input.securityProfileTargetArn !== undefined && { securityProfileTargetArn: input.securityProfileTargetArn }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListStreamsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/streams";
                query = __assign(__assign(__assign({}, (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.ascendingOrder !== undefined && { isAscendingOrder: input.ascendingOrder.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListTagsForResourceCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags";
                query = __assign(__assign({}, (input.resourceArn !== undefined && { resourceArn: input.resourceArn })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListTargetsForPolicyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/policy-targets/{policyName}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                query = __assign(__assign({}, (input.marker !== undefined && { marker: input.marker })), (input.pageSize !== undefined && { pageSize: input.pageSize.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListTargetsForSecurityProfileCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/security-profiles/{securityProfileName}/targets";
                if (input.securityProfileName !== undefined) {
                    labelValue = input.securityProfileName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: securityProfileName.");
                    }
                    resolvedPath = resolvedPath.replace("{securityProfileName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: securityProfileName.");
                }
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingGroupsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups";
                query = __assign(__assign(__assign(__assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.parentGroup !== undefined && { parentGroup: input.parentGroup })), (input.namePrefixFilter !== undefined && { namePrefixFilter: input.namePrefixFilter })), (input.recursive !== undefined && { recursive: input.recursive.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingGroupsForThingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}/thing-groups";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingPrincipalsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}/principals";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingRegistrationTaskReportsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/thing-registration-tasks/{taskId}/reports";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                query = __assign(__assign(__assign({}, (input.reportType !== undefined && { reportType: input.reportType })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingRegistrationTasksCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-registration-tasks";
                query = __assign(__assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.status !== undefined && { status: input.status }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things";
                query = __assign(__assign(__assign(__assign(__assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.attributeName !== undefined && { attributeName: input.attributeName })), (input.attributeValue !== undefined && { attributeValue: input.attributeValue })), (input.thingTypeName !== undefined && { thingTypeName: input.thingTypeName })), (input.usePrefixAttributeValue !== undefined && {
                    usePrefixAttributeValue: input.usePrefixAttributeValue.toString(),
                }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingsInBillingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/billing-groups/{billingGroupName}/things";
                if (input.billingGroupName !== undefined) {
                    labelValue = input.billingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: billingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{billingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: billingGroupName.");
                }
                query = __assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingsInThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups/{thingGroupName}/things";
                if (input.thingGroupName !== undefined) {
                    labelValue = input.thingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingGroupName.");
                }
                query = __assign(__assign(__assign({}, (input.recursive !== undefined && { recursive: input.recursive.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListThingTypesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-types";
                query = __assign(__assign(__assign({}, (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.thingTypeName !== undefined && { thingTypeName: input.thingTypeName }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListTopicRuleDestinationsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/destinations";
                query = __assign(__assign({}, (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListTopicRulesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/rules";
                query = __assign(__assign(__assign(__assign({}, (input.topic !== undefined && { topic: input.topic })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.ruleDisabled !== undefined && { ruleDisabled: input.ruleDisabled.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListV2LoggingLevelsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/v2LoggingLevel";
                query = __assign(__assign(__assign({}, (input.targetType !== undefined && { targetType: input.targetType })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ListViolationEventsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/violation-events";
                query = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.startTime !== undefined && { startTime: (input.startTime.toISOString().split(".")[0] + "Z").toString() })), (input.endTime !== undefined && { endTime: (input.endTime.toISOString().split(".")[0] + "Z").toString() })), (input.thingName !== undefined && { thingName: input.thingName })), (input.securityProfileName !== undefined && { securityProfileName: input.securityProfileName })), (input.behaviorCriteriaType !== undefined && { behaviorCriteriaType: input.behaviorCriteriaType })), (input.listSuppressedAlerts !== undefined && { listSuppressedAlerts: input.listSuppressedAlerts.toString() })), (input.verificationState !== undefined && { verificationState: input.verificationState })), (input.nextToken !== undefined && { nextToken: input.nextToken })), (input.maxResults !== undefined && { maxResults: input.maxResults.toString() }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1PutVerificationStateOnViolationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/violations/verification-state/{violationId}";
                if (input.violationId !== undefined) {
                    labelValue = input.violationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: violationId.");
                    }
                    resolvedPath = resolvedPath.replace("{violationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: violationId.");
                }
                body = JSON.stringify(__assign(__assign({}, (input.verificationState !== undefined &&
                    input.verificationState !== null && { verificationState: input.verificationState })), (input.verificationStateDescription !== undefined &&
                    input.verificationStateDescription !== null && {
                    verificationStateDescription: input.verificationStateDescription,
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1RegisterCACertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/cacertificate";
                query = __assign(__assign({}, (input.setAsActive !== undefined && { setAsActive: input.setAsActive.toString() })), (input.allowAutoRegistration !== undefined && { allowAutoRegistration: input.allowAutoRegistration.toString() }));
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.caCertificate !== undefined && input.caCertificate !== null && { caCertificate: input.caCertificate })), (input.registrationConfig !== undefined &&
                    input.registrationConfig !== null && {
                    registrationConfig: serializeAws_restJson1RegistrationConfig(input.registrationConfig, context),
                })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })), (input.verificationCertificate !== undefined &&
                    input.verificationCertificate !== null && { verificationCertificate: input.verificationCertificate })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1RegisterCertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificate/register";
                query = __assign({}, (input.setAsActive !== undefined && { setAsActive: input.setAsActive.toString() }));
                body = JSON.stringify(__assign(__assign(__assign({}, (input.caCertificatePem !== undefined &&
                    input.caCertificatePem !== null && { caCertificatePem: input.caCertificatePem })), (input.certificatePem !== undefined &&
                    input.certificatePem !== null && { certificatePem: input.certificatePem })), (input.status !== undefined && input.status !== null && { status: input.status })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1RegisterCertificateWithoutCACommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificate/register-no-ca";
                body = JSON.stringify(__assign(__assign({}, (input.certificatePem !== undefined &&
                    input.certificatePem !== null && { certificatePem: input.certificatePem })), (input.status !== undefined && input.status !== null && { status: input.status })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1RegisterThingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things";
                body = JSON.stringify(__assign(__assign({}, (input.parameters !== undefined &&
                    input.parameters !== null && { parameters: serializeAws_restJson1Parameters(input.parameters, context) })), (input.templateBody !== undefined && input.templateBody !== null && { templateBody: input.templateBody })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1RejectCertificateTransferCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/reject-certificate-transfer/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                body = JSON.stringify(__assign({}, (input.rejectReason !== undefined && input.rejectReason !== null && { rejectReason: input.rejectReason })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1RemoveThingFromBillingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/billing-groups/removeThingFromBillingGroup";
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.billingGroupArn !== undefined &&
                    input.billingGroupArn !== null && { billingGroupArn: input.billingGroupArn })), (input.billingGroupName !== undefined &&
                    input.billingGroupName !== null && { billingGroupName: input.billingGroupName })), (input.thingArn !== undefined && input.thingArn !== null && { thingArn: input.thingArn })), (input.thingName !== undefined && input.thingName !== null && { thingName: input.thingName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1RemoveThingFromThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups/removeThingFromThingGroup";
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.thingArn !== undefined && input.thingArn !== null && { thingArn: input.thingArn })), (input.thingGroupArn !== undefined && input.thingGroupArn !== null && { thingGroupArn: input.thingGroupArn })), (input.thingGroupName !== undefined &&
                    input.thingGroupName !== null && { thingGroupName: input.thingGroupName })), (input.thingName !== undefined && input.thingName !== null && { thingName: input.thingName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ReplaceTopicRuleCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/rules/{ruleName}";
                if (input.ruleName !== undefined) {
                    labelValue = input.ruleName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ruleName.");
                    }
                    resolvedPath = resolvedPath.replace("{ruleName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ruleName.");
                }
                if (input.topicRulePayload !== undefined) {
                    body = serializeAws_restJson1TopicRulePayload(input.topicRulePayload, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1SearchIndexCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indices/search";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.maxResults !== undefined && input.maxResults !== null && { maxResults: input.maxResults })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1SetDefaultAuthorizerCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/default-authorizer";
                body = JSON.stringify(__assign({}, (input.authorizerName !== undefined &&
                    input.authorizerName !== null && { authorizerName: input.authorizerName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1SetDefaultPolicyVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/policies/{policyName}/version/{policyVersionId}";
                if (input.policyName !== undefined) {
                    labelValue = input.policyName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyName.");
                    }
                    resolvedPath = resolvedPath.replace("{policyName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyName.");
                }
                if (input.policyVersionId !== undefined) {
                    labelValue = input.policyVersionId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: policyVersionId.");
                    }
                    resolvedPath = resolvedPath.replace("{policyVersionId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: policyVersionId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1SetLoggingOptionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/loggingOptions";
                if (input.loggingOptionsPayload !== undefined) {
                    body = serializeAws_restJson1LoggingOptionsPayload(input.loggingOptionsPayload, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1SetV2LoggingLevelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/v2LoggingLevel";
                body = JSON.stringify(__assign(__assign({}, (input.logLevel !== undefined && input.logLevel !== null && { logLevel: input.logLevel })), (input.logTarget !== undefined &&
                    input.logTarget !== null && { logTarget: serializeAws_restJson1LogTarget(input.logTarget, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1SetV2LoggingOptionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/v2LoggingOptions";
                body = JSON.stringify(__assign(__assign(__assign({}, (input.defaultLogLevel !== undefined &&
                    input.defaultLogLevel !== null && { defaultLogLevel: input.defaultLogLevel })), (input.disableAllLogs !== undefined &&
                    input.disableAllLogs !== null && { disableAllLogs: input.disableAllLogs })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1StartAuditMitigationActionsTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _d.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/mitigationactions/tasks/{taskId}";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                body = JSON.stringify(__assign(__assign(__assign({}, (input.auditCheckToActionsMapping !== undefined &&
                    input.auditCheckToActionsMapping !== null && {
                    auditCheckToActionsMapping: serializeAws_restJson1AuditCheckToActionsMapping(input.auditCheckToActionsMapping, context),
                })), { clientRequestToken: (_c = input.clientRequestToken) !== null && _c !== void 0 ? _c : generateIdempotencyToken() }), (input.target !== undefined &&
                    input.target !== null && {
                    target: serializeAws_restJson1AuditMitigationActionsTaskTarget(input.target, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1StartDetectMitigationActionsTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _d.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/detect/mitigationactions/tasks/{taskId}";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.actions !== undefined &&
                    input.actions !== null && {
                    actions: serializeAws_restJson1DetectMitigationActionsToExecuteList(input.actions, context),
                })), { clientRequestToken: (_c = input.clientRequestToken) !== null && _c !== void 0 ? _c : generateIdempotencyToken() }), (input.includeOnlyActiveViolations !== undefined &&
                    input.includeOnlyActiveViolations !== null && { includeOnlyActiveViolations: input.includeOnlyActiveViolations })), (input.includeSuppressedAlerts !== undefined &&
                    input.includeSuppressedAlerts !== null && { includeSuppressedAlerts: input.includeSuppressedAlerts })), (input.target !== undefined &&
                    input.target !== null && {
                    target: serializeAws_restJson1DetectMitigationActionsTaskTarget(input.target, context),
                })), (input.violationEventOccurrenceRange !== undefined &&
                    input.violationEventOccurrenceRange !== null && {
                    violationEventOccurrenceRange: serializeAws_restJson1ViolationEventOccurrenceRange(input.violationEventOccurrenceRange, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1StartOnDemandAuditTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/tasks";
                body = JSON.stringify(__assign({}, (input.targetCheckNames !== undefined &&
                    input.targetCheckNames !== null && {
                    targetCheckNames: serializeAws_restJson1TargetAuditCheckNames(input.targetCheckNames, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1StartThingRegistrationTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-registration-tasks";
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.inputFileBucket !== undefined &&
                    input.inputFileBucket !== null && { inputFileBucket: input.inputFileBucket })), (input.inputFileKey !== undefined && input.inputFileKey !== null && { inputFileKey: input.inputFileKey })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.templateBody !== undefined && input.templateBody !== null && { templateBody: input.templateBody })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1StopThingRegistrationTaskCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-registration-tasks/{taskId}/cancel";
                if (input.taskId !== undefined) {
                    labelValue = input.taskId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: taskId.");
                    }
                    resolvedPath = resolvedPath.replace("{taskId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: taskId.");
                }
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1TagResourceCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags";
                body = JSON.stringify(__assign(__assign({}, (input.resourceArn !== undefined && input.resourceArn !== null && { resourceArn: input.resourceArn })), (input.tags !== undefined &&
                    input.tags !== null && { tags: serializeAws_restJson1TagList(input.tags, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1TestAuthorizationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/test-authorization";
                query = __assign({}, (input.clientId !== undefined && { clientId: input.clientId }));
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.authInfos !== undefined &&
                    input.authInfos !== null && { authInfos: serializeAws_restJson1AuthInfos(input.authInfos, context) })), (input.cognitoIdentityPoolId !== undefined &&
                    input.cognitoIdentityPoolId !== null && { cognitoIdentityPoolId: input.cognitoIdentityPoolId })), (input.policyNamesToAdd !== undefined &&
                    input.policyNamesToAdd !== null && {
                    policyNamesToAdd: serializeAws_restJson1PolicyNames(input.policyNamesToAdd, context),
                })), (input.policyNamesToSkip !== undefined &&
                    input.policyNamesToSkip !== null && {
                    policyNamesToSkip: serializeAws_restJson1PolicyNames(input.policyNamesToSkip, context),
                })), (input.principal !== undefined && input.principal !== null && { principal: input.principal })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1TestInvokeAuthorizerCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/authorizer/{authorizerName}/test";
                if (input.authorizerName !== undefined) {
                    labelValue = input.authorizerName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: authorizerName.");
                    }
                    resolvedPath = resolvedPath.replace("{authorizerName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: authorizerName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.httpContext !== undefined &&
                    input.httpContext !== null && { httpContext: serializeAws_restJson1HttpContext(input.httpContext, context) })), (input.mqttContext !== undefined &&
                    input.mqttContext !== null && { mqttContext: serializeAws_restJson1MqttContext(input.mqttContext, context) })), (input.tlsContext !== undefined &&
                    input.tlsContext !== null && { tlsContext: serializeAws_restJson1TlsContext(input.tlsContext, context) })), (input.token !== undefined && input.token !== null && { token: input.token })), (input.tokenSignature !== undefined &&
                    input.tokenSignature !== null && { tokenSignature: input.tokenSignature })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1TransferCertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/transfer-certificate/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                query = __assign({}, (input.targetAwsAccount !== undefined && { targetAwsAccount: input.targetAwsAccount }));
                body = JSON.stringify(__assign({}, (input.transferMessage !== undefined &&
                    input.transferMessage !== null && { transferMessage: input.transferMessage })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UntagResourceCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/untag";
                body = JSON.stringify(__assign(__assign({}, (input.resourceArn !== undefined && input.resourceArn !== null && { resourceArn: input.resourceArn })), (input.tagKeys !== undefined &&
                    input.tagKeys !== null && { tagKeys: serializeAws_restJson1TagKeyList(input.tagKeys, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateAccountAuditConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/configuration";
                body = JSON.stringify(__assign(__assign(__assign({}, (input.auditCheckConfigurations !== undefined &&
                    input.auditCheckConfigurations !== null && {
                    auditCheckConfigurations: serializeAws_restJson1AuditCheckConfigurations(input.auditCheckConfigurations, context),
                })), (input.auditNotificationTargetConfigurations !== undefined &&
                    input.auditNotificationTargetConfigurations !== null && {
                    auditNotificationTargetConfigurations: serializeAws_restJson1AuditNotificationTargetConfigurations(input.auditNotificationTargetConfigurations, context),
                })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateAuditSuppressionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/audit/suppressions/update";
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.checkName !== undefined && input.checkName !== null && { checkName: input.checkName })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.expirationDate !== undefined &&
                    input.expirationDate !== null && { expirationDate: Math.round(input.expirationDate.getTime() / 1000) })), (input.resourceIdentifier !== undefined &&
                    input.resourceIdentifier !== null && {
                    resourceIdentifier: serializeAws_restJson1ResourceIdentifier(input.resourceIdentifier, context),
                })), (input.suppressIndefinitely !== undefined &&
                    input.suppressIndefinitely !== null && { suppressIndefinitely: input.suppressIndefinitely })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateAuthorizerCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/authorizer/{authorizerName}";
                if (input.authorizerName !== undefined) {
                    labelValue = input.authorizerName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: authorizerName.");
                    }
                    resolvedPath = resolvedPath.replace("{authorizerName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: authorizerName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.authorizerFunctionArn !== undefined &&
                    input.authorizerFunctionArn !== null && { authorizerFunctionArn: input.authorizerFunctionArn })), (input.enableCachingForHttp !== undefined &&
                    input.enableCachingForHttp !== null && { enableCachingForHttp: input.enableCachingForHttp })), (input.status !== undefined && input.status !== null && { status: input.status })), (input.tokenKeyName !== undefined && input.tokenKeyName !== null && { tokenKeyName: input.tokenKeyName })), (input.tokenSigningPublicKeys !== undefined &&
                    input.tokenSigningPublicKeys !== null && {
                    tokenSigningPublicKeys: serializeAws_restJson1PublicKeyMap(input.tokenSigningPublicKeys, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateBillingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/billing-groups/{billingGroupName}";
                if (input.billingGroupName !== undefined) {
                    labelValue = input.billingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: billingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{billingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: billingGroupName.");
                }
                body = JSON.stringify(__assign(__assign({}, (input.billingGroupProperties !== undefined &&
                    input.billingGroupProperties !== null && {
                    billingGroupProperties: serializeAws_restJson1BillingGroupProperties(input.billingGroupProperties, context),
                })), (input.expectedVersion !== undefined &&
                    input.expectedVersion !== null && { expectedVersion: input.expectedVersion })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateCACertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/cacertificate/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                query = __assign(__assign({}, (input.newStatus !== undefined && { newStatus: input.newStatus })), (input.newAutoRegistrationStatus !== undefined && {
                    newAutoRegistrationStatus: input.newAutoRegistrationStatus,
                }));
                body = JSON.stringify(__assign(__assign({}, (input.registrationConfig !== undefined &&
                    input.registrationConfig !== null && {
                    registrationConfig: serializeAws_restJson1RegistrationConfig(input.registrationConfig, context),
                })), (input.removeAutoRegistration !== undefined &&
                    input.removeAutoRegistration !== null && { removeAutoRegistration: input.removeAutoRegistration })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateCertificateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {};
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/certificates/{certificateId}";
                if (input.certificateId !== undefined) {
                    labelValue = input.certificateId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: certificateId.");
                    }
                    resolvedPath = resolvedPath.replace("{certificateId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: certificateId.");
                }
                query = __assign({}, (input.newStatus !== undefined && { newStatus: input.newStatus }));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateCustomMetricCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/custom-metric/{metricName}";
                if (input.metricName !== undefined) {
                    labelValue = input.metricName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: metricName.");
                    }
                    resolvedPath = resolvedPath.replace("{metricName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: metricName.");
                }
                body = JSON.stringify(__assign({}, (input.displayName !== undefined && input.displayName !== null && { displayName: input.displayName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateDimensionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/dimensions/{name}";
                if (input.name !== undefined) {
                    labelValue = input.name;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: name.");
                    }
                    resolvedPath = resolvedPath.replace("{name}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: name.");
                }
                body = JSON.stringify(__assign({}, (input.stringValues !== undefined &&
                    input.stringValues !== null && {
                    stringValues: serializeAws_restJson1DimensionStringValues(input.stringValues, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateDomainConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/domainConfigurations/{domainConfigurationName}";
                if (input.domainConfigurationName !== undefined) {
                    labelValue = input.domainConfigurationName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: domainConfigurationName.");
                    }
                    resolvedPath = resolvedPath.replace("{domainConfigurationName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: domainConfigurationName.");
                }
                body = JSON.stringify(__assign(__assign(__assign({}, (input.authorizerConfig !== undefined &&
                    input.authorizerConfig !== null && {
                    authorizerConfig: serializeAws_restJson1AuthorizerConfig(input.authorizerConfig, context),
                })), (input.domainConfigurationStatus !== undefined &&
                    input.domainConfigurationStatus !== null && { domainConfigurationStatus: input.domainConfigurationStatus })), (input.removeAuthorizerConfig !== undefined &&
                    input.removeAuthorizerConfig !== null && { removeAuthorizerConfig: input.removeAuthorizerConfig })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateDynamicThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/dynamic-thing-groups/{thingGroupName}";
                if (input.thingGroupName !== undefined) {
                    labelValue = input.thingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingGroupName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign({}, (input.expectedVersion !== undefined &&
                    input.expectedVersion !== null && { expectedVersion: input.expectedVersion })), (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })), (input.thingGroupProperties !== undefined &&
                    input.thingGroupProperties !== null && {
                    thingGroupProperties: serializeAws_restJson1ThingGroupProperties(input.thingGroupProperties, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateEventConfigurationsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/event-configurations";
                body = JSON.stringify(__assign({}, (input.eventConfigurations !== undefined &&
                    input.eventConfigurations !== null && {
                    eventConfigurations: serializeAws_restJson1EventConfigurations(input.eventConfigurations, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateFleetMetricCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/fleet-metric/{metricName}";
                if (input.metricName !== undefined) {
                    labelValue = input.metricName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: metricName.");
                    }
                    resolvedPath = resolvedPath.replace("{metricName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: metricName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.aggregationField !== undefined &&
                    input.aggregationField !== null && { aggregationField: input.aggregationField })), (input.aggregationType !== undefined &&
                    input.aggregationType !== null && {
                    aggregationType: serializeAws_restJson1AggregationType(input.aggregationType, context),
                })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.expectedVersion !== undefined &&
                    input.expectedVersion !== null && { expectedVersion: input.expectedVersion })), (input.indexName !== undefined && input.indexName !== null && { indexName: input.indexName })), (input.period !== undefined && input.period !== null && { period: input.period })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.queryVersion !== undefined && input.queryVersion !== null && { queryVersion: input.queryVersion })), (input.unit !== undefined && input.unit !== null && { unit: input.unit })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateIndexingConfigurationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/indexing/config";
                body = JSON.stringify(__assign(__assign({}, (input.thingGroupIndexingConfiguration !== undefined &&
                    input.thingGroupIndexingConfiguration !== null && {
                    thingGroupIndexingConfiguration: serializeAws_restJson1ThingGroupIndexingConfiguration(input.thingGroupIndexingConfiguration, context),
                })), (input.thingIndexingConfiguration !== undefined &&
                    input.thingIndexingConfiguration !== null && {
                    thingIndexingConfiguration: serializeAws_restJson1ThingIndexingConfiguration(input.thingIndexingConfiguration, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/jobs/{jobId}";
                if (input.jobId !== undefined) {
                    labelValue = input.jobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: jobId.");
                    }
                    resolvedPath = resolvedPath.replace("{jobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: jobId.");
                }
                query = __assign({}, (input.namespaceId !== undefined && { namespaceId: input.namespaceId }));
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.abortConfig !== undefined &&
                    input.abortConfig !== null && { abortConfig: serializeAws_restJson1AbortConfig(input.abortConfig, context) })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.jobExecutionsRetryConfig !== undefined &&
                    input.jobExecutionsRetryConfig !== null && {
                    jobExecutionsRetryConfig: serializeAws_restJson1JobExecutionsRetryConfig(input.jobExecutionsRetryConfig, context),
                })), (input.jobExecutionsRolloutConfig !== undefined &&
                    input.jobExecutionsRolloutConfig !== null && {
                    jobExecutionsRolloutConfig: serializeAws_restJson1JobExecutionsRolloutConfig(input.jobExecutionsRolloutConfig, context),
                })), (input.presignedUrlConfig !== undefined &&
                    input.presignedUrlConfig !== null && {
                    presignedUrlConfig: serializeAws_restJson1PresignedUrlConfig(input.presignedUrlConfig, context),
                })), (input.timeoutConfig !== undefined &&
                    input.timeoutConfig !== null && {
                    timeoutConfig: serializeAws_restJson1TimeoutConfig(input.timeoutConfig, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateMitigationActionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/mitigationactions/actions/{actionName}";
                if (input.actionName !== undefined) {
                    labelValue = input.actionName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: actionName.");
                    }
                    resolvedPath = resolvedPath.replace("{actionName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: actionName.");
                }
                body = JSON.stringify(__assign(__assign({}, (input.actionParams !== undefined &&
                    input.actionParams !== null && {
                    actionParams: serializeAws_restJson1MitigationActionParams(input.actionParams, context),
                })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateProvisioningTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/provisioning-templates/{templateName}";
                if (input.templateName !== undefined) {
                    labelValue = input.templateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: templateName.");
                    }
                    resolvedPath = resolvedPath.replace("{templateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: templateName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.defaultVersionId !== undefined &&
                    input.defaultVersionId !== null && { defaultVersionId: input.defaultVersionId })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.enabled !== undefined && input.enabled !== null && { enabled: input.enabled })), (input.preProvisioningHook !== undefined &&
                    input.preProvisioningHook !== null && {
                    preProvisioningHook: serializeAws_restJson1ProvisioningHook(input.preProvisioningHook, context),
                })), (input.provisioningRoleArn !== undefined &&
                    input.provisioningRoleArn !== null && { provisioningRoleArn: input.provisioningRoleArn })), (input.removePreProvisioningHook !== undefined &&
                    input.removePreProvisioningHook !== null && { removePreProvisioningHook: input.removePreProvisioningHook })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateRoleAliasCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/role-aliases/{roleAlias}";
                if (input.roleAlias !== undefined) {
                    labelValue = input.roleAlias;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: roleAlias.");
                    }
                    resolvedPath = resolvedPath.replace("{roleAlias}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: roleAlias.");
                }
                body = JSON.stringify(__assign(__assign({}, (input.credentialDurationSeconds !== undefined &&
                    input.credentialDurationSeconds !== null && { credentialDurationSeconds: input.credentialDurationSeconds })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateScheduledAuditCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") +
                    "/audit/scheduledaudits/{scheduledAuditName}";
                if (input.scheduledAuditName !== undefined) {
                    labelValue = input.scheduledAuditName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: scheduledAuditName.");
                    }
                    resolvedPath = resolvedPath.replace("{scheduledAuditName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: scheduledAuditName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.dayOfMonth !== undefined && input.dayOfMonth !== null && { dayOfMonth: input.dayOfMonth })), (input.dayOfWeek !== undefined && input.dayOfWeek !== null && { dayOfWeek: input.dayOfWeek })), (input.frequency !== undefined && input.frequency !== null && { frequency: input.frequency })), (input.targetCheckNames !== undefined &&
                    input.targetCheckNames !== null && {
                    targetCheckNames: serializeAws_restJson1TargetAuditCheckNames(input.targetCheckNames, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateSecurityProfileCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/security-profiles/{securityProfileName}";
                if (input.securityProfileName !== undefined) {
                    labelValue = input.securityProfileName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: securityProfileName.");
                    }
                    resolvedPath = resolvedPath.replace("{securityProfileName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: securityProfileName.");
                }
                query = __assign({}, (input.expectedVersion !== undefined && { expectedVersion: input.expectedVersion.toString() }));
                body = JSON.stringify(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.additionalMetricsToRetain !== undefined &&
                    input.additionalMetricsToRetain !== null && {
                    additionalMetricsToRetain: serializeAws_restJson1AdditionalMetricsToRetainList(input.additionalMetricsToRetain, context),
                })), (input.additionalMetricsToRetainV2 !== undefined &&
                    input.additionalMetricsToRetainV2 !== null && {
                    additionalMetricsToRetainV2: serializeAws_restJson1AdditionalMetricsToRetainV2List(input.additionalMetricsToRetainV2, context),
                })), (input.alertTargets !== undefined &&
                    input.alertTargets !== null && { alertTargets: serializeAws_restJson1AlertTargets(input.alertTargets, context) })), (input.behaviors !== undefined &&
                    input.behaviors !== null && { behaviors: serializeAws_restJson1Behaviors(input.behaviors, context) })), (input.deleteAdditionalMetricsToRetain !== undefined &&
                    input.deleteAdditionalMetricsToRetain !== null && {
                    deleteAdditionalMetricsToRetain: input.deleteAdditionalMetricsToRetain,
                })), (input.deleteAlertTargets !== undefined &&
                    input.deleteAlertTargets !== null && { deleteAlertTargets: input.deleteAlertTargets })), (input.deleteBehaviors !== undefined &&
                    input.deleteBehaviors !== null && { deleteBehaviors: input.deleteBehaviors })), (input.securityProfileDescription !== undefined &&
                    input.securityProfileDescription !== null && { securityProfileDescription: input.securityProfileDescription })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateStreamCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/streams/{streamId}";
                if (input.streamId !== undefined) {
                    labelValue = input.streamId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: streamId.");
                    }
                    resolvedPath = resolvedPath.replace("{streamId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: streamId.");
                }
                body = JSON.stringify(__assign(__assign(__assign({}, (input.description !== undefined && input.description !== null && { description: input.description })), (input.files !== undefined &&
                    input.files !== null && { files: serializeAws_restJson1StreamFiles(input.files, context) })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateThingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/things/{thingName}";
                if (input.thingName !== undefined) {
                    labelValue = input.thingName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingName.");
                }
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.attributePayload !== undefined &&
                    input.attributePayload !== null && {
                    attributePayload: serializeAws_restJson1AttributePayload(input.attributePayload, context),
                })), (input.expectedVersion !== undefined &&
                    input.expectedVersion !== null && { expectedVersion: input.expectedVersion })), (input.removeThingType !== undefined &&
                    input.removeThingType !== null && { removeThingType: input.removeThingType })), (input.thingTypeName !== undefined && input.thingTypeName !== null && { thingTypeName: input.thingTypeName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateThingGroupCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups/{thingGroupName}";
                if (input.thingGroupName !== undefined) {
                    labelValue = input.thingGroupName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: thingGroupName.");
                    }
                    resolvedPath = resolvedPath.replace("{thingGroupName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: thingGroupName.");
                }
                body = JSON.stringify(__assign(__assign({}, (input.expectedVersion !== undefined &&
                    input.expectedVersion !== null && { expectedVersion: input.expectedVersion })), (input.thingGroupProperties !== undefined &&
                    input.thingGroupProperties !== null && {
                    thingGroupProperties: serializeAws_restJson1ThingGroupProperties(input.thingGroupProperties, context),
                })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateThingGroupsForThingCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/thing-groups/updateThingGroupsForThing";
                body = JSON.stringify(__assign(__assign(__assign(__assign({}, (input.overrideDynamicGroups !== undefined &&
                    input.overrideDynamicGroups !== null && { overrideDynamicGroups: input.overrideDynamicGroups })), (input.thingGroupsToAdd !== undefined &&
                    input.thingGroupsToAdd !== null && {
                    thingGroupsToAdd: serializeAws_restJson1ThingGroupList(input.thingGroupsToAdd, context),
                })), (input.thingGroupsToRemove !== undefined &&
                    input.thingGroupsToRemove !== null && {
                    thingGroupsToRemove: serializeAws_restJson1ThingGroupList(input.thingGroupsToRemove, context),
                })), (input.thingName !== undefined && input.thingName !== null && { thingName: input.thingName })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1UpdateTopicRuleDestinationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/destinations";
                body = JSON.stringify(__assign(__assign({}, (input.arn !== undefined && input.arn !== null && { arn: input.arn })), (input.status !== undefined && input.status !== null && { status: input.status })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PATCH",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1ValidateSecurityProfileBehaviorsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    "content-type": "application/json",
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/security-profile-behaviors/validate";
                body = JSON.stringify(__assign({}, (input.behaviors !== undefined &&
                    input.behaviors !== null && { behaviors: serializeAws_restJson1Behaviors(input.behaviors, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var deserializeAws_restJson1AcceptCertificateTransferCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1AcceptCertificateTransferCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1AcceptCertificateTransferCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "TransferAlreadyCompletedException": return [3, 12];
                    case "com.amazonaws.iot#TransferAlreadyCompletedException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1TransferAlreadyCompletedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1AddThingToBillingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1AddThingToBillingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1AddThingToBillingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1AddThingToThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1AddThingToThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1AddThingToThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1AssociateTargetsWithJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1AssociateTargetsWithJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    description: undefined,
                    jobArn: undefined,
                    jobId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.jobArn !== undefined && data.jobArn !== null) {
                    contents.jobArn = __expectString(data.jobArn);
                }
                if (data.jobId !== undefined && data.jobId !== null) {
                    contents.jobId = __expectString(data.jobId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1AssociateTargetsWithJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "LimitExceededException": return [3, 4];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1AttachPolicyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1AttachPolicyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1AttachPolicyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1AttachPrincipalPolicyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1AttachPrincipalPolicyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1AttachPrincipalPolicyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1AttachSecurityProfileCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1AttachSecurityProfileCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1AttachSecurityProfileCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "VersionConflictException": return [3, 12];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1AttachThingPrincipalCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1AttachThingPrincipalCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1AttachThingPrincipalCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CancelAuditMitigationActionsTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CancelAuditMitigationActionsTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CancelAuditMitigationActionsTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CancelAuditTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CancelAuditTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CancelAuditTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CancelCertificateTransferCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CancelCertificateTransferCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CancelCertificateTransferCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "TransferAlreadyCompletedException": return [3, 12];
                    case "com.amazonaws.iot#TransferAlreadyCompletedException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1TransferAlreadyCompletedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CancelDetectMitigationActionsTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CancelDetectMitigationActionsTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CancelDetectMitigationActionsTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CancelJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CancelJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    description: undefined,
                    jobArn: undefined,
                    jobId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.jobArn !== undefined && data.jobArn !== null) {
                    contents.jobArn = __expectString(data.jobArn);
                }
                if (data.jobId !== undefined && data.jobId !== null) {
                    contents.jobId = __expectString(data.jobId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CancelJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "LimitExceededException": return [3, 4];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CancelJobExecutionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CancelJobExecutionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CancelJobExecutionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "InvalidStateTransitionException": return [3, 4];
                    case "com.amazonaws.iot#InvalidStateTransitionException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "VersionConflictException": return [3, 12];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidStateTransitionExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ClearDefaultAuthorizerCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ClearDefaultAuthorizerCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ClearDefaultAuthorizerCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ConfirmTopicRuleDestinationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ConfirmTopicRuleDestinationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ConfirmTopicRuleDestinationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateAuditSuppressionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateAuditSuppressionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateAuditSuppressionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateAuthorizerCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateAuthorizerCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    authorizerArn: undefined,
                    authorizerName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.authorizerArn !== undefined && data.authorizerArn !== null) {
                    contents.authorizerArn = __expectString(data.authorizerArn);
                }
                if (data.authorizerName !== undefined && data.authorizerName !== null) {
                    contents.authorizerName = __expectString(data.authorizerName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateAuthorizerCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateBillingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateBillingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    billingGroupArn: undefined,
                    billingGroupId: undefined,
                    billingGroupName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.billingGroupArn !== undefined && data.billingGroupArn !== null) {
                    contents.billingGroupArn = __expectString(data.billingGroupArn);
                }
                if (data.billingGroupId !== undefined && data.billingGroupId !== null) {
                    contents.billingGroupId = __expectString(data.billingGroupId);
                }
                if (data.billingGroupName !== undefined && data.billingGroupName !== null) {
                    contents.billingGroupName = __expectString(data.billingGroupName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateBillingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceAlreadyExistsException": return [3, 6];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateCertificateFromCsrCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateCertificateFromCsrCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificateArn: undefined,
                    certificateId: undefined,
                    certificatePem: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificateArn !== undefined && data.certificateArn !== null) {
                    contents.certificateArn = __expectString(data.certificateArn);
                }
                if (data.certificateId !== undefined && data.certificateId !== null) {
                    contents.certificateId = __expectString(data.certificateId);
                }
                if (data.certificatePem !== undefined && data.certificatePem !== null) {
                    contents.certificatePem = __expectString(data.certificatePem);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateCertificateFromCsrCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateCustomMetricCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateCustomMetricCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    metricArn: undefined,
                    metricName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.metricArn !== undefined && data.metricArn !== null) {
                    contents.metricArn = __expectString(data.metricArn);
                }
                if (data.metricName !== undefined && data.metricName !== null) {
                    contents.metricName = __expectString(data.metricName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateCustomMetricCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateDimensionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateDimensionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    arn: undefined,
                    name: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.arn !== undefined && data.arn !== null) {
                    contents.arn = __expectString(data.arn);
                }
                if (data.name !== undefined && data.name !== null) {
                    contents.name = __expectString(data.name);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateDimensionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateDomainConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateDomainConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    domainConfigurationArn: undefined,
                    domainConfigurationName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.domainConfigurationArn !== undefined && data.domainConfigurationArn !== null) {
                    contents.domainConfigurationArn = __expectString(data.domainConfigurationArn);
                }
                if (data.domainConfigurationName !== undefined && data.domainConfigurationName !== null) {
                    contents.domainConfigurationName = __expectString(data.domainConfigurationName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateDomainConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateValidationException": return [3, 2];
                    case "com.amazonaws.iot#CertificateValidationException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "LimitExceededException": return [3, 8];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 8];
                    case "ResourceAlreadyExistsException": return [3, 10];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 10];
                    case "ServiceUnavailableException": return [3, 12];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 12];
                    case "ThrottlingException": return [3, 14];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 14];
                    case "UnauthorizedException": return [3, 16];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1CertificateValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateDynamicThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateDynamicThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    indexName: undefined,
                    queryString: undefined,
                    queryVersion: undefined,
                    thingGroupArn: undefined,
                    thingGroupId: undefined,
                    thingGroupName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.indexName !== undefined && data.indexName !== null) {
                    contents.indexName = __expectString(data.indexName);
                }
                if (data.queryString !== undefined && data.queryString !== null) {
                    contents.queryString = __expectString(data.queryString);
                }
                if (data.queryVersion !== undefined && data.queryVersion !== null) {
                    contents.queryVersion = __expectString(data.queryVersion);
                }
                if (data.thingGroupArn !== undefined && data.thingGroupArn !== null) {
                    contents.thingGroupArn = __expectString(data.thingGroupArn);
                }
                if (data.thingGroupId !== undefined && data.thingGroupId !== null) {
                    contents.thingGroupId = __expectString(data.thingGroupId);
                }
                if (data.thingGroupName !== undefined && data.thingGroupName !== null) {
                    contents.thingGroupName = __expectString(data.thingGroupName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateDynamicThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidQueryException": return [3, 4];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "LimitExceededException": return [3, 8];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 8];
                    case "ResourceAlreadyExistsException": return [3, 10];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 10];
                    case "ResourceNotFoundException": return [3, 12];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 12];
                    case "ThrottlingException": return [3, 14];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateFleetMetricCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateFleetMetricCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    metricArn: undefined,
                    metricName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.metricArn !== undefined && data.metricArn !== null) {
                    contents.metricArn = __expectString(data.metricArn);
                }
                if (data.metricName !== undefined && data.metricName !== null) {
                    contents.metricName = __expectString(data.metricName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateFleetMetricCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "IndexNotReadyException": return [3, 2];
                    case "com.amazonaws.iot#IndexNotReadyException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidAggregationException": return [3, 6];
                    case "com.amazonaws.iot#InvalidAggregationException": return [3, 6];
                    case "InvalidQueryException": return [3, 8];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 8];
                    case "InvalidRequestException": return [3, 10];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 10];
                    case "LimitExceededException": return [3, 12];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 12];
                    case "ResourceAlreadyExistsException": return [3, 14];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 14];
                    case "ResourceNotFoundException": return [3, 16];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 16];
                    case "ServiceUnavailableException": return [3, 18];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 18];
                    case "ThrottlingException": return [3, 20];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 20];
                    case "UnauthorizedException": return [3, 22];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 22];
                }
                return [3, 24];
            case 2: return [4, deserializeAws_restJson1IndexNotReadyExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidAggregationExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 19: throw _d.sent();
            case 20: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 21: throw _d.sent();
            case 22: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 23: throw _d.sent();
            case 24:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    description: undefined,
                    jobArn: undefined,
                    jobId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.jobArn !== undefined && data.jobArn !== null) {
                    contents.jobArn = __expectString(data.jobArn);
                }
                if (data.jobId !== undefined && data.jobId !== null) {
                    contents.jobId = __expectString(data.jobId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "LimitExceededException": return [3, 4];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 4];
                    case "ResourceAlreadyExistsException": return [3, 6];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateJobTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateJobTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    jobTemplateArn: undefined,
                    jobTemplateId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.jobTemplateArn !== undefined && data.jobTemplateArn !== null) {
                    contents.jobTemplateArn = __expectString(data.jobTemplateArn);
                }
                if (data.jobTemplateId !== undefined && data.jobTemplateId !== null) {
                    contents.jobTemplateId = __expectString(data.jobTemplateId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateJobTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictException": return [3, 2];
                    case "com.amazonaws.iot#ConflictException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "LimitExceededException": return [3, 8];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 8];
                    case "ResourceNotFoundException": return [3, 10];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateKeysAndCertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateKeysAndCertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificateArn: undefined,
                    certificateId: undefined,
                    certificatePem: undefined,
                    keyPair: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificateArn !== undefined && data.certificateArn !== null) {
                    contents.certificateArn = __expectString(data.certificateArn);
                }
                if (data.certificateId !== undefined && data.certificateId !== null) {
                    contents.certificateId = __expectString(data.certificateId);
                }
                if (data.certificatePem !== undefined && data.certificatePem !== null) {
                    contents.certificatePem = __expectString(data.certificatePem);
                }
                if (data.keyPair !== undefined && data.keyPair !== null) {
                    contents.keyPair = deserializeAws_restJson1KeyPair(data.keyPair, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateKeysAndCertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateMitigationActionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateMitigationActionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    actionArn: undefined,
                    actionId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.actionArn !== undefined && data.actionArn !== null) {
                    contents.actionArn = __expectString(data.actionArn);
                }
                if (data.actionId !== undefined && data.actionId !== null) {
                    contents.actionId = __expectString(data.actionId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateMitigationActionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateOTAUpdateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateOTAUpdateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    awsIotJobArn: undefined,
                    awsIotJobId: undefined,
                    otaUpdateArn: undefined,
                    otaUpdateId: undefined,
                    otaUpdateStatus: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.awsIotJobArn !== undefined && data.awsIotJobArn !== null) {
                    contents.awsIotJobArn = __expectString(data.awsIotJobArn);
                }
                if (data.awsIotJobId !== undefined && data.awsIotJobId !== null) {
                    contents.awsIotJobId = __expectString(data.awsIotJobId);
                }
                if (data.otaUpdateArn !== undefined && data.otaUpdateArn !== null) {
                    contents.otaUpdateArn = __expectString(data.otaUpdateArn);
                }
                if (data.otaUpdateId !== undefined && data.otaUpdateId !== null) {
                    contents.otaUpdateId = __expectString(data.otaUpdateId);
                }
                if (data.otaUpdateStatus !== undefined && data.otaUpdateStatus !== null) {
                    contents.otaUpdateStatus = __expectString(data.otaUpdateStatus);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateOTAUpdateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ResourceNotFoundException": return [3, 10];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 10];
                    case "ServiceUnavailableException": return [3, 12];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 12];
                    case "ThrottlingException": return [3, 14];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 14];
                    case "UnauthorizedException": return [3, 16];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreatePolicyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreatePolicyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    policyArn: undefined,
                    policyDocument: undefined,
                    policyName: undefined,
                    policyVersionId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.policyArn !== undefined && data.policyArn !== null) {
                    contents.policyArn = __expectString(data.policyArn);
                }
                if (data.policyDocument !== undefined && data.policyDocument !== null) {
                    contents.policyDocument = __expectString(data.policyDocument);
                }
                if (data.policyName !== undefined && data.policyName !== null) {
                    contents.policyName = __expectString(data.policyName);
                }
                if (data.policyVersionId !== undefined && data.policyVersionId !== null) {
                    contents.policyVersionId = __expectString(data.policyVersionId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreatePolicyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "MalformedPolicyException": return [3, 6];
                    case "com.amazonaws.iot#MalformedPolicyException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1MalformedPolicyExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreatePolicyVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreatePolicyVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    isDefaultVersion: undefined,
                    policyArn: undefined,
                    policyDocument: undefined,
                    policyVersionId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.isDefaultVersion !== undefined && data.isDefaultVersion !== null) {
                    contents.isDefaultVersion = __expectBoolean(data.isDefaultVersion);
                }
                if (data.policyArn !== undefined && data.policyArn !== null) {
                    contents.policyArn = __expectString(data.policyArn);
                }
                if (data.policyDocument !== undefined && data.policyDocument !== null) {
                    contents.policyDocument = __expectString(data.policyDocument);
                }
                if (data.policyVersionId !== undefined && data.policyVersionId !== null) {
                    contents.policyVersionId = __expectString(data.policyVersionId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreatePolicyVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "MalformedPolicyException": return [3, 6];
                    case "com.amazonaws.iot#MalformedPolicyException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                    case "VersionsLimitExceededException": return [3, 16];
                    case "com.amazonaws.iot#VersionsLimitExceededException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1MalformedPolicyExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1VersionsLimitExceededExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateProvisioningClaimCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateProvisioningClaimCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificateId: undefined,
                    certificatePem: undefined,
                    expiration: undefined,
                    keyPair: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificateId !== undefined && data.certificateId !== null) {
                    contents.certificateId = __expectString(data.certificateId);
                }
                if (data.certificatePem !== undefined && data.certificatePem !== null) {
                    contents.certificatePem = __expectString(data.certificatePem);
                }
                if (data.expiration !== undefined && data.expiration !== null) {
                    contents.expiration = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.expiration)));
                }
                if (data.keyPair !== undefined && data.keyPair !== null) {
                    contents.keyPair = deserializeAws_restJson1KeyPair(data.keyPair, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateProvisioningClaimCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateProvisioningTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateProvisioningTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    defaultVersionId: undefined,
                    templateArn: undefined,
                    templateName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.defaultVersionId !== undefined && data.defaultVersionId !== null) {
                    contents.defaultVersionId = __expectInt32(data.defaultVersionId);
                }
                if (data.templateArn !== undefined && data.templateArn !== null) {
                    contents.templateArn = __expectString(data.templateArn);
                }
                if (data.templateName !== undefined && data.templateName !== null) {
                    contents.templateName = __expectString(data.templateName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateProvisioningTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateProvisioningTemplateVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateProvisioningTemplateVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    isDefaultVersion: undefined,
                    templateArn: undefined,
                    templateName: undefined,
                    versionId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.isDefaultVersion !== undefined && data.isDefaultVersion !== null) {
                    contents.isDefaultVersion = __expectBoolean(data.isDefaultVersion);
                }
                if (data.templateArn !== undefined && data.templateArn !== null) {
                    contents.templateArn = __expectString(data.templateArn);
                }
                if (data.templateName !== undefined && data.templateName !== null) {
                    contents.templateName = __expectString(data.templateName);
                }
                if (data.versionId !== undefined && data.versionId !== null) {
                    contents.versionId = __expectInt32(data.versionId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateProvisioningTemplateVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                    case "VersionsLimitExceededException": return [3, 14];
                    case "com.amazonaws.iot#VersionsLimitExceededException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1VersionsLimitExceededExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateRoleAliasCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateRoleAliasCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    roleAlias: undefined,
                    roleAliasArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.roleAlias !== undefined && data.roleAlias !== null) {
                    contents.roleAlias = __expectString(data.roleAlias);
                }
                if (data.roleAliasArn !== undefined && data.roleAliasArn !== null) {
                    contents.roleAliasArn = __expectString(data.roleAliasArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateRoleAliasCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateScheduledAuditCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateScheduledAuditCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    scheduledAuditArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.scheduledAuditArn !== undefined && data.scheduledAuditArn !== null) {
                    contents.scheduledAuditArn = __expectString(data.scheduledAuditArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateScheduledAuditCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateSecurityProfileCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateSecurityProfileCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    securityProfileArn: undefined,
                    securityProfileName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.securityProfileArn !== undefined && data.securityProfileArn !== null) {
                    contents.securityProfileArn = __expectString(data.securityProfileArn);
                }
                if (data.securityProfileName !== undefined && data.securityProfileName !== null) {
                    contents.securityProfileName = __expectString(data.securityProfileName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateSecurityProfileCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceAlreadyExistsException": return [3, 6];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateStreamCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateStreamCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    description: undefined,
                    streamArn: undefined,
                    streamId: undefined,
                    streamVersion: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.streamArn !== undefined && data.streamArn !== null) {
                    contents.streamArn = __expectString(data.streamArn);
                }
                if (data.streamId !== undefined && data.streamId !== null) {
                    contents.streamId = __expectString(data.streamId);
                }
                if (data.streamVersion !== undefined && data.streamVersion !== null) {
                    contents.streamVersion = __expectInt32(data.streamVersion);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateStreamCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ResourceNotFoundException": return [3, 10];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 10];
                    case "ServiceUnavailableException": return [3, 12];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 12];
                    case "ThrottlingException": return [3, 14];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 14];
                    case "UnauthorizedException": return [3, 16];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateThingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateThingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    thingArn: undefined,
                    thingId: undefined,
                    thingName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.thingArn !== undefined && data.thingArn !== null) {
                    contents.thingArn = __expectString(data.thingArn);
                }
                if (data.thingId !== undefined && data.thingId !== null) {
                    contents.thingId = __expectString(data.thingId);
                }
                if (data.thingName !== undefined && data.thingName !== null) {
                    contents.thingName = __expectString(data.thingName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateThingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceAlreadyExistsException": return [3, 6];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    thingGroupArn: undefined,
                    thingGroupId: undefined,
                    thingGroupName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.thingGroupArn !== undefined && data.thingGroupArn !== null) {
                    contents.thingGroupArn = __expectString(data.thingGroupArn);
                }
                if (data.thingGroupId !== undefined && data.thingGroupId !== null) {
                    contents.thingGroupId = __expectString(data.thingGroupId);
                }
                if (data.thingGroupName !== undefined && data.thingGroupName !== null) {
                    contents.thingGroupName = __expectString(data.thingGroupName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceAlreadyExistsException": return [3, 6];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateThingTypeCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateThingTypeCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    thingTypeArn: undefined,
                    thingTypeId: undefined,
                    thingTypeName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.thingTypeArn !== undefined && data.thingTypeArn !== null) {
                    contents.thingTypeArn = __expectString(data.thingTypeArn);
                }
                if (data.thingTypeId !== undefined && data.thingTypeId !== null) {
                    contents.thingTypeId = __expectString(data.thingTypeId);
                }
                if (data.thingTypeName !== undefined && data.thingTypeName !== null) {
                    contents.thingTypeName = __expectString(data.thingTypeName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateThingTypeCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceAlreadyExistsException": return [3, 6];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateTopicRuleCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateTopicRuleCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateTopicRuleCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "SqlParseException": return [3, 12];
                    case "com.amazonaws.iot#SqlParseException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1SqlParseExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1CreateTopicRuleDestinationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1CreateTopicRuleDestinationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    topicRuleDestination: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.topicRuleDestination !== undefined && data.topicRuleDestination !== null) {
                    contents.topicRuleDestination = deserializeAws_restJson1TopicRuleDestination(data.topicRuleDestination, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1CreateTopicRuleDestinationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteAccountAuditConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteAccountAuditConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteAccountAuditConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteAuditSuppressionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteAuditSuppressionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteAuditSuppressionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteAuthorizerCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteAuthorizerCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteAuthorizerCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "DeleteConflictException": return [3, 2];
                    case "com.amazonaws.iot#DeleteConflictException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1DeleteConflictExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteBillingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteBillingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteBillingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "VersionConflictException": return [3, 8];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteCACertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteCACertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteCACertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateStateException": return [3, 2];
                    case "com.amazonaws.iot#CertificateStateException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1CertificateStateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteCertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteCertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteCertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateStateException": return [3, 2];
                    case "com.amazonaws.iot#CertificateStateException": return [3, 2];
                    case "DeleteConflictException": return [3, 4];
                    case "com.amazonaws.iot#DeleteConflictException": return [3, 4];
                    case "InternalFailureException": return [3, 6];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 6];
                    case "InvalidRequestException": return [3, 8];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 8];
                    case "ResourceNotFoundException": return [3, 10];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 10];
                    case "ServiceUnavailableException": return [3, 12];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 12];
                    case "ThrottlingException": return [3, 14];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 14];
                    case "UnauthorizedException": return [3, 16];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1CertificateStateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1DeleteConflictExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteCustomMetricCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteCustomMetricCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteCustomMetricCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteDimensionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteDimensionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteDimensionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteDomainConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteDomainConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteDomainConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteDynamicThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteDynamicThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteDynamicThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "VersionConflictException": return [3, 8];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteFleetMetricCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteFleetMetricCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteFleetMetricCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                    case "VersionConflictException": return [3, 12];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "InvalidStateTransitionException": return [3, 4];
                    case "com.amazonaws.iot#InvalidStateTransitionException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidStateTransitionExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteJobExecutionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteJobExecutionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteJobExecutionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "InvalidStateTransitionException": return [3, 4];
                    case "com.amazonaws.iot#InvalidStateTransitionException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidStateTransitionExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteJobTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteJobTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteJobTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteMitigationActionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteMitigationActionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteMitigationActionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteOTAUpdateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteOTAUpdateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteOTAUpdateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                    case "VersionConflictException": return [3, 14];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeletePolicyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeletePolicyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeletePolicyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "DeleteConflictException": return [3, 2];
                    case "com.amazonaws.iot#DeleteConflictException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1DeleteConflictExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeletePolicyVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeletePolicyVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeletePolicyVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "DeleteConflictException": return [3, 2];
                    case "com.amazonaws.iot#DeleteConflictException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1DeleteConflictExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteProvisioningTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteProvisioningTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteProvisioningTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "DeleteConflictException": return [3, 4];
                    case "com.amazonaws.iot#DeleteConflictException": return [3, 4];
                    case "InternalFailureException": return [3, 6];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 6];
                    case "InvalidRequestException": return [3, 8];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 8];
                    case "ResourceNotFoundException": return [3, 10];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1DeleteConflictExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteProvisioningTemplateVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteProvisioningTemplateVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteProvisioningTemplateVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "DeleteConflictException": return [3, 4];
                    case "com.amazonaws.iot#DeleteConflictException": return [3, 4];
                    case "InternalFailureException": return [3, 6];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 6];
                    case "InvalidRequestException": return [3, 8];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 8];
                    case "ResourceNotFoundException": return [3, 10];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1DeleteConflictExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteRegistrationCodeCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteRegistrationCodeCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteRegistrationCodeCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "ResourceNotFoundException": return [3, 4];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteRoleAliasCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteRoleAliasCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteRoleAliasCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "DeleteConflictException": return [3, 2];
                    case "com.amazonaws.iot#DeleteConflictException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1DeleteConflictExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteScheduledAuditCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteScheduledAuditCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteScheduledAuditCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteSecurityProfileCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteSecurityProfileCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteSecurityProfileCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "VersionConflictException": return [3, 8];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteStreamCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteStreamCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteStreamCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "DeleteConflictException": return [3, 2];
                    case "com.amazonaws.iot#DeleteConflictException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1DeleteConflictExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteThingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteThingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteThingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                    case "VersionConflictException": return [3, 14];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "VersionConflictException": return [3, 8];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteThingTypeCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteThingTypeCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteThingTypeCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteTopicRuleCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteTopicRuleCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteTopicRuleCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteTopicRuleDestinationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteTopicRuleDestinationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteTopicRuleDestinationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeleteV2LoggingLevelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeleteV2LoggingLevelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeleteV2LoggingLevelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DeprecateThingTypeCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DeprecateThingTypeCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DeprecateThingTypeCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeAccountAuditConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeAccountAuditConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    auditCheckConfigurations: undefined,
                    auditNotificationTargetConfigurations: undefined,
                    roleArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.auditCheckConfigurations !== undefined && data.auditCheckConfigurations !== null) {
                    contents.auditCheckConfigurations = deserializeAws_restJson1AuditCheckConfigurations(data.auditCheckConfigurations, context);
                }
                if (data.auditNotificationTargetConfigurations !== undefined && data.auditNotificationTargetConfigurations !== null) {
                    contents.auditNotificationTargetConfigurations = deserializeAws_restJson1AuditNotificationTargetConfigurations(data.auditNotificationTargetConfigurations, context);
                }
                if (data.roleArn !== undefined && data.roleArn !== null) {
                    contents.roleArn = __expectString(data.roleArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeAccountAuditConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "ThrottlingException": return [3, 4];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 4];
                }
                return [3, 6];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeAuditFindingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeAuditFindingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    finding: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.finding !== undefined && data.finding !== null) {
                    contents.finding = deserializeAws_restJson1AuditFinding(data.finding, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeAuditFindingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeAuditMitigationActionsTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeAuditMitigationActionsTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    actionsDefinition: undefined,
                    auditCheckToActionsMapping: undefined,
                    endTime: undefined,
                    startTime: undefined,
                    target: undefined,
                    taskStatistics: undefined,
                    taskStatus: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.actionsDefinition !== undefined && data.actionsDefinition !== null) {
                    contents.actionsDefinition = deserializeAws_restJson1MitigationActionList(data.actionsDefinition, context);
                }
                if (data.auditCheckToActionsMapping !== undefined && data.auditCheckToActionsMapping !== null) {
                    contents.auditCheckToActionsMapping = deserializeAws_restJson1AuditCheckToActionsMapping(data.auditCheckToActionsMapping, context);
                }
                if (data.endTime !== undefined && data.endTime !== null) {
                    contents.endTime = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.endTime)));
                }
                if (data.startTime !== undefined && data.startTime !== null) {
                    contents.startTime = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.startTime)));
                }
                if (data.target !== undefined && data.target !== null) {
                    contents.target = deserializeAws_restJson1AuditMitigationActionsTaskTarget(data.target, context);
                }
                if (data.taskStatistics !== undefined && data.taskStatistics !== null) {
                    contents.taskStatistics = deserializeAws_restJson1AuditMitigationActionsTaskStatistics(data.taskStatistics, context);
                }
                if (data.taskStatus !== undefined && data.taskStatus !== null) {
                    contents.taskStatus = __expectString(data.taskStatus);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeAuditMitigationActionsTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeAuditSuppressionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeAuditSuppressionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    checkName: undefined,
                    description: undefined,
                    expirationDate: undefined,
                    resourceIdentifier: undefined,
                    suppressIndefinitely: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.checkName !== undefined && data.checkName !== null) {
                    contents.checkName = __expectString(data.checkName);
                }
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.expirationDate !== undefined && data.expirationDate !== null) {
                    contents.expirationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.expirationDate)));
                }
                if (data.resourceIdentifier !== undefined && data.resourceIdentifier !== null) {
                    contents.resourceIdentifier = deserializeAws_restJson1ResourceIdentifier(data.resourceIdentifier, context);
                }
                if (data.suppressIndefinitely !== undefined && data.suppressIndefinitely !== null) {
                    contents.suppressIndefinitely = __expectBoolean(data.suppressIndefinitely);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeAuditSuppressionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeAuditTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeAuditTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    auditDetails: undefined,
                    scheduledAuditName: undefined,
                    taskStartTime: undefined,
                    taskStatistics: undefined,
                    taskStatus: undefined,
                    taskType: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.auditDetails !== undefined && data.auditDetails !== null) {
                    contents.auditDetails = deserializeAws_restJson1AuditDetails(data.auditDetails, context);
                }
                if (data.scheduledAuditName !== undefined && data.scheduledAuditName !== null) {
                    contents.scheduledAuditName = __expectString(data.scheduledAuditName);
                }
                if (data.taskStartTime !== undefined && data.taskStartTime !== null) {
                    contents.taskStartTime = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.taskStartTime)));
                }
                if (data.taskStatistics !== undefined && data.taskStatistics !== null) {
                    contents.taskStatistics = deserializeAws_restJson1TaskStatistics(data.taskStatistics, context);
                }
                if (data.taskStatus !== undefined && data.taskStatus !== null) {
                    contents.taskStatus = __expectString(data.taskStatus);
                }
                if (data.taskType !== undefined && data.taskType !== null) {
                    contents.taskType = __expectString(data.taskType);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeAuditTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeAuthorizerCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeAuthorizerCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    authorizerDescription: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.authorizerDescription !== undefined && data.authorizerDescription !== null) {
                    contents.authorizerDescription = deserializeAws_restJson1AuthorizerDescription(data.authorizerDescription, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeAuthorizerCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeBillingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeBillingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    billingGroupArn: undefined,
                    billingGroupId: undefined,
                    billingGroupMetadata: undefined,
                    billingGroupName: undefined,
                    billingGroupProperties: undefined,
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.billingGroupArn !== undefined && data.billingGroupArn !== null) {
                    contents.billingGroupArn = __expectString(data.billingGroupArn);
                }
                if (data.billingGroupId !== undefined && data.billingGroupId !== null) {
                    contents.billingGroupId = __expectString(data.billingGroupId);
                }
                if (data.billingGroupMetadata !== undefined && data.billingGroupMetadata !== null) {
                    contents.billingGroupMetadata = deserializeAws_restJson1BillingGroupMetadata(data.billingGroupMetadata, context);
                }
                if (data.billingGroupName !== undefined && data.billingGroupName !== null) {
                    contents.billingGroupName = __expectString(data.billingGroupName);
                }
                if (data.billingGroupProperties !== undefined && data.billingGroupProperties !== null) {
                    contents.billingGroupProperties = deserializeAws_restJson1BillingGroupProperties(data.billingGroupProperties, context);
                }
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeBillingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeCACertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeCACertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificateDescription: undefined,
                    registrationConfig: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificateDescription !== undefined && data.certificateDescription !== null) {
                    contents.certificateDescription = deserializeAws_restJson1CACertificateDescription(data.certificateDescription, context);
                }
                if (data.registrationConfig !== undefined && data.registrationConfig !== null) {
                    contents.registrationConfig = deserializeAws_restJson1RegistrationConfig(data.registrationConfig, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeCACertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeCertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeCertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificateDescription: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificateDescription !== undefined && data.certificateDescription !== null) {
                    contents.certificateDescription = deserializeAws_restJson1CertificateDescription(data.certificateDescription, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeCertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeCustomMetricCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeCustomMetricCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    creationDate: undefined,
                    displayName: undefined,
                    lastModifiedDate: undefined,
                    metricArn: undefined,
                    metricName: undefined,
                    metricType: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.displayName !== undefined && data.displayName !== null) {
                    contents.displayName = __expectString(data.displayName);
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.metricArn !== undefined && data.metricArn !== null) {
                    contents.metricArn = __expectString(data.metricArn);
                }
                if (data.metricName !== undefined && data.metricName !== null) {
                    contents.metricName = __expectString(data.metricName);
                }
                if (data.metricType !== undefined && data.metricType !== null) {
                    contents.metricType = __expectString(data.metricType);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeCustomMetricCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeDefaultAuthorizerCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeDefaultAuthorizerCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    authorizerDescription: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.authorizerDescription !== undefined && data.authorizerDescription !== null) {
                    contents.authorizerDescription = deserializeAws_restJson1AuthorizerDescription(data.authorizerDescription, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeDefaultAuthorizerCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeDetectMitigationActionsTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeDetectMitigationActionsTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    taskSummary: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.taskSummary !== undefined && data.taskSummary !== null) {
                    contents.taskSummary = deserializeAws_restJson1DetectMitigationActionsTaskSummary(data.taskSummary, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeDetectMitigationActionsTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeDimensionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeDimensionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    arn: undefined,
                    creationDate: undefined,
                    lastModifiedDate: undefined,
                    name: undefined,
                    stringValues: undefined,
                    type: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.arn !== undefined && data.arn !== null) {
                    contents.arn = __expectString(data.arn);
                }
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.name !== undefined && data.name !== null) {
                    contents.name = __expectString(data.name);
                }
                if (data.stringValues !== undefined && data.stringValues !== null) {
                    contents.stringValues = deserializeAws_restJson1DimensionStringValues(data.stringValues, context);
                }
                if (data.type !== undefined && data.type !== null) {
                    contents.type = __expectString(data.type);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeDimensionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeDomainConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeDomainConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    authorizerConfig: undefined,
                    domainConfigurationArn: undefined,
                    domainConfigurationName: undefined,
                    domainConfigurationStatus: undefined,
                    domainName: undefined,
                    domainType: undefined,
                    lastStatusChangeDate: undefined,
                    serverCertificates: undefined,
                    serviceType: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.authorizerConfig !== undefined && data.authorizerConfig !== null) {
                    contents.authorizerConfig = deserializeAws_restJson1AuthorizerConfig(data.authorizerConfig, context);
                }
                if (data.domainConfigurationArn !== undefined && data.domainConfigurationArn !== null) {
                    contents.domainConfigurationArn = __expectString(data.domainConfigurationArn);
                }
                if (data.domainConfigurationName !== undefined && data.domainConfigurationName !== null) {
                    contents.domainConfigurationName = __expectString(data.domainConfigurationName);
                }
                if (data.domainConfigurationStatus !== undefined && data.domainConfigurationStatus !== null) {
                    contents.domainConfigurationStatus = __expectString(data.domainConfigurationStatus);
                }
                if (data.domainName !== undefined && data.domainName !== null) {
                    contents.domainName = __expectString(data.domainName);
                }
                if (data.domainType !== undefined && data.domainType !== null) {
                    contents.domainType = __expectString(data.domainType);
                }
                if (data.lastStatusChangeDate !== undefined && data.lastStatusChangeDate !== null) {
                    contents.lastStatusChangeDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastStatusChangeDate)));
                }
                if (data.serverCertificates !== undefined && data.serverCertificates !== null) {
                    contents.serverCertificates = deserializeAws_restJson1ServerCertificates(data.serverCertificates, context);
                }
                if (data.serviceType !== undefined && data.serviceType !== null) {
                    contents.serviceType = __expectString(data.serviceType);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeDomainConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeEndpointCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeEndpointCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    endpointAddress: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.endpointAddress !== undefined && data.endpointAddress !== null) {
                    contents.endpointAddress = __expectString(data.endpointAddress);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeEndpointCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "UnauthorizedException": return [3, 8];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeEventConfigurationsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeEventConfigurationsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    creationDate: undefined,
                    eventConfigurations: undefined,
                    lastModifiedDate: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.eventConfigurations !== undefined && data.eventConfigurations !== null) {
                    contents.eventConfigurations = deserializeAws_restJson1EventConfigurations(data.eventConfigurations, context);
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeEventConfigurationsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "ThrottlingException": return [3, 4];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 4];
                }
                return [3, 6];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeFleetMetricCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeFleetMetricCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    aggregationField: undefined,
                    aggregationType: undefined,
                    creationDate: undefined,
                    description: undefined,
                    indexName: undefined,
                    lastModifiedDate: undefined,
                    metricArn: undefined,
                    metricName: undefined,
                    period: undefined,
                    queryString: undefined,
                    queryVersion: undefined,
                    unit: undefined,
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.aggregationField !== undefined && data.aggregationField !== null) {
                    contents.aggregationField = __expectString(data.aggregationField);
                }
                if (data.aggregationType !== undefined && data.aggregationType !== null) {
                    contents.aggregationType = deserializeAws_restJson1AggregationType(data.aggregationType, context);
                }
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.indexName !== undefined && data.indexName !== null) {
                    contents.indexName = __expectString(data.indexName);
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.metricArn !== undefined && data.metricArn !== null) {
                    contents.metricArn = __expectString(data.metricArn);
                }
                if (data.metricName !== undefined && data.metricName !== null) {
                    contents.metricName = __expectString(data.metricName);
                }
                if (data.period !== undefined && data.period !== null) {
                    contents.period = __expectInt32(data.period);
                }
                if (data.queryString !== undefined && data.queryString !== null) {
                    contents.queryString = __expectString(data.queryString);
                }
                if (data.queryVersion !== undefined && data.queryVersion !== null) {
                    contents.queryVersion = __expectString(data.queryVersion);
                }
                if (data.unit !== undefined && data.unit !== null) {
                    contents.unit = __expectString(data.unit);
                }
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeFleetMetricCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeIndexCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeIndexCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    indexName: undefined,
                    indexStatus: undefined,
                    schema: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.indexName !== undefined && data.indexName !== null) {
                    contents.indexName = __expectString(data.indexName);
                }
                if (data.indexStatus !== undefined && data.indexStatus !== null) {
                    contents.indexStatus = __expectString(data.indexStatus);
                }
                if (data.schema !== undefined && data.schema !== null) {
                    contents.schema = __expectString(data.schema);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeIndexCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    documentSource: undefined,
                    job: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.documentSource !== undefined && data.documentSource !== null) {
                    contents.documentSource = __expectString(data.documentSource);
                }
                if (data.job !== undefined && data.job !== null) {
                    contents.job = deserializeAws_restJson1Job(data.job, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "ResourceNotFoundException": return [3, 4];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeJobExecutionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeJobExecutionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    execution: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.execution !== undefined && data.execution !== null) {
                    contents.execution = deserializeAws_restJson1JobExecution(data.execution, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeJobExecutionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "ResourceNotFoundException": return [3, 4];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeJobTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeJobTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    abortConfig: undefined,
                    createdAt: undefined,
                    description: undefined,
                    document: undefined,
                    documentSource: undefined,
                    jobExecutionsRetryConfig: undefined,
                    jobExecutionsRolloutConfig: undefined,
                    jobTemplateArn: undefined,
                    jobTemplateId: undefined,
                    presignedUrlConfig: undefined,
                    timeoutConfig: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.abortConfig !== undefined && data.abortConfig !== null) {
                    contents.abortConfig = deserializeAws_restJson1AbortConfig(data.abortConfig, context);
                }
                if (data.createdAt !== undefined && data.createdAt !== null) {
                    contents.createdAt = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.createdAt)));
                }
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.document !== undefined && data.document !== null) {
                    contents.document = __expectString(data.document);
                }
                if (data.documentSource !== undefined && data.documentSource !== null) {
                    contents.documentSource = __expectString(data.documentSource);
                }
                if (data.jobExecutionsRetryConfig !== undefined && data.jobExecutionsRetryConfig !== null) {
                    contents.jobExecutionsRetryConfig = deserializeAws_restJson1JobExecutionsRetryConfig(data.jobExecutionsRetryConfig, context);
                }
                if (data.jobExecutionsRolloutConfig !== undefined && data.jobExecutionsRolloutConfig !== null) {
                    contents.jobExecutionsRolloutConfig = deserializeAws_restJson1JobExecutionsRolloutConfig(data.jobExecutionsRolloutConfig, context);
                }
                if (data.jobTemplateArn !== undefined && data.jobTemplateArn !== null) {
                    contents.jobTemplateArn = __expectString(data.jobTemplateArn);
                }
                if (data.jobTemplateId !== undefined && data.jobTemplateId !== null) {
                    contents.jobTemplateId = __expectString(data.jobTemplateId);
                }
                if (data.presignedUrlConfig !== undefined && data.presignedUrlConfig !== null) {
                    contents.presignedUrlConfig = deserializeAws_restJson1PresignedUrlConfig(data.presignedUrlConfig, context);
                }
                if (data.timeoutConfig !== undefined && data.timeoutConfig !== null) {
                    contents.timeoutConfig = deserializeAws_restJson1TimeoutConfig(data.timeoutConfig, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeJobTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeManagedJobTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeManagedJobTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    description: undefined,
                    document: undefined,
                    documentParameters: undefined,
                    environments: undefined,
                    templateArn: undefined,
                    templateName: undefined,
                    templateVersion: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.document !== undefined && data.document !== null) {
                    contents.document = __expectString(data.document);
                }
                if (data.documentParameters !== undefined && data.documentParameters !== null) {
                    contents.documentParameters = deserializeAws_restJson1DocumentParameters(data.documentParameters, context);
                }
                if (data.environments !== undefined && data.environments !== null) {
                    contents.environments = deserializeAws_restJson1Environments(data.environments, context);
                }
                if (data.templateArn !== undefined && data.templateArn !== null) {
                    contents.templateArn = __expectString(data.templateArn);
                }
                if (data.templateName !== undefined && data.templateName !== null) {
                    contents.templateName = __expectString(data.templateName);
                }
                if (data.templateVersion !== undefined && data.templateVersion !== null) {
                    contents.templateVersion = __expectString(data.templateVersion);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeManagedJobTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalServerException": return [3, 2];
                    case "com.amazonaws.iot#InternalServerException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeMitigationActionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeMitigationActionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    actionArn: undefined,
                    actionId: undefined,
                    actionName: undefined,
                    actionParams: undefined,
                    actionType: undefined,
                    creationDate: undefined,
                    lastModifiedDate: undefined,
                    roleArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.actionArn !== undefined && data.actionArn !== null) {
                    contents.actionArn = __expectString(data.actionArn);
                }
                if (data.actionId !== undefined && data.actionId !== null) {
                    contents.actionId = __expectString(data.actionId);
                }
                if (data.actionName !== undefined && data.actionName !== null) {
                    contents.actionName = __expectString(data.actionName);
                }
                if (data.actionParams !== undefined && data.actionParams !== null) {
                    contents.actionParams = deserializeAws_restJson1MitigationActionParams(data.actionParams, context);
                }
                if (data.actionType !== undefined && data.actionType !== null) {
                    contents.actionType = __expectString(data.actionType);
                }
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.roleArn !== undefined && data.roleArn !== null) {
                    contents.roleArn = __expectString(data.roleArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeMitigationActionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeProvisioningTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeProvisioningTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    creationDate: undefined,
                    defaultVersionId: undefined,
                    description: undefined,
                    enabled: undefined,
                    lastModifiedDate: undefined,
                    preProvisioningHook: undefined,
                    provisioningRoleArn: undefined,
                    templateArn: undefined,
                    templateBody: undefined,
                    templateName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.defaultVersionId !== undefined && data.defaultVersionId !== null) {
                    contents.defaultVersionId = __expectInt32(data.defaultVersionId);
                }
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.enabled !== undefined && data.enabled !== null) {
                    contents.enabled = __expectBoolean(data.enabled);
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.preProvisioningHook !== undefined && data.preProvisioningHook !== null) {
                    contents.preProvisioningHook = deserializeAws_restJson1ProvisioningHook(data.preProvisioningHook, context);
                }
                if (data.provisioningRoleArn !== undefined && data.provisioningRoleArn !== null) {
                    contents.provisioningRoleArn = __expectString(data.provisioningRoleArn);
                }
                if (data.templateArn !== undefined && data.templateArn !== null) {
                    contents.templateArn = __expectString(data.templateArn);
                }
                if (data.templateBody !== undefined && data.templateBody !== null) {
                    contents.templateBody = __expectString(data.templateBody);
                }
                if (data.templateName !== undefined && data.templateName !== null) {
                    contents.templateName = __expectString(data.templateName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeProvisioningTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeProvisioningTemplateVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeProvisioningTemplateVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    creationDate: undefined,
                    isDefaultVersion: undefined,
                    templateBody: undefined,
                    versionId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.isDefaultVersion !== undefined && data.isDefaultVersion !== null) {
                    contents.isDefaultVersion = __expectBoolean(data.isDefaultVersion);
                }
                if (data.templateBody !== undefined && data.templateBody !== null) {
                    contents.templateBody = __expectString(data.templateBody);
                }
                if (data.versionId !== undefined && data.versionId !== null) {
                    contents.versionId = __expectInt32(data.versionId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeProvisioningTemplateVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeRoleAliasCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeRoleAliasCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    roleAliasDescription: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.roleAliasDescription !== undefined && data.roleAliasDescription !== null) {
                    contents.roleAliasDescription = deserializeAws_restJson1RoleAliasDescription(data.roleAliasDescription, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeRoleAliasCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeScheduledAuditCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeScheduledAuditCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    dayOfMonth: undefined,
                    dayOfWeek: undefined,
                    frequency: undefined,
                    scheduledAuditArn: undefined,
                    scheduledAuditName: undefined,
                    targetCheckNames: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.dayOfMonth !== undefined && data.dayOfMonth !== null) {
                    contents.dayOfMonth = __expectString(data.dayOfMonth);
                }
                if (data.dayOfWeek !== undefined && data.dayOfWeek !== null) {
                    contents.dayOfWeek = __expectString(data.dayOfWeek);
                }
                if (data.frequency !== undefined && data.frequency !== null) {
                    contents.frequency = __expectString(data.frequency);
                }
                if (data.scheduledAuditArn !== undefined && data.scheduledAuditArn !== null) {
                    contents.scheduledAuditArn = __expectString(data.scheduledAuditArn);
                }
                if (data.scheduledAuditName !== undefined && data.scheduledAuditName !== null) {
                    contents.scheduledAuditName = __expectString(data.scheduledAuditName);
                }
                if (data.targetCheckNames !== undefined && data.targetCheckNames !== null) {
                    contents.targetCheckNames = deserializeAws_restJson1TargetAuditCheckNames(data.targetCheckNames, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeScheduledAuditCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeSecurityProfileCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeSecurityProfileCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    additionalMetricsToRetain: undefined,
                    additionalMetricsToRetainV2: undefined,
                    alertTargets: undefined,
                    behaviors: undefined,
                    creationDate: undefined,
                    lastModifiedDate: undefined,
                    securityProfileArn: undefined,
                    securityProfileDescription: undefined,
                    securityProfileName: undefined,
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.additionalMetricsToRetain !== undefined && data.additionalMetricsToRetain !== null) {
                    contents.additionalMetricsToRetain = deserializeAws_restJson1AdditionalMetricsToRetainList(data.additionalMetricsToRetain, context);
                }
                if (data.additionalMetricsToRetainV2 !== undefined && data.additionalMetricsToRetainV2 !== null) {
                    contents.additionalMetricsToRetainV2 = deserializeAws_restJson1AdditionalMetricsToRetainV2List(data.additionalMetricsToRetainV2, context);
                }
                if (data.alertTargets !== undefined && data.alertTargets !== null) {
                    contents.alertTargets = deserializeAws_restJson1AlertTargets(data.alertTargets, context);
                }
                if (data.behaviors !== undefined && data.behaviors !== null) {
                    contents.behaviors = deserializeAws_restJson1Behaviors(data.behaviors, context);
                }
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.securityProfileArn !== undefined && data.securityProfileArn !== null) {
                    contents.securityProfileArn = __expectString(data.securityProfileArn);
                }
                if (data.securityProfileDescription !== undefined && data.securityProfileDescription !== null) {
                    contents.securityProfileDescription = __expectString(data.securityProfileDescription);
                }
                if (data.securityProfileName !== undefined && data.securityProfileName !== null) {
                    contents.securityProfileName = __expectString(data.securityProfileName);
                }
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeSecurityProfileCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeStreamCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeStreamCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    streamInfo: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.streamInfo !== undefined && data.streamInfo !== null) {
                    contents.streamInfo = deserializeAws_restJson1StreamInfo(data.streamInfo, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeStreamCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeThingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeThingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    attributes: undefined,
                    billingGroupName: undefined,
                    defaultClientId: undefined,
                    thingArn: undefined,
                    thingId: undefined,
                    thingName: undefined,
                    thingTypeName: undefined,
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.attributes !== undefined && data.attributes !== null) {
                    contents.attributes = deserializeAws_restJson1Attributes(data.attributes, context);
                }
                if (data.billingGroupName !== undefined && data.billingGroupName !== null) {
                    contents.billingGroupName = __expectString(data.billingGroupName);
                }
                if (data.defaultClientId !== undefined && data.defaultClientId !== null) {
                    contents.defaultClientId = __expectString(data.defaultClientId);
                }
                if (data.thingArn !== undefined && data.thingArn !== null) {
                    contents.thingArn = __expectString(data.thingArn);
                }
                if (data.thingId !== undefined && data.thingId !== null) {
                    contents.thingId = __expectString(data.thingId);
                }
                if (data.thingName !== undefined && data.thingName !== null) {
                    contents.thingName = __expectString(data.thingName);
                }
                if (data.thingTypeName !== undefined && data.thingTypeName !== null) {
                    contents.thingTypeName = __expectString(data.thingTypeName);
                }
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeThingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    indexName: undefined,
                    queryString: undefined,
                    queryVersion: undefined,
                    status: undefined,
                    thingGroupArn: undefined,
                    thingGroupId: undefined,
                    thingGroupMetadata: undefined,
                    thingGroupName: undefined,
                    thingGroupProperties: undefined,
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.indexName !== undefined && data.indexName !== null) {
                    contents.indexName = __expectString(data.indexName);
                }
                if (data.queryString !== undefined && data.queryString !== null) {
                    contents.queryString = __expectString(data.queryString);
                }
                if (data.queryVersion !== undefined && data.queryVersion !== null) {
                    contents.queryVersion = __expectString(data.queryVersion);
                }
                if (data.status !== undefined && data.status !== null) {
                    contents.status = __expectString(data.status);
                }
                if (data.thingGroupArn !== undefined && data.thingGroupArn !== null) {
                    contents.thingGroupArn = __expectString(data.thingGroupArn);
                }
                if (data.thingGroupId !== undefined && data.thingGroupId !== null) {
                    contents.thingGroupId = __expectString(data.thingGroupId);
                }
                if (data.thingGroupMetadata !== undefined && data.thingGroupMetadata !== null) {
                    contents.thingGroupMetadata = deserializeAws_restJson1ThingGroupMetadata(data.thingGroupMetadata, context);
                }
                if (data.thingGroupName !== undefined && data.thingGroupName !== null) {
                    contents.thingGroupName = __expectString(data.thingGroupName);
                }
                if (data.thingGroupProperties !== undefined && data.thingGroupProperties !== null) {
                    contents.thingGroupProperties = deserializeAws_restJson1ThingGroupProperties(data.thingGroupProperties, context);
                }
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeThingRegistrationTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeThingRegistrationTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    creationDate: undefined,
                    failureCount: undefined,
                    inputFileBucket: undefined,
                    inputFileKey: undefined,
                    lastModifiedDate: undefined,
                    message: undefined,
                    percentageProgress: undefined,
                    roleArn: undefined,
                    status: undefined,
                    successCount: undefined,
                    taskId: undefined,
                    templateBody: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.failureCount !== undefined && data.failureCount !== null) {
                    contents.failureCount = __expectInt32(data.failureCount);
                }
                if (data.inputFileBucket !== undefined && data.inputFileBucket !== null) {
                    contents.inputFileBucket = __expectString(data.inputFileBucket);
                }
                if (data.inputFileKey !== undefined && data.inputFileKey !== null) {
                    contents.inputFileKey = __expectString(data.inputFileKey);
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.message !== undefined && data.message !== null) {
                    contents.message = __expectString(data.message);
                }
                if (data.percentageProgress !== undefined && data.percentageProgress !== null) {
                    contents.percentageProgress = __expectInt32(data.percentageProgress);
                }
                if (data.roleArn !== undefined && data.roleArn !== null) {
                    contents.roleArn = __expectString(data.roleArn);
                }
                if (data.status !== undefined && data.status !== null) {
                    contents.status = __expectString(data.status);
                }
                if (data.successCount !== undefined && data.successCount !== null) {
                    contents.successCount = __expectInt32(data.successCount);
                }
                if (data.taskId !== undefined && data.taskId !== null) {
                    contents.taskId = __expectString(data.taskId);
                }
                if (data.templateBody !== undefined && data.templateBody !== null) {
                    contents.templateBody = __expectString(data.templateBody);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeThingRegistrationTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DescribeThingTypeCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DescribeThingTypeCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    thingTypeArn: undefined,
                    thingTypeId: undefined,
                    thingTypeMetadata: undefined,
                    thingTypeName: undefined,
                    thingTypeProperties: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.thingTypeArn !== undefined && data.thingTypeArn !== null) {
                    contents.thingTypeArn = __expectString(data.thingTypeArn);
                }
                if (data.thingTypeId !== undefined && data.thingTypeId !== null) {
                    contents.thingTypeId = __expectString(data.thingTypeId);
                }
                if (data.thingTypeMetadata !== undefined && data.thingTypeMetadata !== null) {
                    contents.thingTypeMetadata = deserializeAws_restJson1ThingTypeMetadata(data.thingTypeMetadata, context);
                }
                if (data.thingTypeName !== undefined && data.thingTypeName !== null) {
                    contents.thingTypeName = __expectString(data.thingTypeName);
                }
                if (data.thingTypeProperties !== undefined && data.thingTypeProperties !== null) {
                    contents.thingTypeProperties = deserializeAws_restJson1ThingTypeProperties(data.thingTypeProperties, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DescribeThingTypeCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DetachPolicyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DetachPolicyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DetachPolicyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DetachPrincipalPolicyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DetachPrincipalPolicyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DetachPrincipalPolicyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DetachSecurityProfileCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DetachSecurityProfileCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DetachSecurityProfileCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DetachThingPrincipalCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DetachThingPrincipalCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DetachThingPrincipalCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1DisableTopicRuleCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1DisableTopicRuleCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1DisableTopicRuleCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1EnableTopicRuleCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1EnableTopicRuleCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1EnableTopicRuleCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetBehaviorModelTrainingSummariesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetBehaviorModelTrainingSummariesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    summaries: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.summaries !== undefined && data.summaries !== null) {
                    contents.summaries = deserializeAws_restJson1BehaviorModelTrainingSummaries(data.summaries, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetBehaviorModelTrainingSummariesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetBucketsAggregationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetBucketsAggregationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    buckets: undefined,
                    totalCount: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.buckets !== undefined && data.buckets !== null) {
                    contents.buckets = deserializeAws_restJson1Buckets(data.buckets, context);
                }
                if (data.totalCount !== undefined && data.totalCount !== null) {
                    contents.totalCount = __expectInt32(data.totalCount);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetBucketsAggregationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "IndexNotReadyException": return [3, 2];
                    case "com.amazonaws.iot#IndexNotReadyException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidAggregationException": return [3, 6];
                    case "com.amazonaws.iot#InvalidAggregationException": return [3, 6];
                    case "InvalidQueryException": return [3, 8];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 8];
                    case "InvalidRequestException": return [3, 10];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 10];
                    case "ResourceNotFoundException": return [3, 12];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 12];
                    case "ServiceUnavailableException": return [3, 14];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 14];
                    case "ThrottlingException": return [3, 16];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 16];
                    case "UnauthorizedException": return [3, 18];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 18];
                }
                return [3, 20];
            case 2: return [4, deserializeAws_restJson1IndexNotReadyExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidAggregationExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 19: throw _d.sent();
            case 20:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetCardinalityCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetCardinalityCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    cardinality: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.cardinality !== undefined && data.cardinality !== null) {
                    contents.cardinality = __expectInt32(data.cardinality);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetCardinalityCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "IndexNotReadyException": return [3, 2];
                    case "com.amazonaws.iot#IndexNotReadyException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidAggregationException": return [3, 6];
                    case "com.amazonaws.iot#InvalidAggregationException": return [3, 6];
                    case "InvalidQueryException": return [3, 8];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 8];
                    case "InvalidRequestException": return [3, 10];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 10];
                    case "ResourceNotFoundException": return [3, 12];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 12];
                    case "ServiceUnavailableException": return [3, 14];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 14];
                    case "ThrottlingException": return [3, 16];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 16];
                    case "UnauthorizedException": return [3, 18];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 18];
                }
                return [3, 20];
            case 2: return [4, deserializeAws_restJson1IndexNotReadyExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidAggregationExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 19: throw _d.sent();
            case 20:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetEffectivePoliciesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetEffectivePoliciesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    effectivePolicies: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.effectivePolicies !== undefined && data.effectivePolicies !== null) {
                    contents.effectivePolicies = deserializeAws_restJson1EffectivePolicies(data.effectivePolicies, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetEffectivePoliciesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetIndexingConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetIndexingConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    thingGroupIndexingConfiguration: undefined,
                    thingIndexingConfiguration: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.thingGroupIndexingConfiguration !== undefined && data.thingGroupIndexingConfiguration !== null) {
                    contents.thingGroupIndexingConfiguration = deserializeAws_restJson1ThingGroupIndexingConfiguration(data.thingGroupIndexingConfiguration, context);
                }
                if (data.thingIndexingConfiguration !== undefined && data.thingIndexingConfiguration !== null) {
                    contents.thingIndexingConfiguration = deserializeAws_restJson1ThingIndexingConfiguration(data.thingIndexingConfiguration, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetIndexingConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetJobDocumentCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetJobDocumentCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    document: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.document !== undefined && data.document !== null) {
                    contents.document = __expectString(data.document);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetJobDocumentCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "ResourceNotFoundException": return [3, 4];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetLoggingOptionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetLoggingOptionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    logLevel: undefined,
                    roleArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.logLevel !== undefined && data.logLevel !== null) {
                    contents.logLevel = __expectString(data.logLevel);
                }
                if (data.roleArn !== undefined && data.roleArn !== null) {
                    contents.roleArn = __expectString(data.roleArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetLoggingOptionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetOTAUpdateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetOTAUpdateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    otaUpdateInfo: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.otaUpdateInfo !== undefined && data.otaUpdateInfo !== null) {
                    contents.otaUpdateInfo = deserializeAws_restJson1OTAUpdateInfo(data.otaUpdateInfo, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetOTAUpdateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetPercentilesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetPercentilesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    percentiles: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.percentiles !== undefined && data.percentiles !== null) {
                    contents.percentiles = deserializeAws_restJson1Percentiles(data.percentiles, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetPercentilesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "IndexNotReadyException": return [3, 2];
                    case "com.amazonaws.iot#IndexNotReadyException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidAggregationException": return [3, 6];
                    case "com.amazonaws.iot#InvalidAggregationException": return [3, 6];
                    case "InvalidQueryException": return [3, 8];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 8];
                    case "InvalidRequestException": return [3, 10];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 10];
                    case "ResourceNotFoundException": return [3, 12];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 12];
                    case "ServiceUnavailableException": return [3, 14];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 14];
                    case "ThrottlingException": return [3, 16];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 16];
                    case "UnauthorizedException": return [3, 18];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 18];
                }
                return [3, 20];
            case 2: return [4, deserializeAws_restJson1IndexNotReadyExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidAggregationExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 19: throw _d.sent();
            case 20:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetPolicyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetPolicyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    creationDate: undefined,
                    defaultVersionId: undefined,
                    generationId: undefined,
                    lastModifiedDate: undefined,
                    policyArn: undefined,
                    policyDocument: undefined,
                    policyName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.defaultVersionId !== undefined && data.defaultVersionId !== null) {
                    contents.defaultVersionId = __expectString(data.defaultVersionId);
                }
                if (data.generationId !== undefined && data.generationId !== null) {
                    contents.generationId = __expectString(data.generationId);
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.policyArn !== undefined && data.policyArn !== null) {
                    contents.policyArn = __expectString(data.policyArn);
                }
                if (data.policyDocument !== undefined && data.policyDocument !== null) {
                    contents.policyDocument = __expectString(data.policyDocument);
                }
                if (data.policyName !== undefined && data.policyName !== null) {
                    contents.policyName = __expectString(data.policyName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetPolicyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetPolicyVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetPolicyVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    creationDate: undefined,
                    generationId: undefined,
                    isDefaultVersion: undefined,
                    lastModifiedDate: undefined,
                    policyArn: undefined,
                    policyDocument: undefined,
                    policyName: undefined,
                    policyVersionId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.generationId !== undefined && data.generationId !== null) {
                    contents.generationId = __expectString(data.generationId);
                }
                if (data.isDefaultVersion !== undefined && data.isDefaultVersion !== null) {
                    contents.isDefaultVersion = __expectBoolean(data.isDefaultVersion);
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.policyArn !== undefined && data.policyArn !== null) {
                    contents.policyArn = __expectString(data.policyArn);
                }
                if (data.policyDocument !== undefined && data.policyDocument !== null) {
                    contents.policyDocument = __expectString(data.policyDocument);
                }
                if (data.policyName !== undefined && data.policyName !== null) {
                    contents.policyName = __expectString(data.policyName);
                }
                if (data.policyVersionId !== undefined && data.policyVersionId !== null) {
                    contents.policyVersionId = __expectString(data.policyVersionId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetPolicyVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetRegistrationCodeCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetRegistrationCodeCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    registrationCode: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.registrationCode !== undefined && data.registrationCode !== null) {
                    contents.registrationCode = __expectString(data.registrationCode);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetRegistrationCodeCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetStatisticsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetStatisticsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    statistics: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.statistics !== undefined && data.statistics !== null) {
                    contents.statistics = deserializeAws_restJson1Statistics(data.statistics, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetStatisticsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "IndexNotReadyException": return [3, 2];
                    case "com.amazonaws.iot#IndexNotReadyException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidAggregationException": return [3, 6];
                    case "com.amazonaws.iot#InvalidAggregationException": return [3, 6];
                    case "InvalidQueryException": return [3, 8];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 8];
                    case "InvalidRequestException": return [3, 10];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 10];
                    case "ResourceNotFoundException": return [3, 12];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 12];
                    case "ServiceUnavailableException": return [3, 14];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 14];
                    case "ThrottlingException": return [3, 16];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 16];
                    case "UnauthorizedException": return [3, 18];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 18];
                }
                return [3, 20];
            case 2: return [4, deserializeAws_restJson1IndexNotReadyExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidAggregationExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 19: throw _d.sent();
            case 20:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetTopicRuleCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetTopicRuleCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    rule: undefined,
                    ruleArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.rule !== undefined && data.rule !== null) {
                    contents.rule = deserializeAws_restJson1TopicRule(data.rule, context);
                }
                if (data.ruleArn !== undefined && data.ruleArn !== null) {
                    contents.ruleArn = __expectString(data.ruleArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetTopicRuleCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "UnauthorizedException": return [3, 8];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetTopicRuleDestinationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetTopicRuleDestinationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    topicRuleDestination: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.topicRuleDestination !== undefined && data.topicRuleDestination !== null) {
                    contents.topicRuleDestination = deserializeAws_restJson1TopicRuleDestination(data.topicRuleDestination, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetTopicRuleDestinationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "UnauthorizedException": return [3, 8];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1GetV2LoggingOptionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1GetV2LoggingOptionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    defaultLogLevel: undefined,
                    disableAllLogs: undefined,
                    roleArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.defaultLogLevel !== undefined && data.defaultLogLevel !== null) {
                    contents.defaultLogLevel = __expectString(data.defaultLogLevel);
                }
                if (data.disableAllLogs !== undefined && data.disableAllLogs !== null) {
                    contents.disableAllLogs = __expectBoolean(data.disableAllLogs);
                }
                if (data.roleArn !== undefined && data.roleArn !== null) {
                    contents.roleArn = __expectString(data.roleArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1GetV2LoggingOptionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "NotConfiguredException": return [3, 4];
                    case "com.amazonaws.iot#NotConfiguredException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1NotConfiguredExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListActiveViolationsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListActiveViolationsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    activeViolations: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.activeViolations !== undefined && data.activeViolations !== null) {
                    contents.activeViolations = deserializeAws_restJson1ActiveViolations(data.activeViolations, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListActiveViolationsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListAttachedPoliciesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListAttachedPoliciesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextMarker: undefined,
                    policies: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                if (data.policies !== undefined && data.policies !== null) {
                    contents.policies = deserializeAws_restJson1Policies(data.policies, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListAttachedPoliciesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListAuditFindingsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListAuditFindingsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    findings: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.findings !== undefined && data.findings !== null) {
                    contents.findings = deserializeAws_restJson1AuditFindings(data.findings, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListAuditFindingsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListAuditMitigationActionsExecutionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListAuditMitigationActionsExecutionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    actionsExecutions: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.actionsExecutions !== undefined && data.actionsExecutions !== null) {
                    contents.actionsExecutions = deserializeAws_restJson1AuditMitigationActionExecutionMetadataList(data.actionsExecutions, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListAuditMitigationActionsExecutionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListAuditMitigationActionsTasksCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListAuditMitigationActionsTasksCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    tasks: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.tasks !== undefined && data.tasks !== null) {
                    contents.tasks = deserializeAws_restJson1AuditMitigationActionsTaskMetadataList(data.tasks, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListAuditMitigationActionsTasksCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListAuditSuppressionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListAuditSuppressionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    suppressions: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.suppressions !== undefined && data.suppressions !== null) {
                    contents.suppressions = deserializeAws_restJson1AuditSuppressionList(data.suppressions, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListAuditSuppressionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListAuditTasksCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListAuditTasksCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    tasks: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.tasks !== undefined && data.tasks !== null) {
                    contents.tasks = deserializeAws_restJson1AuditTaskMetadataList(data.tasks, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListAuditTasksCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListAuthorizersCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListAuthorizersCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    authorizers: undefined,
                    nextMarker: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.authorizers !== undefined && data.authorizers !== null) {
                    contents.authorizers = deserializeAws_restJson1Authorizers(data.authorizers, context);
                }
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListAuthorizersCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListBillingGroupsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListBillingGroupsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    billingGroups: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.billingGroups !== undefined && data.billingGroups !== null) {
                    contents.billingGroups = deserializeAws_restJson1BillingGroupNameAndArnList(data.billingGroups, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListBillingGroupsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListCACertificatesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListCACertificatesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificates: undefined,
                    nextMarker: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificates !== undefined && data.certificates !== null) {
                    contents.certificates = deserializeAws_restJson1CACertificates(data.certificates, context);
                }
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListCACertificatesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListCertificatesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListCertificatesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificates: undefined,
                    nextMarker: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificates !== undefined && data.certificates !== null) {
                    contents.certificates = deserializeAws_restJson1Certificates(data.certificates, context);
                }
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListCertificatesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListCertificatesByCACommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListCertificatesByCACommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificates: undefined,
                    nextMarker: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificates !== undefined && data.certificates !== null) {
                    contents.certificates = deserializeAws_restJson1Certificates(data.certificates, context);
                }
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListCertificatesByCACommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListCustomMetricsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListCustomMetricsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    metricNames: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.metricNames !== undefined && data.metricNames !== null) {
                    contents.metricNames = deserializeAws_restJson1MetricNames(data.metricNames, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListCustomMetricsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListDetectMitigationActionsExecutionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListDetectMitigationActionsExecutionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    actionsExecutions: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.actionsExecutions !== undefined && data.actionsExecutions !== null) {
                    contents.actionsExecutions = deserializeAws_restJson1DetectMitigationActionExecutionList(data.actionsExecutions, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListDetectMitigationActionsExecutionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListDetectMitigationActionsTasksCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListDetectMitigationActionsTasksCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    tasks: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.tasks !== undefined && data.tasks !== null) {
                    contents.tasks = deserializeAws_restJson1DetectMitigationActionsTaskSummaryList(data.tasks, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListDetectMitigationActionsTasksCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListDimensionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListDimensionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    dimensionNames: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.dimensionNames !== undefined && data.dimensionNames !== null) {
                    contents.dimensionNames = deserializeAws_restJson1DimensionNames(data.dimensionNames, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListDimensionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListDomainConfigurationsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListDomainConfigurationsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    domainConfigurations: undefined,
                    nextMarker: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.domainConfigurations !== undefined && data.domainConfigurations !== null) {
                    contents.domainConfigurations = deserializeAws_restJson1DomainConfigurations(data.domainConfigurations, context);
                }
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListDomainConfigurationsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListFleetMetricsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListFleetMetricsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    fleetMetrics: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.fleetMetrics !== undefined && data.fleetMetrics !== null) {
                    contents.fleetMetrics = deserializeAws_restJson1FleetMetricNameAndArnList(data.fleetMetrics, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListFleetMetricsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListIndicesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListIndicesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    indexNames: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.indexNames !== undefined && data.indexNames !== null) {
                    contents.indexNames = deserializeAws_restJson1IndexNamesList(data.indexNames, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListIndicesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListJobExecutionsForJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListJobExecutionsForJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    executionSummaries: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.executionSummaries !== undefined && data.executionSummaries !== null) {
                    contents.executionSummaries = deserializeAws_restJson1JobExecutionSummaryForJobList(data.executionSummaries, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListJobExecutionsForJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "ResourceNotFoundException": return [3, 4];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListJobExecutionsForThingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListJobExecutionsForThingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    executionSummaries: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.executionSummaries !== undefined && data.executionSummaries !== null) {
                    contents.executionSummaries = deserializeAws_restJson1JobExecutionSummaryForThingList(data.executionSummaries, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListJobExecutionsForThingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "ResourceNotFoundException": return [3, 4];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListJobsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListJobsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    jobs: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.jobs !== undefined && data.jobs !== null) {
                    contents.jobs = deserializeAws_restJson1JobSummaryList(data.jobs, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListJobsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "ResourceNotFoundException": return [3, 4];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListJobTemplatesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListJobTemplatesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    jobTemplates: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.jobTemplates !== undefined && data.jobTemplates !== null) {
                    contents.jobTemplates = deserializeAws_restJson1JobTemplateSummaryList(data.jobTemplates, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListJobTemplatesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListManagedJobTemplatesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListManagedJobTemplatesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    managedJobTemplates: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.managedJobTemplates !== undefined && data.managedJobTemplates !== null) {
                    contents.managedJobTemplates = deserializeAws_restJson1ManagedJobTemplatesSummaryList(data.managedJobTemplates, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListManagedJobTemplatesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalServerException": return [3, 2];
                    case "com.amazonaws.iot#InternalServerException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListMetricValuesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListMetricValuesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    metricDatumList: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.metricDatumList !== undefined && data.metricDatumList !== null) {
                    contents.metricDatumList = deserializeAws_restJson1MetricDatumList(data.metricDatumList, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListMetricValuesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListMitigationActionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListMitigationActionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    actionIdentifiers: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.actionIdentifiers !== undefined && data.actionIdentifiers !== null) {
                    contents.actionIdentifiers = deserializeAws_restJson1MitigationActionIdentifierList(data.actionIdentifiers, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListMitigationActionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListOTAUpdatesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListOTAUpdatesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    otaUpdates: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.otaUpdates !== undefined && data.otaUpdates !== null) {
                    contents.otaUpdates = deserializeAws_restJson1OTAUpdatesSummary(data.otaUpdates, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListOTAUpdatesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListOutgoingCertificatesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListOutgoingCertificatesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextMarker: undefined,
                    outgoingCertificates: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                if (data.outgoingCertificates !== undefined && data.outgoingCertificates !== null) {
                    contents.outgoingCertificates = deserializeAws_restJson1OutgoingCertificates(data.outgoingCertificates, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListOutgoingCertificatesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListPoliciesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListPoliciesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextMarker: undefined,
                    policies: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                if (data.policies !== undefined && data.policies !== null) {
                    contents.policies = deserializeAws_restJson1Policies(data.policies, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListPoliciesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListPolicyPrincipalsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListPolicyPrincipalsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextMarker: undefined,
                    principals: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                if (data.principals !== undefined && data.principals !== null) {
                    contents.principals = deserializeAws_restJson1Principals(data.principals, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListPolicyPrincipalsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListPolicyVersionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListPolicyVersionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    policyVersions: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.policyVersions !== undefined && data.policyVersions !== null) {
                    contents.policyVersions = deserializeAws_restJson1PolicyVersions(data.policyVersions, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListPolicyVersionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListPrincipalPoliciesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListPrincipalPoliciesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextMarker: undefined,
                    policies: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                if (data.policies !== undefined && data.policies !== null) {
                    contents.policies = deserializeAws_restJson1Policies(data.policies, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListPrincipalPoliciesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListPrincipalThingsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListPrincipalThingsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    things: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.things !== undefined && data.things !== null) {
                    contents.things = deserializeAws_restJson1ThingNameList(data.things, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListPrincipalThingsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListProvisioningTemplatesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListProvisioningTemplatesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    templates: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.templates !== undefined && data.templates !== null) {
                    contents.templates = deserializeAws_restJson1ProvisioningTemplateListing(data.templates, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListProvisioningTemplatesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "UnauthorizedException": return [3, 8];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListProvisioningTemplateVersionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListProvisioningTemplateVersionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    versions: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.versions !== undefined && data.versions !== null) {
                    contents.versions = deserializeAws_restJson1ProvisioningTemplateVersionListing(data.versions, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListProvisioningTemplateVersionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListRoleAliasesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListRoleAliasesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextMarker: undefined,
                    roleAliases: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                if (data.roleAliases !== undefined && data.roleAliases !== null) {
                    contents.roleAliases = deserializeAws_restJson1RoleAliases(data.roleAliases, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListRoleAliasesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListScheduledAuditsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListScheduledAuditsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    scheduledAudits: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.scheduledAudits !== undefined && data.scheduledAudits !== null) {
                    contents.scheduledAudits = deserializeAws_restJson1ScheduledAuditMetadataList(data.scheduledAudits, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListScheduledAuditsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListSecurityProfilesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListSecurityProfilesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    securityProfileIdentifiers: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.securityProfileIdentifiers !== undefined && data.securityProfileIdentifiers !== null) {
                    contents.securityProfileIdentifiers = deserializeAws_restJson1SecurityProfileIdentifiers(data.securityProfileIdentifiers, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListSecurityProfilesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListSecurityProfilesForTargetCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListSecurityProfilesForTargetCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    securityProfileTargetMappings: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.securityProfileTargetMappings !== undefined && data.securityProfileTargetMappings !== null) {
                    contents.securityProfileTargetMappings = deserializeAws_restJson1SecurityProfileTargetMappings(data.securityProfileTargetMappings, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListSecurityProfilesForTargetCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListStreamsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListStreamsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    streams: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.streams !== undefined && data.streams !== null) {
                    contents.streams = deserializeAws_restJson1StreamsSummary(data.streams, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListStreamsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListTagsForResourceCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListTagsForResourceCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    tags: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.tags !== undefined && data.tags !== null) {
                    contents.tags = deserializeAws_restJson1TagList(data.tags, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListTagsForResourceCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListTargetsForPolicyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListTargetsForPolicyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextMarker: undefined,
                    targets: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextMarker !== undefined && data.nextMarker !== null) {
                    contents.nextMarker = __expectString(data.nextMarker);
                }
                if (data.targets !== undefined && data.targets !== null) {
                    contents.targets = deserializeAws_restJson1PolicyTargets(data.targets, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListTargetsForPolicyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListTargetsForSecurityProfileCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListTargetsForSecurityProfileCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    securityProfileTargets: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.securityProfileTargets !== undefined && data.securityProfileTargets !== null) {
                    contents.securityProfileTargets = deserializeAws_restJson1SecurityProfileTargets(data.securityProfileTargets, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListTargetsForSecurityProfileCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingGroupsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingGroupsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    thingGroups: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.thingGroups !== undefined && data.thingGroups !== null) {
                    contents.thingGroups = deserializeAws_restJson1ThingGroupNameAndArnList(data.thingGroups, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingGroupsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingGroupsForThingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingGroupsForThingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    thingGroups: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.thingGroups !== undefined && data.thingGroups !== null) {
                    contents.thingGroups = deserializeAws_restJson1ThingGroupNameAndArnList(data.thingGroups, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingGroupsForThingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingPrincipalsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingPrincipalsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    principals: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.principals !== undefined && data.principals !== null) {
                    contents.principals = deserializeAws_restJson1Principals(data.principals, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingPrincipalsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingRegistrationTaskReportsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingRegistrationTaskReportsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    reportType: undefined,
                    resourceLinks: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.reportType !== undefined && data.reportType !== null) {
                    contents.reportType = __expectString(data.reportType);
                }
                if (data.resourceLinks !== undefined && data.resourceLinks !== null) {
                    contents.resourceLinks = deserializeAws_restJson1S3FileUrlList(data.resourceLinks, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingRegistrationTaskReportsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "UnauthorizedException": return [3, 8];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingRegistrationTasksCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingRegistrationTasksCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    taskIds: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.taskIds !== undefined && data.taskIds !== null) {
                    contents.taskIds = deserializeAws_restJson1TaskIdList(data.taskIds, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingRegistrationTasksCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "UnauthorizedException": return [3, 8];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    things: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.things !== undefined && data.things !== null) {
                    contents.things = deserializeAws_restJson1ThingAttributeList(data.things, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingsInBillingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingsInBillingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    things: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.things !== undefined && data.things !== null) {
                    contents.things = deserializeAws_restJson1ThingNameList(data.things, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingsInBillingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingsInThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingsInThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    things: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.things !== undefined && data.things !== null) {
                    contents.things = deserializeAws_restJson1ThingNameList(data.things, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingsInThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListThingTypesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListThingTypesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    thingTypes: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.thingTypes !== undefined && data.thingTypes !== null) {
                    contents.thingTypes = deserializeAws_restJson1ThingTypeList(data.thingTypes, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListThingTypesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListTopicRuleDestinationsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListTopicRuleDestinationsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    destinationSummaries: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.destinationSummaries !== undefined && data.destinationSummaries !== null) {
                    contents.destinationSummaries = deserializeAws_restJson1TopicRuleDestinationSummaries(data.destinationSummaries, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListTopicRuleDestinationsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "UnauthorizedException": return [3, 8];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListTopicRulesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListTopicRulesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    rules: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.rules !== undefined && data.rules !== null) {
                    contents.rules = deserializeAws_restJson1TopicRuleList(data.rules, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListTopicRulesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListV2LoggingLevelsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListV2LoggingLevelsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    logTargetConfigurations: undefined,
                    nextToken: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.logTargetConfigurations !== undefined && data.logTargetConfigurations !== null) {
                    contents.logTargetConfigurations = deserializeAws_restJson1LogTargetConfigurations(data.logTargetConfigurations, context);
                }
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListV2LoggingLevelsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "NotConfiguredException": return [3, 6];
                    case "com.amazonaws.iot#NotConfiguredException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1NotConfiguredExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ListViolationEventsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ListViolationEventsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    violationEvents: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.violationEvents !== undefined && data.violationEvents !== null) {
                    contents.violationEvents = deserializeAws_restJson1ViolationEvents(data.violationEvents, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ListViolationEventsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1PutVerificationStateOnViolationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1PutVerificationStateOnViolationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1PutVerificationStateOnViolationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1RegisterCACertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1RegisterCACertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificateArn: undefined,
                    certificateId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificateArn !== undefined && data.certificateArn !== null) {
                    contents.certificateArn = __expectString(data.certificateArn);
                }
                if (data.certificateId !== undefined && data.certificateId !== null) {
                    contents.certificateId = __expectString(data.certificateId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1RegisterCACertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateValidationException": return [3, 2];
                    case "com.amazonaws.iot#CertificateValidationException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "LimitExceededException": return [3, 8];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 8];
                    case "RegistrationCodeValidationException": return [3, 10];
                    case "com.amazonaws.iot#RegistrationCodeValidationException": return [3, 10];
                    case "ResourceAlreadyExistsException": return [3, 12];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 12];
                    case "ServiceUnavailableException": return [3, 14];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 14];
                    case "ThrottlingException": return [3, 16];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 16];
                    case "UnauthorizedException": return [3, 18];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 18];
                }
                return [3, 20];
            case 2: return [4, deserializeAws_restJson1CertificateValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1RegistrationCodeValidationExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 19: throw _d.sent();
            case 20:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1RegisterCertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1RegisterCertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificateArn: undefined,
                    certificateId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificateArn !== undefined && data.certificateArn !== null) {
                    contents.certificateArn = __expectString(data.certificateArn);
                }
                if (data.certificateId !== undefined && data.certificateId !== null) {
                    contents.certificateId = __expectString(data.certificateId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1RegisterCertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateConflictException": return [3, 2];
                    case "com.amazonaws.iot#CertificateConflictException": return [3, 2];
                    case "CertificateStateException": return [3, 4];
                    case "com.amazonaws.iot#CertificateStateException": return [3, 4];
                    case "CertificateValidationException": return [3, 6];
                    case "com.amazonaws.iot#CertificateValidationException": return [3, 6];
                    case "InternalFailureException": return [3, 8];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 8];
                    case "InvalidRequestException": return [3, 10];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 10];
                    case "ResourceAlreadyExistsException": return [3, 12];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 12];
                    case "ServiceUnavailableException": return [3, 14];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 14];
                    case "ThrottlingException": return [3, 16];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 16];
                    case "UnauthorizedException": return [3, 18];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 18];
                }
                return [3, 20];
            case 2: return [4, deserializeAws_restJson1CertificateConflictExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1CertificateStateExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1CertificateValidationExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 19: throw _d.sent();
            case 20:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1RegisterCertificateWithoutCACommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1RegisterCertificateWithoutCACommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificateArn: undefined,
                    certificateId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificateArn !== undefined && data.certificateArn !== null) {
                    contents.certificateArn = __expectString(data.certificateArn);
                }
                if (data.certificateId !== undefined && data.certificateId !== null) {
                    contents.certificateId = __expectString(data.certificateId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1RegisterCertificateWithoutCACommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateStateException": return [3, 2];
                    case "com.amazonaws.iot#CertificateStateException": return [3, 2];
                    case "CertificateValidationException": return [3, 4];
                    case "com.amazonaws.iot#CertificateValidationException": return [3, 4];
                    case "InternalFailureException": return [3, 6];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 6];
                    case "InvalidRequestException": return [3, 8];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 8];
                    case "ResourceAlreadyExistsException": return [3, 10];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 10];
                    case "ServiceUnavailableException": return [3, 12];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 12];
                    case "ThrottlingException": return [3, 14];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 14];
                    case "UnauthorizedException": return [3, 16];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1CertificateStateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1CertificateValidationExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1RegisterThingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1RegisterThingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    certificatePem: undefined,
                    resourceArns: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.certificatePem !== undefined && data.certificatePem !== null) {
                    contents.certificatePem = __expectString(data.certificatePem);
                }
                if (data.resourceArns !== undefined && data.resourceArns !== null) {
                    contents.resourceArns = deserializeAws_restJson1ResourceArns(data.resourceArns, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1RegisterThingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceRegistrationFailureException": return [3, 8];
                    case "com.amazonaws.iot#ResourceRegistrationFailureException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceRegistrationFailureExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1RejectCertificateTransferCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1RejectCertificateTransferCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1RejectCertificateTransferCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "TransferAlreadyCompletedException": return [3, 12];
                    case "com.amazonaws.iot#TransferAlreadyCompletedException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1TransferAlreadyCompletedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1RemoveThingFromBillingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1RemoveThingFromBillingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1RemoveThingFromBillingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1RemoveThingFromThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1RemoveThingFromThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1RemoveThingFromThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ReplaceTopicRuleCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ReplaceTopicRuleCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ReplaceTopicRuleCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "SqlParseException": return [3, 10];
                    case "com.amazonaws.iot#SqlParseException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1SqlParseExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1SearchIndexCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1SearchIndexCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    nextToken: undefined,
                    thingGroups: undefined,
                    things: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.nextToken !== undefined && data.nextToken !== null) {
                    contents.nextToken = __expectString(data.nextToken);
                }
                if (data.thingGroups !== undefined && data.thingGroups !== null) {
                    contents.thingGroups = deserializeAws_restJson1ThingGroupDocumentList(data.thingGroups, context);
                }
                if (data.things !== undefined && data.things !== null) {
                    contents.things = deserializeAws_restJson1ThingDocumentList(data.things, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1SearchIndexCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "IndexNotReadyException": return [3, 2];
                    case "com.amazonaws.iot#IndexNotReadyException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidQueryException": return [3, 6];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 6];
                    case "InvalidRequestException": return [3, 8];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 8];
                    case "ResourceNotFoundException": return [3, 10];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 10];
                    case "ServiceUnavailableException": return [3, 12];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 12];
                    case "ThrottlingException": return [3, 14];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 14];
                    case "UnauthorizedException": return [3, 16];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1IndexNotReadyExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1SetDefaultAuthorizerCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1SetDefaultAuthorizerCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    authorizerArn: undefined,
                    authorizerName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.authorizerArn !== undefined && data.authorizerArn !== null) {
                    contents.authorizerArn = __expectString(data.authorizerArn);
                }
                if (data.authorizerName !== undefined && data.authorizerName !== null) {
                    contents.authorizerName = __expectString(data.authorizerName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1SetDefaultAuthorizerCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceAlreadyExistsException": return [3, 6];
                    case "com.amazonaws.iot#ResourceAlreadyExistsException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1SetDefaultPolicyVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1SetDefaultPolicyVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1SetDefaultPolicyVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1SetLoggingOptionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1SetLoggingOptionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1SetLoggingOptionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1SetV2LoggingLevelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1SetV2LoggingLevelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1SetV2LoggingLevelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "NotConfiguredException": return [3, 8];
                    case "com.amazonaws.iot#NotConfiguredException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1NotConfiguredExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1SetV2LoggingOptionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1SetV2LoggingOptionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1SetV2LoggingOptionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalException": return [3, 2];
                    case "com.amazonaws.iot#InternalException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1StartAuditMitigationActionsTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1StartAuditMitigationActionsTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    taskId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.taskId !== undefined && data.taskId !== null) {
                    contents.taskId = __expectString(data.taskId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1StartAuditMitigationActionsTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "TaskAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#TaskAlreadyExistsException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1TaskAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1StartDetectMitigationActionsTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1StartDetectMitigationActionsTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    taskId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.taskId !== undefined && data.taskId !== null) {
                    contents.taskId = __expectString(data.taskId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1StartDetectMitigationActionsTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "TaskAlreadyExistsException": return [3, 8];
                    case "com.amazonaws.iot#TaskAlreadyExistsException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1TaskAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1StartOnDemandAuditTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1StartOnDemandAuditTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    taskId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.taskId !== undefined && data.taskId !== null) {
                    contents.taskId = __expectString(data.taskId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1StartOnDemandAuditTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1StartThingRegistrationTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1StartThingRegistrationTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    taskId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.taskId !== undefined && data.taskId !== null) {
                    contents.taskId = __expectString(data.taskId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1StartThingRegistrationTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                    case "UnauthorizedException": return [3, 8];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1StopThingRegistrationTaskCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1StopThingRegistrationTaskCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1StopThingRegistrationTaskCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1TagResourceCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1TagResourceCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1TagResourceCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1TestAuthorizationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1TestAuthorizationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    authResults: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.authResults !== undefined && data.authResults !== null) {
                    contents.authResults = deserializeAws_restJson1AuthResults(data.authResults, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1TestAuthorizationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1TestInvokeAuthorizerCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1TestInvokeAuthorizerCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    disconnectAfterInSeconds: undefined,
                    isAuthenticated: undefined,
                    policyDocuments: undefined,
                    principalId: undefined,
                    refreshAfterInSeconds: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.disconnectAfterInSeconds !== undefined && data.disconnectAfterInSeconds !== null) {
                    contents.disconnectAfterInSeconds = __expectInt32(data.disconnectAfterInSeconds);
                }
                if (data.isAuthenticated !== undefined && data.isAuthenticated !== null) {
                    contents.isAuthenticated = __expectBoolean(data.isAuthenticated);
                }
                if (data.policyDocuments !== undefined && data.policyDocuments !== null) {
                    contents.policyDocuments = deserializeAws_restJson1PolicyDocuments(data.policyDocuments, context);
                }
                if (data.principalId !== undefined && data.principalId !== null) {
                    contents.principalId = __expectString(data.principalId);
                }
                if (data.refreshAfterInSeconds !== undefined && data.refreshAfterInSeconds !== null) {
                    contents.refreshAfterInSeconds = __expectInt32(data.refreshAfterInSeconds);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1TestInvokeAuthorizerCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "InvalidResponseException": return [3, 6];
                    case "com.amazonaws.iot#InvalidResponseException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidResponseExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1TransferCertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1TransferCertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    transferredCertificateArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.transferredCertificateArn !== undefined && data.transferredCertificateArn !== null) {
                    contents.transferredCertificateArn = __expectString(data.transferredCertificateArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1TransferCertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateStateException": return [3, 2];
                    case "com.amazonaws.iot#CertificateStateException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "TransferConflictException": return [3, 14];
                    case "com.amazonaws.iot#TransferConflictException": return [3, 14];
                    case "UnauthorizedException": return [3, 16];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1CertificateStateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1TransferConflictExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UntagResourceCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UntagResourceCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UntagResourceCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateAccountAuditConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateAccountAuditConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateAccountAuditConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateAuditSuppressionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateAuditSuppressionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateAuditSuppressionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateAuthorizerCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateAuthorizerCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    authorizerArn: undefined,
                    authorizerName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.authorizerArn !== undefined && data.authorizerArn !== null) {
                    contents.authorizerArn = __expectString(data.authorizerArn);
                }
                if (data.authorizerName !== undefined && data.authorizerName !== null) {
                    contents.authorizerName = __expectString(data.authorizerName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateAuthorizerCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "LimitExceededException": return [3, 6];
                    case "com.amazonaws.iot#LimitExceededException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateBillingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateBillingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateBillingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "VersionConflictException": return [3, 10];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateCACertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateCACertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateCACertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateCertificateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateCertificateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateCertificateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateStateException": return [3, 2];
                    case "com.amazonaws.iot#CertificateStateException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1CertificateStateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateCustomMetricCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateCustomMetricCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    creationDate: undefined,
                    displayName: undefined,
                    lastModifiedDate: undefined,
                    metricArn: undefined,
                    metricName: undefined,
                    metricType: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.displayName !== undefined && data.displayName !== null) {
                    contents.displayName = __expectString(data.displayName);
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.metricArn !== undefined && data.metricArn !== null) {
                    contents.metricArn = __expectString(data.metricArn);
                }
                if (data.metricName !== undefined && data.metricName !== null) {
                    contents.metricName = __expectString(data.metricName);
                }
                if (data.metricType !== undefined && data.metricType !== null) {
                    contents.metricType = __expectString(data.metricType);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateCustomMetricCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateDimensionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateDimensionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    arn: undefined,
                    creationDate: undefined,
                    lastModifiedDate: undefined,
                    name: undefined,
                    stringValues: undefined,
                    type: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.arn !== undefined && data.arn !== null) {
                    contents.arn = __expectString(data.arn);
                }
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.name !== undefined && data.name !== null) {
                    contents.name = __expectString(data.name);
                }
                if (data.stringValues !== undefined && data.stringValues !== null) {
                    contents.stringValues = deserializeAws_restJson1DimensionStringValues(data.stringValues, context);
                }
                if (data.type !== undefined && data.type !== null) {
                    contents.type = __expectString(data.type);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateDimensionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateDomainConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateDomainConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    domainConfigurationArn: undefined,
                    domainConfigurationName: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.domainConfigurationArn !== undefined && data.domainConfigurationArn !== null) {
                    contents.domainConfigurationArn = __expectString(data.domainConfigurationArn);
                }
                if (data.domainConfigurationName !== undefined && data.domainConfigurationName !== null) {
                    contents.domainConfigurationName = __expectString(data.domainConfigurationName);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateDomainConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "CertificateValidationException": return [3, 2];
                    case "com.amazonaws.iot#CertificateValidationException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ServiceUnavailableException": return [3, 10];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 12];
                    case "UnauthorizedException": return [3, 14];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1CertificateValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateDynamicThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateDynamicThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateDynamicThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidQueryException": return [3, 4];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "VersionConflictException": return [3, 12];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateEventConfigurationsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateEventConfigurationsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateEventConfigurationsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateFleetMetricCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateFleetMetricCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateFleetMetricCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "IndexNotReadyException": return [3, 2];
                    case "com.amazonaws.iot#IndexNotReadyException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidAggregationException": return [3, 6];
                    case "com.amazonaws.iot#InvalidAggregationException": return [3, 6];
                    case "InvalidQueryException": return [3, 8];
                    case "com.amazonaws.iot#InvalidQueryException": return [3, 8];
                    case "InvalidRequestException": return [3, 10];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 10];
                    case "ResourceNotFoundException": return [3, 12];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 12];
                    case "ServiceUnavailableException": return [3, 14];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 14];
                    case "ThrottlingException": return [3, 16];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 16];
                    case "UnauthorizedException": return [3, 18];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 18];
                    case "VersionConflictException": return [3, 20];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 20];
                }
                return [3, 22];
            case 2: return [4, deserializeAws_restJson1IndexNotReadyExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidAggregationExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidQueryExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 19: throw _d.sent();
            case 20: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 21: throw _d.sent();
            case 22:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateIndexingConfigurationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateIndexingConfigurationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateIndexingConfigurationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidRequestException": return [3, 2];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 2];
                    case "ResourceNotFoundException": return [3, 4];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 4];
                    case "ServiceUnavailableException": return [3, 6];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateMitigationActionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateMitigationActionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    actionArn: undefined,
                    actionId: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.actionArn !== undefined && data.actionArn !== null) {
                    contents.actionArn = __expectString(data.actionArn);
                }
                if (data.actionId !== undefined && data.actionId !== null) {
                    contents.actionId = __expectString(data.actionId);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateMitigationActionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateProvisioningTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateProvisioningTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateProvisioningTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalFailureException": return [3, 4];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ResourceNotFoundException": return [3, 8];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateRoleAliasCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateRoleAliasCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    roleAlias: undefined,
                    roleAliasArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.roleAlias !== undefined && data.roleAlias !== null) {
                    contents.roleAlias = __expectString(data.roleAlias);
                }
                if (data.roleAliasArn !== undefined && data.roleAliasArn !== null) {
                    contents.roleAliasArn = __expectString(data.roleAliasArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateRoleAliasCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateScheduledAuditCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateScheduledAuditCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    scheduledAuditArn: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.scheduledAuditArn !== undefined && data.scheduledAuditArn !== null) {
                    contents.scheduledAuditArn = __expectString(data.scheduledAuditArn);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateScheduledAuditCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateSecurityProfileCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateSecurityProfileCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    additionalMetricsToRetain: undefined,
                    additionalMetricsToRetainV2: undefined,
                    alertTargets: undefined,
                    behaviors: undefined,
                    creationDate: undefined,
                    lastModifiedDate: undefined,
                    securityProfileArn: undefined,
                    securityProfileDescription: undefined,
                    securityProfileName: undefined,
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.additionalMetricsToRetain !== undefined && data.additionalMetricsToRetain !== null) {
                    contents.additionalMetricsToRetain = deserializeAws_restJson1AdditionalMetricsToRetainList(data.additionalMetricsToRetain, context);
                }
                if (data.additionalMetricsToRetainV2 !== undefined && data.additionalMetricsToRetainV2 !== null) {
                    contents.additionalMetricsToRetainV2 = deserializeAws_restJson1AdditionalMetricsToRetainV2List(data.additionalMetricsToRetainV2, context);
                }
                if (data.alertTargets !== undefined && data.alertTargets !== null) {
                    contents.alertTargets = deserializeAws_restJson1AlertTargets(data.alertTargets, context);
                }
                if (data.behaviors !== undefined && data.behaviors !== null) {
                    contents.behaviors = deserializeAws_restJson1Behaviors(data.behaviors, context);
                }
                if (data.creationDate !== undefined && data.creationDate !== null) {
                    contents.creationDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.creationDate)));
                }
                if (data.lastModifiedDate !== undefined && data.lastModifiedDate !== null) {
                    contents.lastModifiedDate = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastModifiedDate)));
                }
                if (data.securityProfileArn !== undefined && data.securityProfileArn !== null) {
                    contents.securityProfileArn = __expectString(data.securityProfileArn);
                }
                if (data.securityProfileDescription !== undefined && data.securityProfileDescription !== null) {
                    contents.securityProfileDescription = __expectString(data.securityProfileDescription);
                }
                if (data.securityProfileName !== undefined && data.securityProfileName !== null) {
                    contents.securityProfileName = __expectString(data.securityProfileName);
                }
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateSecurityProfileCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "VersionConflictException": return [3, 10];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateStreamCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateStreamCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    description: undefined,
                    streamArn: undefined,
                    streamId: undefined,
                    streamVersion: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.description !== undefined && data.description !== null) {
                    contents.description = __expectString(data.description);
                }
                if (data.streamArn !== undefined && data.streamArn !== null) {
                    contents.streamArn = __expectString(data.streamArn);
                }
                if (data.streamId !== undefined && data.streamId !== null) {
                    contents.streamId = __expectString(data.streamId);
                }
                if (data.streamVersion !== undefined && data.streamVersion !== null) {
                    contents.streamVersion = __expectInt32(data.streamVersion);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateStreamCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateThingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateThingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateThingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "ThrottlingException": return [3, 10];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 10];
                    case "UnauthorizedException": return [3, 12];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 12];
                    case "VersionConflictException": return [3, 14];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 14];
                }
                return [3, 16];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateThingGroupCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateThingGroupCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    version: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.version !== undefined && data.version !== null) {
                    contents.version = __expectLong(data.version);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateThingGroupCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                    case "VersionConflictException": return [3, 10];
                    case "com.amazonaws.iot#VersionConflictException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1VersionConflictExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateThingGroupsForThingCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateThingGroupsForThingCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateThingGroupsForThingCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ResourceNotFoundException": return [3, 6];
                    case "com.amazonaws.iot#ResourceNotFoundException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1UpdateTopicRuleDestinationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1UpdateTopicRuleDestinationCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                };
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1UpdateTopicRuleDestinationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConflictingResourceUpdateException": return [3, 2];
                    case "com.amazonaws.iot#ConflictingResourceUpdateException": return [3, 2];
                    case "InternalException": return [3, 4];
                    case "com.amazonaws.iot#InternalException": return [3, 4];
                    case "InvalidRequestException": return [3, 6];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 6];
                    case "ServiceUnavailableException": return [3, 8];
                    case "com.amazonaws.iot#ServiceUnavailableException": return [3, 8];
                    case "UnauthorizedException": return [3, 10];
                    case "com.amazonaws.iot#UnauthorizedException": return [3, 10];
                }
                return [3, 12];
            case 2: return [4, deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InternalExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
export var deserializeAws_restJson1ValidateSecurityProfileBehaviorsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1ValidateSecurityProfileBehaviorsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    valid: undefined,
                    validationErrors: undefined,
                };
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [_b.apply(void 0, [_c.sent()]), "body"]);
                if (data.valid !== undefined && data.valid !== null) {
                    contents.valid = __expectBoolean(data.valid);
                }
                if (data.validationErrors !== undefined && data.validationErrors !== null) {
                    contents.validationErrors = deserializeAws_restJson1ValidationErrors(data.validationErrors, context);
                }
                return [2, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1ValidateSecurityProfileBehaviorsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalFailureException": return [3, 2];
                    case "com.amazonaws.iot#InternalFailureException": return [3, 2];
                    case "InvalidRequestException": return [3, 4];
                    case "com.amazonaws.iot#InvalidRequestException": return [3, 4];
                    case "ThrottlingException": return [3, 6];
                    case "com.amazonaws.iot#ThrottlingException": return [3, 6];
                }
                return [3, 8];
            case 2: return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1InvalidRequestExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8:
                parsedBody = parsedOutput.body;
                response = new __BaseException({
                    name: parsedBody.code || parsedBody.Code || errorCode,
                    $fault: "client",
                    $metadata: deserializeMetadata(output),
                });
                throw __decorateServiceException(response, parsedBody);
        }
    });
}); };
var deserializeAws_restJson1CertificateConflictExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new CertificateConflictException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1CertificateStateExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new CertificateStateException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1CertificateValidationExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new CertificateValidationException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1ConflictExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new ConflictException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1ConflictingResourceUpdateExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new ConflictingResourceUpdateException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1DeleteConflictExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new DeleteConflictException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1IndexNotReadyExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new IndexNotReadyException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InternalExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new InternalException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InternalFailureExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new InternalFailureException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InternalServerExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new InternalServerException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InvalidAggregationExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new InvalidAggregationException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InvalidQueryExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new InvalidQueryException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InvalidRequestExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new InvalidRequestException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InvalidResponseExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new InvalidResponseException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InvalidStateTransitionExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new InvalidStateTransitionException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1LimitExceededExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new LimitExceededException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1MalformedPolicyExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new MalformedPolicyException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1NotConfiguredExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new NotConfiguredException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1RegistrationCodeValidationExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new RegistrationCodeValidationException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1ResourceAlreadyExistsExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        if (data.resourceArn !== undefined && data.resourceArn !== null) {
            contents.resourceArn = __expectString(data.resourceArn);
        }
        if (data.resourceId !== undefined && data.resourceId !== null) {
            contents.resourceId = __expectString(data.resourceId);
        }
        exception = new ResourceAlreadyExistsException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new ResourceNotFoundException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1ResourceRegistrationFailureExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new ResourceRegistrationFailureException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1ServiceUnavailableExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new ServiceUnavailableException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1SqlParseExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new SqlParseException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1TaskAlreadyExistsExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new TaskAlreadyExistsException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1ThrottlingExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new ThrottlingException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1TransferAlreadyCompletedExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new TransferAlreadyCompletedException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1TransferConflictExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new TransferConflictException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1UnauthorizedExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new UnauthorizedException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1VersionConflictExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new VersionConflictException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1VersionsLimitExceededExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = {};
        data = parsedOutput.body;
        if (data.message !== undefined && data.message !== null) {
            contents.message = __expectString(data.message);
        }
        exception = new VersionsLimitExceededException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var serializeAws_restJson1AbortConfig = function (input, context) {
    return __assign({}, (input.criteriaList !== undefined &&
        input.criteriaList !== null && {
        criteriaList: serializeAws_restJson1AbortCriteriaList(input.criteriaList, context),
    }));
};
var serializeAws_restJson1AbortCriteria = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.action !== undefined && input.action !== null && { action: input.action })), (input.failureType !== undefined && input.failureType !== null && { failureType: input.failureType })), (input.minNumberOfExecutedThings !== undefined &&
        input.minNumberOfExecutedThings !== null && { minNumberOfExecutedThings: input.minNumberOfExecutedThings })), (input.thresholdPercentage !== undefined &&
        input.thresholdPercentage !== null && { thresholdPercentage: __serializeFloat(input.thresholdPercentage) }));
};
var serializeAws_restJson1AbortCriteriaList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1AbortCriteria(entry, context);
    });
};
var serializeAws_restJson1Action = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.cloudwatchAlarm !== undefined &&
        input.cloudwatchAlarm !== null && {
        cloudwatchAlarm: serializeAws_restJson1CloudwatchAlarmAction(input.cloudwatchAlarm, context),
    })), (input.cloudwatchLogs !== undefined &&
        input.cloudwatchLogs !== null && {
        cloudwatchLogs: serializeAws_restJson1CloudwatchLogsAction(input.cloudwatchLogs, context),
    })), (input.cloudwatchMetric !== undefined &&
        input.cloudwatchMetric !== null && {
        cloudwatchMetric: serializeAws_restJson1CloudwatchMetricAction(input.cloudwatchMetric, context),
    })), (input.dynamoDB !== undefined &&
        input.dynamoDB !== null && { dynamoDB: serializeAws_restJson1DynamoDBAction(input.dynamoDB, context) })), (input.dynamoDBv2 !== undefined &&
        input.dynamoDBv2 !== null && { dynamoDBv2: serializeAws_restJson1DynamoDBv2Action(input.dynamoDBv2, context) })), (input.elasticsearch !== undefined &&
        input.elasticsearch !== null && {
        elasticsearch: serializeAws_restJson1ElasticsearchAction(input.elasticsearch, context),
    })), (input.firehose !== undefined &&
        input.firehose !== null && { firehose: serializeAws_restJson1FirehoseAction(input.firehose, context) })), (input.http !== undefined &&
        input.http !== null && { http: serializeAws_restJson1HttpAction(input.http, context) })), (input.iotAnalytics !== undefined &&
        input.iotAnalytics !== null && {
        iotAnalytics: serializeAws_restJson1IotAnalyticsAction(input.iotAnalytics, context),
    })), (input.iotEvents !== undefined &&
        input.iotEvents !== null && { iotEvents: serializeAws_restJson1IotEventsAction(input.iotEvents, context) })), (input.iotSiteWise !== undefined &&
        input.iotSiteWise !== null && {
        iotSiteWise: serializeAws_restJson1IotSiteWiseAction(input.iotSiteWise, context),
    })), (input.kafka !== undefined &&
        input.kafka !== null && { kafka: serializeAws_restJson1KafkaAction(input.kafka, context) })), (input.kinesis !== undefined &&
        input.kinesis !== null && { kinesis: serializeAws_restJson1KinesisAction(input.kinesis, context) })), (input.lambda !== undefined &&
        input.lambda !== null && { lambda: serializeAws_restJson1LambdaAction(input.lambda, context) })), (input.openSearch !== undefined &&
        input.openSearch !== null && { openSearch: serializeAws_restJson1OpenSearchAction(input.openSearch, context) })), (input.republish !== undefined &&
        input.republish !== null && { republish: serializeAws_restJson1RepublishAction(input.republish, context) })), (input.s3 !== undefined && input.s3 !== null && { s3: serializeAws_restJson1S3Action(input.s3, context) })), (input.salesforce !== undefined &&
        input.salesforce !== null && { salesforce: serializeAws_restJson1SalesforceAction(input.salesforce, context) })), (input.sns !== undefined && input.sns !== null && { sns: serializeAws_restJson1SnsAction(input.sns, context) })), (input.sqs !== undefined && input.sqs !== null && { sqs: serializeAws_restJson1SqsAction(input.sqs, context) })), (input.stepFunctions !== undefined &&
        input.stepFunctions !== null && {
        stepFunctions: serializeAws_restJson1StepFunctionsAction(input.stepFunctions, context),
    })), (input.timestream !== undefined &&
        input.timestream !== null && { timestream: serializeAws_restJson1TimestreamAction(input.timestream, context) }));
};
var serializeAws_restJson1ActionList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1Action(entry, context);
    });
};
var serializeAws_restJson1AdditionalMetricsToRetainList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1AdditionalMetricsToRetainV2List = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1MetricToRetain(entry, context);
    });
};
var serializeAws_restJson1AdditionalParameterMap = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1AddThingsToThingGroupParams = function (input, context) {
    return __assign(__assign({}, (input.overrideDynamicGroups !== undefined &&
        input.overrideDynamicGroups !== null && { overrideDynamicGroups: input.overrideDynamicGroups })), (input.thingGroupNames !== undefined &&
        input.thingGroupNames !== null && {
        thingGroupNames: serializeAws_restJson1ThingGroupNames(input.thingGroupNames, context),
    }));
};
var serializeAws_restJson1AggregationType = function (input, context) {
    return __assign(__assign({}, (input.name !== undefined && input.name !== null && { name: input.name })), (input.values !== undefined &&
        input.values !== null && { values: serializeAws_restJson1AggregationTypeValues(input.values, context) }));
};
var serializeAws_restJson1AggregationTypeValues = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1AlertTarget = function (input, context) {
    return __assign(__assign({}, (input.alertTargetArn !== undefined &&
        input.alertTargetArn !== null && { alertTargetArn: input.alertTargetArn })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1AlertTargets = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1AlertTarget(value, context), _b));
    }, {});
};
var serializeAws_restJson1AssetPropertyTimestamp = function (input, context) {
    return __assign(__assign({}, (input.offsetInNanos !== undefined && input.offsetInNanos !== null && { offsetInNanos: input.offsetInNanos })), (input.timeInSeconds !== undefined && input.timeInSeconds !== null && { timeInSeconds: input.timeInSeconds }));
};
var serializeAws_restJson1AssetPropertyValue = function (input, context) {
    return __assign(__assign(__assign({}, (input.quality !== undefined && input.quality !== null && { quality: input.quality })), (input.timestamp !== undefined &&
        input.timestamp !== null && {
        timestamp: serializeAws_restJson1AssetPropertyTimestamp(input.timestamp, context),
    })), (input.value !== undefined &&
        input.value !== null && { value: serializeAws_restJson1AssetPropertyVariant(input.value, context) }));
};
var serializeAws_restJson1AssetPropertyValueList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1AssetPropertyValue(entry, context);
    });
};
var serializeAws_restJson1AssetPropertyVariant = function (input, context) {
    return AssetPropertyVariant.visit(input, {
        booleanValue: function (value) { return ({ booleanValue: value }); },
        doubleValue: function (value) { return ({ doubleValue: value }); },
        integerValue: function (value) { return ({ integerValue: value }); },
        stringValue: function (value) { return ({ stringValue: value }); },
        _: function (name, value) { return ({ name: value }); },
    });
};
var serializeAws_restJson1AttributePayload = function (input, context) {
    return __assign(__assign({}, (input.attributes !== undefined &&
        input.attributes !== null && { attributes: serializeAws_restJson1Attributes(input.attributes, context) })), (input.merge !== undefined && input.merge !== null && { merge: input.merge }));
};
var serializeAws_restJson1Attributes = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1AttributesMap = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1AuditCheckConfiguration = function (input, context) {
    return __assign({}, (input.enabled !== undefined && input.enabled !== null && { enabled: input.enabled }));
};
var serializeAws_restJson1AuditCheckConfigurations = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1AuditCheckConfiguration(value, context), _b));
    }, {});
};
var serializeAws_restJson1AuditCheckToActionsMapping = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1MitigationActionNameList(value, context), _b));
    }, {});
};
var serializeAws_restJson1AuditCheckToReasonCodeFilter = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1ReasonForNonComplianceCodes(value, context), _b));
    }, {});
};
var serializeAws_restJson1AuditMitigationActionsTaskTarget = function (input, context) {
    return __assign(__assign(__assign({}, (input.auditCheckToReasonCodeFilter !== undefined &&
        input.auditCheckToReasonCodeFilter !== null && {
        auditCheckToReasonCodeFilter: serializeAws_restJson1AuditCheckToReasonCodeFilter(input.auditCheckToReasonCodeFilter, context),
    })), (input.auditTaskId !== undefined && input.auditTaskId !== null && { auditTaskId: input.auditTaskId })), (input.findingIds !== undefined &&
        input.findingIds !== null && { findingIds: serializeAws_restJson1FindingIds(input.findingIds, context) }));
};
var serializeAws_restJson1AuditNotificationTarget = function (input, context) {
    return __assign(__assign(__assign({}, (input.enabled !== undefined && input.enabled !== null && { enabled: input.enabled })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.targetArn !== undefined && input.targetArn !== null && { targetArn: input.targetArn }));
};
var serializeAws_restJson1AuditNotificationTargetConfigurations = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1AuditNotificationTarget(value, context), _b));
    }, {});
};
var serializeAws_restJson1AuthInfo = function (input, context) {
    return __assign(__assign({}, (input.actionType !== undefined && input.actionType !== null && { actionType: input.actionType })), (input.resources !== undefined &&
        input.resources !== null && { resources: serializeAws_restJson1Resources(input.resources, context) }));
};
var serializeAws_restJson1AuthInfos = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1AuthInfo(entry, context);
    });
};
var serializeAws_restJson1AuthorizerConfig = function (input, context) {
    return __assign(__assign({}, (input.allowAuthorizerOverride !== undefined &&
        input.allowAuthorizerOverride !== null && { allowAuthorizerOverride: input.allowAuthorizerOverride })), (input.defaultAuthorizerName !== undefined &&
        input.defaultAuthorizerName !== null && { defaultAuthorizerName: input.defaultAuthorizerName }));
};
var serializeAws_restJson1AwsJobAbortConfig = function (input, context) {
    return __assign({}, (input.abortCriteriaList !== undefined &&
        input.abortCriteriaList !== null && {
        abortCriteriaList: serializeAws_restJson1AwsJobAbortCriteriaList(input.abortCriteriaList, context),
    }));
};
var serializeAws_restJson1AwsJobAbortCriteria = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.action !== undefined && input.action !== null && { action: input.action })), (input.failureType !== undefined && input.failureType !== null && { failureType: input.failureType })), (input.minNumberOfExecutedThings !== undefined &&
        input.minNumberOfExecutedThings !== null && { minNumberOfExecutedThings: input.minNumberOfExecutedThings })), (input.thresholdPercentage !== undefined &&
        input.thresholdPercentage !== null && { thresholdPercentage: __serializeFloat(input.thresholdPercentage) }));
};
var serializeAws_restJson1AwsJobAbortCriteriaList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1AwsJobAbortCriteria(entry, context);
    });
};
var serializeAws_restJson1AwsJobExecutionsRolloutConfig = function (input, context) {
    return __assign(__assign({}, (input.exponentialRate !== undefined &&
        input.exponentialRate !== null && {
        exponentialRate: serializeAws_restJson1AwsJobExponentialRolloutRate(input.exponentialRate, context),
    })), (input.maximumPerMinute !== undefined &&
        input.maximumPerMinute !== null && { maximumPerMinute: input.maximumPerMinute }));
};
var serializeAws_restJson1AwsJobExponentialRolloutRate = function (input, context) {
    return __assign(__assign(__assign({}, (input.baseRatePerMinute !== undefined &&
        input.baseRatePerMinute !== null && { baseRatePerMinute: input.baseRatePerMinute })), (input.incrementFactor !== undefined &&
        input.incrementFactor !== null && { incrementFactor: __serializeFloat(input.incrementFactor) })), (input.rateIncreaseCriteria !== undefined &&
        input.rateIncreaseCriteria !== null && {
        rateIncreaseCriteria: serializeAws_restJson1AwsJobRateIncreaseCriteria(input.rateIncreaseCriteria, context),
    }));
};
var serializeAws_restJson1AwsJobPresignedUrlConfig = function (input, context) {
    return __assign({}, (input.expiresInSec !== undefined && input.expiresInSec !== null && { expiresInSec: input.expiresInSec }));
};
var serializeAws_restJson1AwsJobRateIncreaseCriteria = function (input, context) {
    return __assign(__assign({}, (input.numberOfNotifiedThings !== undefined &&
        input.numberOfNotifiedThings !== null && { numberOfNotifiedThings: input.numberOfNotifiedThings })), (input.numberOfSucceededThings !== undefined &&
        input.numberOfSucceededThings !== null && { numberOfSucceededThings: input.numberOfSucceededThings }));
};
var serializeAws_restJson1AwsJobTimeoutConfig = function (input, context) {
    return __assign({}, (input.inProgressTimeoutInMinutes !== undefined &&
        input.inProgressTimeoutInMinutes !== null && { inProgressTimeoutInMinutes: input.inProgressTimeoutInMinutes }));
};
var serializeAws_restJson1Behavior = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.criteria !== undefined &&
        input.criteria !== null && { criteria: serializeAws_restJson1BehaviorCriteria(input.criteria, context) })), (input.metric !== undefined && input.metric !== null && { metric: input.metric })), (input.metricDimension !== undefined &&
        input.metricDimension !== null && {
        metricDimension: serializeAws_restJson1MetricDimension(input.metricDimension, context),
    })), (input.name !== undefined && input.name !== null && { name: input.name })), (input.suppressAlerts !== undefined &&
        input.suppressAlerts !== null && { suppressAlerts: input.suppressAlerts }));
};
var serializeAws_restJson1BehaviorCriteria = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.comparisonOperator !== undefined &&
        input.comparisonOperator !== null && { comparisonOperator: input.comparisonOperator })), (input.consecutiveDatapointsToAlarm !== undefined &&
        input.consecutiveDatapointsToAlarm !== null && {
        consecutiveDatapointsToAlarm: input.consecutiveDatapointsToAlarm,
    })), (input.consecutiveDatapointsToClear !== undefined &&
        input.consecutiveDatapointsToClear !== null && {
        consecutiveDatapointsToClear: input.consecutiveDatapointsToClear,
    })), (input.durationSeconds !== undefined &&
        input.durationSeconds !== null && { durationSeconds: input.durationSeconds })), (input.mlDetectionConfig !== undefined &&
        input.mlDetectionConfig !== null && {
        mlDetectionConfig: serializeAws_restJson1MachineLearningDetectionConfig(input.mlDetectionConfig, context),
    })), (input.statisticalThreshold !== undefined &&
        input.statisticalThreshold !== null && {
        statisticalThreshold: serializeAws_restJson1StatisticalThreshold(input.statisticalThreshold, context),
    })), (input.value !== undefined &&
        input.value !== null && { value: serializeAws_restJson1MetricValue(input.value, context) }));
};
var serializeAws_restJson1Behaviors = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1Behavior(entry, context);
    });
};
var serializeAws_restJson1BillingGroupProperties = function (input, context) {
    return __assign({}, (input.billingGroupDescription !== undefined &&
        input.billingGroupDescription !== null && { billingGroupDescription: input.billingGroupDescription }));
};
var serializeAws_restJson1BucketsAggregationType = function (input, context) {
    return __assign({}, (input.termsAggregation !== undefined &&
        input.termsAggregation !== null && {
        termsAggregation: serializeAws_restJson1TermsAggregation(input.termsAggregation, context),
    }));
};
var serializeAws_restJson1Cidrs = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1ClientProperties = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1CloudwatchAlarmAction = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.alarmName !== undefined && input.alarmName !== null && { alarmName: input.alarmName })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.stateReason !== undefined && input.stateReason !== null && { stateReason: input.stateReason })), (input.stateValue !== undefined && input.stateValue !== null && { stateValue: input.stateValue }));
};
var serializeAws_restJson1CloudwatchLogsAction = function (input, context) {
    return __assign(__assign({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1CloudwatchMetricAction = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.metricName !== undefined && input.metricName !== null && { metricName: input.metricName })), (input.metricNamespace !== undefined &&
        input.metricNamespace !== null && { metricNamespace: input.metricNamespace })), (input.metricTimestamp !== undefined &&
        input.metricTimestamp !== null && { metricTimestamp: input.metricTimestamp })), (input.metricUnit !== undefined && input.metricUnit !== null && { metricUnit: input.metricUnit })), (input.metricValue !== undefined && input.metricValue !== null && { metricValue: input.metricValue })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1CodeSigning = function (input, context) {
    return __assign(__assign(__assign({}, (input.awsSignerJobId !== undefined &&
        input.awsSignerJobId !== null && { awsSignerJobId: input.awsSignerJobId })), (input.customCodeSigning !== undefined &&
        input.customCodeSigning !== null && {
        customCodeSigning: serializeAws_restJson1CustomCodeSigning(input.customCodeSigning, context),
    })), (input.startSigningJobParameter !== undefined &&
        input.startSigningJobParameter !== null && {
        startSigningJobParameter: serializeAws_restJson1StartSigningJobParameter(input.startSigningJobParameter, context),
    }));
};
var serializeAws_restJson1CodeSigningCertificateChain = function (input, context) {
    return __assign(__assign({}, (input.certificateName !== undefined &&
        input.certificateName !== null && { certificateName: input.certificateName })), (input.inlineDocument !== undefined &&
        input.inlineDocument !== null && { inlineDocument: input.inlineDocument }));
};
var serializeAws_restJson1CodeSigningSignature = function (input, context) {
    return __assign({}, (input.inlineDocument !== undefined &&
        input.inlineDocument !== null && { inlineDocument: context.base64Encoder(input.inlineDocument) }));
};
var serializeAws_restJson1Configuration = function (input, context) {
    return __assign({}, (input.Enabled !== undefined && input.Enabled !== null && { Enabled: input.Enabled }));
};
var serializeAws_restJson1CustomCodeSigning = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.certificateChain !== undefined &&
        input.certificateChain !== null && {
        certificateChain: serializeAws_restJson1CodeSigningCertificateChain(input.certificateChain, context),
    })), (input.hashAlgorithm !== undefined && input.hashAlgorithm !== null && { hashAlgorithm: input.hashAlgorithm })), (input.signature !== undefined &&
        input.signature !== null && { signature: serializeAws_restJson1CodeSigningSignature(input.signature, context) })), (input.signatureAlgorithm !== undefined &&
        input.signatureAlgorithm !== null && { signatureAlgorithm: input.signatureAlgorithm }));
};
var serializeAws_restJson1Destination = function (input, context) {
    return __assign({}, (input.s3Destination !== undefined &&
        input.s3Destination !== null && {
        s3Destination: serializeAws_restJson1S3Destination(input.s3Destination, context),
    }));
};
var serializeAws_restJson1DetailsMap = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1DetectMitigationActionsTaskTarget = function (input, context) {
    return __assign(__assign(__assign({}, (input.behaviorName !== undefined && input.behaviorName !== null && { behaviorName: input.behaviorName })), (input.securityProfileName !== undefined &&
        input.securityProfileName !== null && { securityProfileName: input.securityProfileName })), (input.violationIds !== undefined &&
        input.violationIds !== null && {
        violationIds: serializeAws_restJson1TargetViolationIdsForDetectMitigationActions(input.violationIds, context),
    }));
};
var serializeAws_restJson1DetectMitigationActionsToExecuteList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1DimensionStringValues = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1DynamoDBAction = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.hashKeyField !== undefined && input.hashKeyField !== null && { hashKeyField: input.hashKeyField })), (input.hashKeyType !== undefined && input.hashKeyType !== null && { hashKeyType: input.hashKeyType })), (input.hashKeyValue !== undefined && input.hashKeyValue !== null && { hashKeyValue: input.hashKeyValue })), (input.operation !== undefined && input.operation !== null && { operation: input.operation })), (input.payloadField !== undefined && input.payloadField !== null && { payloadField: input.payloadField })), (input.rangeKeyField !== undefined && input.rangeKeyField !== null && { rangeKeyField: input.rangeKeyField })), (input.rangeKeyType !== undefined && input.rangeKeyType !== null && { rangeKeyType: input.rangeKeyType })), (input.rangeKeyValue !== undefined && input.rangeKeyValue !== null && { rangeKeyValue: input.rangeKeyValue })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.tableName !== undefined && input.tableName !== null && { tableName: input.tableName }));
};
var serializeAws_restJson1DynamoDBv2Action = function (input, context) {
    return __assign(__assign({}, (input.putItem !== undefined &&
        input.putItem !== null && { putItem: serializeAws_restJson1PutItemInput(input.putItem, context) })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1ElasticsearchAction = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.endpoint !== undefined && input.endpoint !== null && { endpoint: input.endpoint })), (input.id !== undefined && input.id !== null && { id: input.id })), (input.index !== undefined && input.index !== null && { index: input.index })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.type !== undefined && input.type !== null && { type: input.type }));
};
var serializeAws_restJson1EnableIoTLoggingParams = function (input, context) {
    return __assign(__assign({}, (input.logLevel !== undefined && input.logLevel !== null && { logLevel: input.logLevel })), (input.roleArnForLogging !== undefined &&
        input.roleArnForLogging !== null && { roleArnForLogging: input.roleArnForLogging }));
};
var serializeAws_restJson1EventConfigurations = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1Configuration(value, context), _b));
    }, {});
};
var serializeAws_restJson1ExponentialRolloutRate = function (input, context) {
    return __assign(__assign(__assign({}, (input.baseRatePerMinute !== undefined &&
        input.baseRatePerMinute !== null && { baseRatePerMinute: input.baseRatePerMinute })), (input.incrementFactor !== undefined &&
        input.incrementFactor !== null && { incrementFactor: __serializeFloat(input.incrementFactor) })), (input.rateIncreaseCriteria !== undefined &&
        input.rateIncreaseCriteria !== null && {
        rateIncreaseCriteria: serializeAws_restJson1RateIncreaseCriteria(input.rateIncreaseCriteria, context),
    }));
};
var serializeAws_restJson1Field = function (input, context) {
    return __assign(__assign({}, (input.name !== undefined && input.name !== null && { name: input.name })), (input.type !== undefined && input.type !== null && { type: input.type }));
};
var serializeAws_restJson1Fields = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1Field(entry, context);
    });
};
var serializeAws_restJson1FileLocation = function (input, context) {
    return __assign(__assign({}, (input.s3Location !== undefined &&
        input.s3Location !== null && { s3Location: serializeAws_restJson1S3Location(input.s3Location, context) })), (input.stream !== undefined &&
        input.stream !== null && { stream: serializeAws_restJson1_Stream(input.stream, context) }));
};
var serializeAws_restJson1FindingIds = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1FirehoseAction = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.batchMode !== undefined && input.batchMode !== null && { batchMode: input.batchMode })), (input.deliveryStreamName !== undefined &&
        input.deliveryStreamName !== null && { deliveryStreamName: input.deliveryStreamName })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.separator !== undefined && input.separator !== null && { separator: input.separator }));
};
var serializeAws_restJson1HeaderList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1HttpActionHeader(entry, context);
    });
};
var serializeAws_restJson1HttpAction = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.auth !== undefined &&
        input.auth !== null && { auth: serializeAws_restJson1HttpAuthorization(input.auth, context) })), (input.confirmationUrl !== undefined &&
        input.confirmationUrl !== null && { confirmationUrl: input.confirmationUrl })), (input.headers !== undefined &&
        input.headers !== null && { headers: serializeAws_restJson1HeaderList(input.headers, context) })), (input.url !== undefined && input.url !== null && { url: input.url }));
};
var serializeAws_restJson1HttpActionHeader = function (input, context) {
    return __assign(__assign({}, (input.key !== undefined && input.key !== null && { key: input.key })), (input.value !== undefined && input.value !== null && { value: input.value }));
};
var serializeAws_restJson1HttpAuthorization = function (input, context) {
    return __assign({}, (input.sigv4 !== undefined &&
        input.sigv4 !== null && { sigv4: serializeAws_restJson1SigV4Authorization(input.sigv4, context) }));
};
var serializeAws_restJson1HttpContext = function (input, context) {
    return __assign(__assign({}, (input.headers !== undefined &&
        input.headers !== null && { headers: serializeAws_restJson1HttpHeaders(input.headers, context) })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString }));
};
var serializeAws_restJson1HttpHeaders = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1HttpUrlDestinationConfiguration = function (input, context) {
    return __assign({}, (input.confirmationUrl !== undefined &&
        input.confirmationUrl !== null && { confirmationUrl: input.confirmationUrl }));
};
var serializeAws_restJson1IotAnalyticsAction = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.batchMode !== undefined && input.batchMode !== null && { batchMode: input.batchMode })), (input.channelArn !== undefined && input.channelArn !== null && { channelArn: input.channelArn })), (input.channelName !== undefined && input.channelName !== null && { channelName: input.channelName })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1IotEventsAction = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.batchMode !== undefined && input.batchMode !== null && { batchMode: input.batchMode })), (input.inputName !== undefined && input.inputName !== null && { inputName: input.inputName })), (input.messageId !== undefined && input.messageId !== null && { messageId: input.messageId })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1IotSiteWiseAction = function (input, context) {
    return __assign(__assign({}, (input.putAssetPropertyValueEntries !== undefined &&
        input.putAssetPropertyValueEntries !== null && {
        putAssetPropertyValueEntries: serializeAws_restJson1PutAssetPropertyValueEntryList(input.putAssetPropertyValueEntries, context),
    })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1JobExecutionsRetryConfig = function (input, context) {
    return __assign({}, (input.criteriaList !== undefined &&
        input.criteriaList !== null && {
        criteriaList: serializeAws_restJson1RetryCriteriaList(input.criteriaList, context),
    }));
};
var serializeAws_restJson1JobExecutionsRolloutConfig = function (input, context) {
    return __assign(__assign({}, (input.exponentialRate !== undefined &&
        input.exponentialRate !== null && {
        exponentialRate: serializeAws_restJson1ExponentialRolloutRate(input.exponentialRate, context),
    })), (input.maximumPerMinute !== undefined &&
        input.maximumPerMinute !== null && { maximumPerMinute: input.maximumPerMinute }));
};
var serializeAws_restJson1JobTargets = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1KafkaAction = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.clientProperties !== undefined &&
        input.clientProperties !== null && {
        clientProperties: serializeAws_restJson1ClientProperties(input.clientProperties, context),
    })), (input.destinationArn !== undefined &&
        input.destinationArn !== null && { destinationArn: input.destinationArn })), (input.key !== undefined && input.key !== null && { key: input.key })), (input.partition !== undefined && input.partition !== null && { partition: input.partition })), (input.topic !== undefined && input.topic !== null && { topic: input.topic }));
};
var serializeAws_restJson1KinesisAction = function (input, context) {
    return __assign(__assign(__assign({}, (input.partitionKey !== undefined && input.partitionKey !== null && { partitionKey: input.partitionKey })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.streamName !== undefined && input.streamName !== null && { streamName: input.streamName }));
};
var serializeAws_restJson1LambdaAction = function (input, context) {
    return __assign({}, (input.functionArn !== undefined && input.functionArn !== null && { functionArn: input.functionArn }));
};
var serializeAws_restJson1LoggingOptionsPayload = function (input, context) {
    return __assign(__assign({}, (input.logLevel !== undefined && input.logLevel !== null && { logLevel: input.logLevel })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1LogTarget = function (input, context) {
    return __assign(__assign({}, (input.targetName !== undefined && input.targetName !== null && { targetName: input.targetName })), (input.targetType !== undefined && input.targetType !== null && { targetType: input.targetType }));
};
var serializeAws_restJson1MachineLearningDetectionConfig = function (input, context) {
    return __assign({}, (input.confidenceLevel !== undefined &&
        input.confidenceLevel !== null && { confidenceLevel: input.confidenceLevel }));
};
var serializeAws_restJson1MetricDimension = function (input, context) {
    return __assign(__assign({}, (input.dimensionName !== undefined && input.dimensionName !== null && { dimensionName: input.dimensionName })), (input.operator !== undefined && input.operator !== null && { operator: input.operator }));
};
var serializeAws_restJson1MetricToRetain = function (input, context) {
    return __assign(__assign({}, (input.metric !== undefined && input.metric !== null && { metric: input.metric })), (input.metricDimension !== undefined &&
        input.metricDimension !== null && {
        metricDimension: serializeAws_restJson1MetricDimension(input.metricDimension, context),
    }));
};
var serializeAws_restJson1MetricValue = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.cidrs !== undefined &&
        input.cidrs !== null && { cidrs: serializeAws_restJson1Cidrs(input.cidrs, context) })), (input.count !== undefined && input.count !== null && { count: input.count })), (input.number !== undefined && input.number !== null && { number: __serializeFloat(input.number) })), (input.numbers !== undefined &&
        input.numbers !== null && { numbers: serializeAws_restJson1NumberList(input.numbers, context) })), (input.ports !== undefined &&
        input.ports !== null && { ports: serializeAws_restJson1Ports(input.ports, context) })), (input.strings !== undefined &&
        input.strings !== null && { strings: serializeAws_restJson1StringList(input.strings, context) }));
};
var serializeAws_restJson1MitigationActionNameList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1MitigationActionParams = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.addThingsToThingGroupParams !== undefined &&
        input.addThingsToThingGroupParams !== null && {
        addThingsToThingGroupParams: serializeAws_restJson1AddThingsToThingGroupParams(input.addThingsToThingGroupParams, context),
    })), (input.enableIoTLoggingParams !== undefined &&
        input.enableIoTLoggingParams !== null && {
        enableIoTLoggingParams: serializeAws_restJson1EnableIoTLoggingParams(input.enableIoTLoggingParams, context),
    })), (input.publishFindingToSnsParams !== undefined &&
        input.publishFindingToSnsParams !== null && {
        publishFindingToSnsParams: serializeAws_restJson1PublishFindingToSnsParams(input.publishFindingToSnsParams, context),
    })), (input.replaceDefaultPolicyVersionParams !== undefined &&
        input.replaceDefaultPolicyVersionParams !== null && {
        replaceDefaultPolicyVersionParams: serializeAws_restJson1ReplaceDefaultPolicyVersionParams(input.replaceDefaultPolicyVersionParams, context),
    })), (input.updateCACertificateParams !== undefined &&
        input.updateCACertificateParams !== null && {
        updateCACertificateParams: serializeAws_restJson1UpdateCACertificateParams(input.updateCACertificateParams, context),
    })), (input.updateDeviceCertificateParams !== undefined &&
        input.updateDeviceCertificateParams !== null && {
        updateDeviceCertificateParams: serializeAws_restJson1UpdateDeviceCertificateParams(input.updateDeviceCertificateParams, context),
    }));
};
var serializeAws_restJson1MqttContext = function (input, context) {
    return __assign(__assign(__assign({}, (input.clientId !== undefined && input.clientId !== null && { clientId: input.clientId })), (input.password !== undefined && input.password !== null && { password: context.base64Encoder(input.password) })), (input.username !== undefined && input.username !== null && { username: input.username }));
};
var serializeAws_restJson1NumberList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __serializeFloat(entry);
    });
};
var serializeAws_restJson1OpenSearchAction = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.endpoint !== undefined && input.endpoint !== null && { endpoint: input.endpoint })), (input.id !== undefined && input.id !== null && { id: input.id })), (input.index !== undefined && input.index !== null && { index: input.index })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.type !== undefined && input.type !== null && { type: input.type }));
};
var serializeAws_restJson1OTAUpdateFile = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.attributes !== undefined &&
        input.attributes !== null && { attributes: serializeAws_restJson1AttributesMap(input.attributes, context) })), (input.codeSigning !== undefined &&
        input.codeSigning !== null && { codeSigning: serializeAws_restJson1CodeSigning(input.codeSigning, context) })), (input.fileLocation !== undefined &&
        input.fileLocation !== null && { fileLocation: serializeAws_restJson1FileLocation(input.fileLocation, context) })), (input.fileName !== undefined && input.fileName !== null && { fileName: input.fileName })), (input.fileType !== undefined && input.fileType !== null && { fileType: input.fileType })), (input.fileVersion !== undefined && input.fileVersion !== null && { fileVersion: input.fileVersion }));
};
var serializeAws_restJson1OTAUpdateFiles = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1OTAUpdateFile(entry, context);
    });
};
var serializeAws_restJson1ParameterMap = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1Parameters = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1PercentList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __serializeFloat(entry);
    });
};
var serializeAws_restJson1PolicyNames = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1PolicyVersionIdentifier = function (input, context) {
    return __assign(__assign({}, (input.policyName !== undefined && input.policyName !== null && { policyName: input.policyName })), (input.policyVersionId !== undefined &&
        input.policyVersionId !== null && { policyVersionId: input.policyVersionId }));
};
var serializeAws_restJson1Ports = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1PresignedUrlConfig = function (input, context) {
    return __assign(__assign({}, (input.expiresInSec !== undefined && input.expiresInSec !== null && { expiresInSec: input.expiresInSec })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1Protocols = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1ProvisioningHook = function (input, context) {
    return __assign(__assign({}, (input.payloadVersion !== undefined &&
        input.payloadVersion !== null && { payloadVersion: input.payloadVersion })), (input.targetArn !== undefined && input.targetArn !== null && { targetArn: input.targetArn }));
};
var serializeAws_restJson1PublicKeyMap = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1PublishFindingToSnsParams = function (input, context) {
    return __assign({}, (input.topicArn !== undefined && input.topicArn !== null && { topicArn: input.topicArn }));
};
var serializeAws_restJson1PutAssetPropertyValueEntry = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.assetId !== undefined && input.assetId !== null && { assetId: input.assetId })), (input.entryId !== undefined && input.entryId !== null && { entryId: input.entryId })), (input.propertyAlias !== undefined && input.propertyAlias !== null && { propertyAlias: input.propertyAlias })), (input.propertyId !== undefined && input.propertyId !== null && { propertyId: input.propertyId })), (input.propertyValues !== undefined &&
        input.propertyValues !== null && {
        propertyValues: serializeAws_restJson1AssetPropertyValueList(input.propertyValues, context),
    }));
};
var serializeAws_restJson1PutAssetPropertyValueEntryList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1PutAssetPropertyValueEntry(entry, context);
    });
};
var serializeAws_restJson1PutItemInput = function (input, context) {
    return __assign({}, (input.tableName !== undefined && input.tableName !== null && { tableName: input.tableName }));
};
var serializeAws_restJson1RateIncreaseCriteria = function (input, context) {
    return __assign(__assign({}, (input.numberOfNotifiedThings !== undefined &&
        input.numberOfNotifiedThings !== null && { numberOfNotifiedThings: input.numberOfNotifiedThings })), (input.numberOfSucceededThings !== undefined &&
        input.numberOfSucceededThings !== null && { numberOfSucceededThings: input.numberOfSucceededThings }));
};
var serializeAws_restJson1ReasonForNonComplianceCodes = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1RegistrationConfig = function (input, context) {
    return __assign(__assign({}, (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.templateBody !== undefined && input.templateBody !== null && { templateBody: input.templateBody }));
};
var serializeAws_restJson1ReplaceDefaultPolicyVersionParams = function (input, context) {
    return __assign({}, (input.templateName !== undefined && input.templateName !== null && { templateName: input.templateName }));
};
var serializeAws_restJson1RepublishAction = function (input, context) {
    return __assign(__assign(__assign({}, (input.qos !== undefined && input.qos !== null && { qos: input.qos })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.topic !== undefined && input.topic !== null && { topic: input.topic }));
};
var serializeAws_restJson1ResourceIdentifier = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.account !== undefined && input.account !== null && { account: input.account })), (input.caCertificateId !== undefined &&
        input.caCertificateId !== null && { caCertificateId: input.caCertificateId })), (input.clientId !== undefined && input.clientId !== null && { clientId: input.clientId })), (input.cognitoIdentityPoolId !== undefined &&
        input.cognitoIdentityPoolId !== null && { cognitoIdentityPoolId: input.cognitoIdentityPoolId })), (input.deviceCertificateId !== undefined &&
        input.deviceCertificateId !== null && { deviceCertificateId: input.deviceCertificateId })), (input.iamRoleArn !== undefined && input.iamRoleArn !== null && { iamRoleArn: input.iamRoleArn })), (input.policyVersionIdentifier !== undefined &&
        input.policyVersionIdentifier !== null && {
        policyVersionIdentifier: serializeAws_restJson1PolicyVersionIdentifier(input.policyVersionIdentifier, context),
    })), (input.roleAliasArn !== undefined && input.roleAliasArn !== null && { roleAliasArn: input.roleAliasArn }));
};
var serializeAws_restJson1Resources = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1RetryCriteria = function (input, context) {
    return __assign(__assign({}, (input.failureType !== undefined && input.failureType !== null && { failureType: input.failureType })), (input.numberOfRetries !== undefined &&
        input.numberOfRetries !== null && { numberOfRetries: input.numberOfRetries }));
};
var serializeAws_restJson1RetryCriteriaList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1RetryCriteria(entry, context);
    });
};
var serializeAws_restJson1S3Action = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.bucketName !== undefined && input.bucketName !== null && { bucketName: input.bucketName })), (input.cannedAcl !== undefined && input.cannedAcl !== null && { cannedAcl: input.cannedAcl })), (input.key !== undefined && input.key !== null && { key: input.key })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_restJson1S3Destination = function (input, context) {
    return __assign(__assign({}, (input.bucket !== undefined && input.bucket !== null && { bucket: input.bucket })), (input.prefix !== undefined && input.prefix !== null && { prefix: input.prefix }));
};
var serializeAws_restJson1S3Location = function (input, context) {
    return __assign(__assign(__assign({}, (input.bucket !== undefined && input.bucket !== null && { bucket: input.bucket })), (input.key !== undefined && input.key !== null && { key: input.key })), (input.version !== undefined && input.version !== null && { version: input.version }));
};
var serializeAws_restJson1SalesforceAction = function (input, context) {
    return __assign(__assign({}, (input.token !== undefined && input.token !== null && { token: input.token })), (input.url !== undefined && input.url !== null && { url: input.url }));
};
var serializeAws_restJson1SearchableAttributes = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1SecurityGroupList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1ServerCertificateArns = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1SigningProfileParameter = function (input, context) {
    return __assign(__assign(__assign({}, (input.certificateArn !== undefined &&
        input.certificateArn !== null && { certificateArn: input.certificateArn })), (input.certificatePathOnDevice !== undefined &&
        input.certificatePathOnDevice !== null && { certificatePathOnDevice: input.certificatePathOnDevice })), (input.platform !== undefined && input.platform !== null && { platform: input.platform }));
};
var serializeAws_restJson1SigV4Authorization = function (input, context) {
    return __assign(__assign(__assign({}, (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.serviceName !== undefined && input.serviceName !== null && { serviceName: input.serviceName })), (input.signingRegion !== undefined && input.signingRegion !== null && { signingRegion: input.signingRegion }));
};
var serializeAws_restJson1SnsAction = function (input, context) {
    return __assign(__assign(__assign({}, (input.messageFormat !== undefined && input.messageFormat !== null && { messageFormat: input.messageFormat })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.targetArn !== undefined && input.targetArn !== null && { targetArn: input.targetArn }));
};
var serializeAws_restJson1SqsAction = function (input, context) {
    return __assign(__assign(__assign({}, (input.queueUrl !== undefined && input.queueUrl !== null && { queueUrl: input.queueUrl })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.useBase64 !== undefined && input.useBase64 !== null && { useBase64: input.useBase64 }));
};
var serializeAws_restJson1StartSigningJobParameter = function (input, context) {
    return __assign(__assign(__assign({}, (input.destination !== undefined &&
        input.destination !== null && { destination: serializeAws_restJson1Destination(input.destination, context) })), (input.signingProfileName !== undefined &&
        input.signingProfileName !== null && { signingProfileName: input.signingProfileName })), (input.signingProfileParameter !== undefined &&
        input.signingProfileParameter !== null && {
        signingProfileParameter: serializeAws_restJson1SigningProfileParameter(input.signingProfileParameter, context),
    }));
};
var serializeAws_restJson1StatisticalThreshold = function (input, context) {
    return __assign({}, (input.statistic !== undefined && input.statistic !== null && { statistic: input.statistic }));
};
var serializeAws_restJson1StepFunctionsAction = function (input, context) {
    return __assign(__assign(__assign({}, (input.executionNamePrefix !== undefined &&
        input.executionNamePrefix !== null && { executionNamePrefix: input.executionNamePrefix })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.stateMachineName !== undefined &&
        input.stateMachineName !== null && { stateMachineName: input.stateMachineName }));
};
var serializeAws_restJson1_Stream = function (input, context) {
    return __assign(__assign({}, (input.fileId !== undefined && input.fileId !== null && { fileId: input.fileId })), (input.streamId !== undefined && input.streamId !== null && { streamId: input.streamId }));
};
var serializeAws_restJson1StreamFile = function (input, context) {
    return __assign(__assign({}, (input.fileId !== undefined && input.fileId !== null && { fileId: input.fileId })), (input.s3Location !== undefined &&
        input.s3Location !== null && { s3Location: serializeAws_restJson1S3Location(input.s3Location, context) }));
};
var serializeAws_restJson1StreamFiles = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1StreamFile(entry, context);
    });
};
var serializeAws_restJson1StringList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1SubnetIdList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1Tag = function (input, context) {
    return __assign(__assign({}, (input.Key !== undefined && input.Key !== null && { Key: input.Key })), (input.Value !== undefined && input.Value !== null && { Value: input.Value }));
};
var serializeAws_restJson1TagKeyList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1TagList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1Tag(entry, context);
    });
};
var serializeAws_restJson1TargetAuditCheckNames = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1Targets = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1TargetViolationIdsForDetectMitigationActions = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1TermsAggregation = function (input, context) {
    return __assign({}, (input.maxBuckets !== undefined && input.maxBuckets !== null && { maxBuckets: input.maxBuckets }));
};
var serializeAws_restJson1ThingGroupIndexingConfiguration = function (input, context) {
    return __assign(__assign(__assign({}, (input.customFields !== undefined &&
        input.customFields !== null && { customFields: serializeAws_restJson1Fields(input.customFields, context) })), (input.managedFields !== undefined &&
        input.managedFields !== null && { managedFields: serializeAws_restJson1Fields(input.managedFields, context) })), (input.thingGroupIndexingMode !== undefined &&
        input.thingGroupIndexingMode !== null && { thingGroupIndexingMode: input.thingGroupIndexingMode }));
};
var serializeAws_restJson1ThingGroupList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1ThingGroupNames = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_restJson1ThingGroupProperties = function (input, context) {
    return __assign(__assign({}, (input.attributePayload !== undefined &&
        input.attributePayload !== null && {
        attributePayload: serializeAws_restJson1AttributePayload(input.attributePayload, context),
    })), (input.thingGroupDescription !== undefined &&
        input.thingGroupDescription !== null && { thingGroupDescription: input.thingGroupDescription }));
};
var serializeAws_restJson1ThingIndexingConfiguration = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.customFields !== undefined &&
        input.customFields !== null && { customFields: serializeAws_restJson1Fields(input.customFields, context) })), (input.deviceDefenderIndexingMode !== undefined &&
        input.deviceDefenderIndexingMode !== null && { deviceDefenderIndexingMode: input.deviceDefenderIndexingMode })), (input.managedFields !== undefined &&
        input.managedFields !== null && { managedFields: serializeAws_restJson1Fields(input.managedFields, context) })), (input.namedShadowIndexingMode !== undefined &&
        input.namedShadowIndexingMode !== null && { namedShadowIndexingMode: input.namedShadowIndexingMode })), (input.thingConnectivityIndexingMode !== undefined &&
        input.thingConnectivityIndexingMode !== null && {
        thingConnectivityIndexingMode: input.thingConnectivityIndexingMode,
    })), (input.thingIndexingMode !== undefined &&
        input.thingIndexingMode !== null && { thingIndexingMode: input.thingIndexingMode }));
};
var serializeAws_restJson1ThingTypeProperties = function (input, context) {
    return __assign(__assign({}, (input.searchableAttributes !== undefined &&
        input.searchableAttributes !== null && {
        searchableAttributes: serializeAws_restJson1SearchableAttributes(input.searchableAttributes, context),
    })), (input.thingTypeDescription !== undefined &&
        input.thingTypeDescription !== null && { thingTypeDescription: input.thingTypeDescription }));
};
var serializeAws_restJson1TimeoutConfig = function (input, context) {
    return __assign({}, (input.inProgressTimeoutInMinutes !== undefined &&
        input.inProgressTimeoutInMinutes !== null && { inProgressTimeoutInMinutes: input.inProgressTimeoutInMinutes }));
};
var serializeAws_restJson1TimestreamAction = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.databaseName !== undefined && input.databaseName !== null && { databaseName: input.databaseName })), (input.dimensions !== undefined &&
        input.dimensions !== null && {
        dimensions: serializeAws_restJson1TimestreamDimensionList(input.dimensions, context),
    })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.tableName !== undefined && input.tableName !== null && { tableName: input.tableName })), (input.timestamp !== undefined &&
        input.timestamp !== null && { timestamp: serializeAws_restJson1TimestreamTimestamp(input.timestamp, context) }));
};
var serializeAws_restJson1TimestreamDimension = function (input, context) {
    return __assign(__assign({}, (input.name !== undefined && input.name !== null && { name: input.name })), (input.value !== undefined && input.value !== null && { value: input.value }));
};
var serializeAws_restJson1TimestreamDimensionList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_restJson1TimestreamDimension(entry, context);
    });
};
var serializeAws_restJson1TimestreamTimestamp = function (input, context) {
    return __assign(__assign({}, (input.unit !== undefined && input.unit !== null && { unit: input.unit })), (input.value !== undefined && input.value !== null && { value: input.value }));
};
var serializeAws_restJson1TlsContext = function (input, context) {
    return __assign({}, (input.serverName !== undefined && input.serverName !== null && { serverName: input.serverName }));
};
var serializeAws_restJson1TopicRuleDestinationConfiguration = function (input, context) {
    return __assign(__assign({}, (input.httpUrlConfiguration !== undefined &&
        input.httpUrlConfiguration !== null && {
        httpUrlConfiguration: serializeAws_restJson1HttpUrlDestinationConfiguration(input.httpUrlConfiguration, context),
    })), (input.vpcConfiguration !== undefined &&
        input.vpcConfiguration !== null && {
        vpcConfiguration: serializeAws_restJson1VpcDestinationConfiguration(input.vpcConfiguration, context),
    }));
};
var serializeAws_restJson1TopicRulePayload = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.actions !== undefined &&
        input.actions !== null && { actions: serializeAws_restJson1ActionList(input.actions, context) })), (input.awsIotSqlVersion !== undefined &&
        input.awsIotSqlVersion !== null && { awsIotSqlVersion: input.awsIotSqlVersion })), (input.description !== undefined && input.description !== null && { description: input.description })), (input.errorAction !== undefined &&
        input.errorAction !== null && { errorAction: serializeAws_restJson1Action(input.errorAction, context) })), (input.ruleDisabled !== undefined && input.ruleDisabled !== null && { ruleDisabled: input.ruleDisabled })), (input.sql !== undefined && input.sql !== null && { sql: input.sql }));
};
var serializeAws_restJson1UpdateCACertificateParams = function (input, context) {
    return __assign({}, (input.action !== undefined && input.action !== null && { action: input.action }));
};
var serializeAws_restJson1UpdateDeviceCertificateParams = function (input, context) {
    return __assign({}, (input.action !== undefined && input.action !== null && { action: input.action }));
};
var serializeAws_restJson1ViolationEventOccurrenceRange = function (input, context) {
    return __assign(__assign({}, (input.endTime !== undefined &&
        input.endTime !== null && { endTime: Math.round(input.endTime.getTime() / 1000) })), (input.startTime !== undefined &&
        input.startTime !== null && { startTime: Math.round(input.startTime.getTime() / 1000) }));
};
var serializeAws_restJson1VpcDestinationConfiguration = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.securityGroups !== undefined &&
        input.securityGroups !== null && {
        securityGroups: serializeAws_restJson1SecurityGroupList(input.securityGroups, context),
    })), (input.subnetIds !== undefined &&
        input.subnetIds !== null && { subnetIds: serializeAws_restJson1SubnetIdList(input.subnetIds, context) })), (input.vpcId !== undefined && input.vpcId !== null && { vpcId: input.vpcId }));
};
var deserializeAws_restJson1AbortConfig = function (output, context) {
    return {
        criteriaList: output.criteriaList !== undefined && output.criteriaList !== null
            ? deserializeAws_restJson1AbortCriteriaList(output.criteriaList, context)
            : undefined,
    };
};
var deserializeAws_restJson1AbortCriteria = function (output, context) {
    return {
        action: __expectString(output.action),
        failureType: __expectString(output.failureType),
        minNumberOfExecutedThings: __expectInt32(output.minNumberOfExecutedThings),
        thresholdPercentage: __limitedParseDouble(output.thresholdPercentage),
    };
};
var deserializeAws_restJson1AbortCriteriaList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AbortCriteria(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1Action = function (output, context) {
    return {
        cloudwatchAlarm: output.cloudwatchAlarm !== undefined && output.cloudwatchAlarm !== null
            ? deserializeAws_restJson1CloudwatchAlarmAction(output.cloudwatchAlarm, context)
            : undefined,
        cloudwatchLogs: output.cloudwatchLogs !== undefined && output.cloudwatchLogs !== null
            ? deserializeAws_restJson1CloudwatchLogsAction(output.cloudwatchLogs, context)
            : undefined,
        cloudwatchMetric: output.cloudwatchMetric !== undefined && output.cloudwatchMetric !== null
            ? deserializeAws_restJson1CloudwatchMetricAction(output.cloudwatchMetric, context)
            : undefined,
        dynamoDB: output.dynamoDB !== undefined && output.dynamoDB !== null
            ? deserializeAws_restJson1DynamoDBAction(output.dynamoDB, context)
            : undefined,
        dynamoDBv2: output.dynamoDBv2 !== undefined && output.dynamoDBv2 !== null
            ? deserializeAws_restJson1DynamoDBv2Action(output.dynamoDBv2, context)
            : undefined,
        elasticsearch: output.elasticsearch !== undefined && output.elasticsearch !== null
            ? deserializeAws_restJson1ElasticsearchAction(output.elasticsearch, context)
            : undefined,
        firehose: output.firehose !== undefined && output.firehose !== null
            ? deserializeAws_restJson1FirehoseAction(output.firehose, context)
            : undefined,
        http: output.http !== undefined && output.http !== null
            ? deserializeAws_restJson1HttpAction(output.http, context)
            : undefined,
        iotAnalytics: output.iotAnalytics !== undefined && output.iotAnalytics !== null
            ? deserializeAws_restJson1IotAnalyticsAction(output.iotAnalytics, context)
            : undefined,
        iotEvents: output.iotEvents !== undefined && output.iotEvents !== null
            ? deserializeAws_restJson1IotEventsAction(output.iotEvents, context)
            : undefined,
        iotSiteWise: output.iotSiteWise !== undefined && output.iotSiteWise !== null
            ? deserializeAws_restJson1IotSiteWiseAction(output.iotSiteWise, context)
            : undefined,
        kafka: output.kafka !== undefined && output.kafka !== null
            ? deserializeAws_restJson1KafkaAction(output.kafka, context)
            : undefined,
        kinesis: output.kinesis !== undefined && output.kinesis !== null
            ? deserializeAws_restJson1KinesisAction(output.kinesis, context)
            : undefined,
        lambda: output.lambda !== undefined && output.lambda !== null
            ? deserializeAws_restJson1LambdaAction(output.lambda, context)
            : undefined,
        openSearch: output.openSearch !== undefined && output.openSearch !== null
            ? deserializeAws_restJson1OpenSearchAction(output.openSearch, context)
            : undefined,
        republish: output.republish !== undefined && output.republish !== null
            ? deserializeAws_restJson1RepublishAction(output.republish, context)
            : undefined,
        s3: output.s3 !== undefined && output.s3 !== null ? deserializeAws_restJson1S3Action(output.s3, context) : undefined,
        salesforce: output.salesforce !== undefined && output.salesforce !== null
            ? deserializeAws_restJson1SalesforceAction(output.salesforce, context)
            : undefined,
        sns: output.sns !== undefined && output.sns !== null
            ? deserializeAws_restJson1SnsAction(output.sns, context)
            : undefined,
        sqs: output.sqs !== undefined && output.sqs !== null
            ? deserializeAws_restJson1SqsAction(output.sqs, context)
            : undefined,
        stepFunctions: output.stepFunctions !== undefined && output.stepFunctions !== null
            ? deserializeAws_restJson1StepFunctionsAction(output.stepFunctions, context)
            : undefined,
        timestream: output.timestream !== undefined && output.timestream !== null
            ? deserializeAws_restJson1TimestreamAction(output.timestream, context)
            : undefined,
    };
};
var deserializeAws_restJson1ActionList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Action(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ActiveViolation = function (output, context) {
    return {
        behavior: output.behavior !== undefined && output.behavior !== null
            ? deserializeAws_restJson1Behavior(output.behavior, context)
            : undefined,
        lastViolationTime: output.lastViolationTime !== undefined && output.lastViolationTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastViolationTime)))
            : undefined,
        lastViolationValue: output.lastViolationValue !== undefined && output.lastViolationValue !== null
            ? deserializeAws_restJson1MetricValue(output.lastViolationValue, context)
            : undefined,
        securityProfileName: __expectString(output.securityProfileName),
        thingName: __expectString(output.thingName),
        verificationState: __expectString(output.verificationState),
        verificationStateDescription: __expectString(output.verificationStateDescription),
        violationEventAdditionalInfo: output.violationEventAdditionalInfo !== undefined && output.violationEventAdditionalInfo !== null
            ? deserializeAws_restJson1ViolationEventAdditionalInfo(output.violationEventAdditionalInfo, context)
            : undefined,
        violationId: __expectString(output.violationId),
        violationStartTime: output.violationStartTime !== undefined && output.violationStartTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.violationStartTime)))
            : undefined,
    };
};
var deserializeAws_restJson1ActiveViolations = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ActiveViolation(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AdditionalMetricsToRetainList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1AdditionalMetricsToRetainV2List = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MetricToRetain(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AdditionalParameterMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1AddThingsToThingGroupParams = function (output, context) {
    return {
        overrideDynamicGroups: __expectBoolean(output.overrideDynamicGroups),
        thingGroupNames: output.thingGroupNames !== undefined && output.thingGroupNames !== null
            ? deserializeAws_restJson1ThingGroupNames(output.thingGroupNames, context)
            : undefined,
    };
};
var deserializeAws_restJson1AggregationType = function (output, context) {
    return {
        name: __expectString(output.name),
        values: output.values !== undefined && output.values !== null
            ? deserializeAws_restJson1AggregationTypeValues(output.values, context)
            : undefined,
    };
};
var deserializeAws_restJson1AggregationTypeValues = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1AlertTarget = function (output, context) {
    return {
        alertTargetArn: __expectString(output.alertTargetArn),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1AlertTargets = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1AlertTarget(value, context), _b));
    }, {});
};
var deserializeAws_restJson1Allowed = function (output, context) {
    return {
        policies: output.policies !== undefined && output.policies !== null
            ? deserializeAws_restJson1Policies(output.policies, context)
            : undefined,
    };
};
var deserializeAws_restJson1AssetPropertyTimestamp = function (output, context) {
    return {
        offsetInNanos: __expectString(output.offsetInNanos),
        timeInSeconds: __expectString(output.timeInSeconds),
    };
};
var deserializeAws_restJson1AssetPropertyValue = function (output, context) {
    return {
        quality: __expectString(output.quality),
        timestamp: output.timestamp !== undefined && output.timestamp !== null
            ? deserializeAws_restJson1AssetPropertyTimestamp(output.timestamp, context)
            : undefined,
        value: output.value !== undefined && output.value !== null
            ? deserializeAws_restJson1AssetPropertyVariant(__expectUnion(output.value), context)
            : undefined,
    };
};
var deserializeAws_restJson1AssetPropertyValueList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AssetPropertyValue(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AssetPropertyVariant = function (output, context) {
    if (__expectString(output.booleanValue) !== undefined) {
        return { booleanValue: __expectString(output.booleanValue) };
    }
    if (__expectString(output.doubleValue) !== undefined) {
        return { doubleValue: __expectString(output.doubleValue) };
    }
    if (__expectString(output.integerValue) !== undefined) {
        return { integerValue: __expectString(output.integerValue) };
    }
    if (__expectString(output.stringValue) !== undefined) {
        return { stringValue: __expectString(output.stringValue) };
    }
    return { $unknown: Object.entries(output)[0] };
};
var deserializeAws_restJson1AttributePayload = function (output, context) {
    return {
        attributes: output.attributes !== undefined && output.attributes !== null
            ? deserializeAws_restJson1Attributes(output.attributes, context)
            : undefined,
        merge: __expectBoolean(output.merge),
    };
};
var deserializeAws_restJson1Attributes = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1AttributesMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1AuditCheckConfiguration = function (output, context) {
    return {
        enabled: __expectBoolean(output.enabled),
    };
};
var deserializeAws_restJson1AuditCheckConfigurations = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1AuditCheckConfiguration(value, context), _b));
    }, {});
};
var deserializeAws_restJson1AuditCheckDetails = function (output, context) {
    return {
        checkCompliant: __expectBoolean(output.checkCompliant),
        checkRunStatus: __expectString(output.checkRunStatus),
        errorCode: __expectString(output.errorCode),
        message: __expectString(output.message),
        nonCompliantResourcesCount: __expectLong(output.nonCompliantResourcesCount),
        suppressedNonCompliantResourcesCount: __expectLong(output.suppressedNonCompliantResourcesCount),
        totalResourcesCount: __expectLong(output.totalResourcesCount),
    };
};
var deserializeAws_restJson1AuditCheckToActionsMapping = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1MitigationActionNameList(value, context), _b));
    }, {});
};
var deserializeAws_restJson1AuditCheckToReasonCodeFilter = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1ReasonForNonComplianceCodes(value, context), _b));
    }, {});
};
var deserializeAws_restJson1AuditDetails = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1AuditCheckDetails(value, context), _b));
    }, {});
};
var deserializeAws_restJson1AuditFinding = function (output, context) {
    return {
        checkName: __expectString(output.checkName),
        findingId: __expectString(output.findingId),
        findingTime: output.findingTime !== undefined && output.findingTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.findingTime)))
            : undefined,
        isSuppressed: __expectBoolean(output.isSuppressed),
        nonCompliantResource: output.nonCompliantResource !== undefined && output.nonCompliantResource !== null
            ? deserializeAws_restJson1NonCompliantResource(output.nonCompliantResource, context)
            : undefined,
        reasonForNonCompliance: __expectString(output.reasonForNonCompliance),
        reasonForNonComplianceCode: __expectString(output.reasonForNonComplianceCode),
        relatedResources: output.relatedResources !== undefined && output.relatedResources !== null
            ? deserializeAws_restJson1RelatedResources(output.relatedResources, context)
            : undefined,
        severity: __expectString(output.severity),
        taskId: __expectString(output.taskId),
        taskStartTime: output.taskStartTime !== undefined && output.taskStartTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.taskStartTime)))
            : undefined,
    };
};
var deserializeAws_restJson1AuditFindings = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AuditFinding(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AuditMitigationActionExecutionMetadata = function (output, context) {
    return {
        actionId: __expectString(output.actionId),
        actionName: __expectString(output.actionName),
        endTime: output.endTime !== undefined && output.endTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.endTime)))
            : undefined,
        errorCode: __expectString(output.errorCode),
        findingId: __expectString(output.findingId),
        message: __expectString(output.message),
        startTime: output.startTime !== undefined && output.startTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startTime)))
            : undefined,
        status: __expectString(output.status),
        taskId: __expectString(output.taskId),
    };
};
var deserializeAws_restJson1AuditMitigationActionExecutionMetadataList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AuditMitigationActionExecutionMetadata(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AuditMitigationActionsTaskMetadata = function (output, context) {
    return {
        startTime: output.startTime !== undefined && output.startTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startTime)))
            : undefined,
        taskId: __expectString(output.taskId),
        taskStatus: __expectString(output.taskStatus),
    };
};
var deserializeAws_restJson1AuditMitigationActionsTaskMetadataList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AuditMitigationActionsTaskMetadata(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AuditMitigationActionsTaskStatistics = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1TaskStatisticsForAuditCheck(value, context), _b));
    }, {});
};
var deserializeAws_restJson1AuditMitigationActionsTaskTarget = function (output, context) {
    return {
        auditCheckToReasonCodeFilter: output.auditCheckToReasonCodeFilter !== undefined && output.auditCheckToReasonCodeFilter !== null
            ? deserializeAws_restJson1AuditCheckToReasonCodeFilter(output.auditCheckToReasonCodeFilter, context)
            : undefined,
        auditTaskId: __expectString(output.auditTaskId),
        findingIds: output.findingIds !== undefined && output.findingIds !== null
            ? deserializeAws_restJson1FindingIds(output.findingIds, context)
            : undefined,
    };
};
var deserializeAws_restJson1AuditNotificationTarget = function (output, context) {
    return {
        enabled: __expectBoolean(output.enabled),
        roleArn: __expectString(output.roleArn),
        targetArn: __expectString(output.targetArn),
    };
};
var deserializeAws_restJson1AuditNotificationTargetConfigurations = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1AuditNotificationTarget(value, context), _b));
    }, {});
};
var deserializeAws_restJson1AuditSuppression = function (output, context) {
    return {
        checkName: __expectString(output.checkName),
        description: __expectString(output.description),
        expirationDate: output.expirationDate !== undefined && output.expirationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.expirationDate)))
            : undefined,
        resourceIdentifier: output.resourceIdentifier !== undefined && output.resourceIdentifier !== null
            ? deserializeAws_restJson1ResourceIdentifier(output.resourceIdentifier, context)
            : undefined,
        suppressIndefinitely: __expectBoolean(output.suppressIndefinitely),
    };
};
var deserializeAws_restJson1AuditSuppressionList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AuditSuppression(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AuditTaskMetadata = function (output, context) {
    return {
        taskId: __expectString(output.taskId),
        taskStatus: __expectString(output.taskStatus),
        taskType: __expectString(output.taskType),
    };
};
var deserializeAws_restJson1AuditTaskMetadataList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AuditTaskMetadata(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AuthInfo = function (output, context) {
    return {
        actionType: __expectString(output.actionType),
        resources: output.resources !== undefined && output.resources !== null
            ? deserializeAws_restJson1Resources(output.resources, context)
            : undefined,
    };
};
var deserializeAws_restJson1AuthorizerConfig = function (output, context) {
    return {
        allowAuthorizerOverride: __expectBoolean(output.allowAuthorizerOverride),
        defaultAuthorizerName: __expectString(output.defaultAuthorizerName),
    };
};
var deserializeAws_restJson1AuthorizerDescription = function (output, context) {
    return {
        authorizerArn: __expectString(output.authorizerArn),
        authorizerFunctionArn: __expectString(output.authorizerFunctionArn),
        authorizerName: __expectString(output.authorizerName),
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        enableCachingForHttp: __expectBoolean(output.enableCachingForHttp),
        lastModifiedDate: output.lastModifiedDate !== undefined && output.lastModifiedDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate)))
            : undefined,
        signingDisabled: __expectBoolean(output.signingDisabled),
        status: __expectString(output.status),
        tokenKeyName: __expectString(output.tokenKeyName),
        tokenSigningPublicKeys: output.tokenSigningPublicKeys !== undefined && output.tokenSigningPublicKeys !== null
            ? deserializeAws_restJson1PublicKeyMap(output.tokenSigningPublicKeys, context)
            : undefined,
    };
};
var deserializeAws_restJson1Authorizers = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AuthorizerSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AuthorizerSummary = function (output, context) {
    return {
        authorizerArn: __expectString(output.authorizerArn),
        authorizerName: __expectString(output.authorizerName),
    };
};
var deserializeAws_restJson1AuthResult = function (output, context) {
    return {
        allowed: output.allowed !== undefined && output.allowed !== null
            ? deserializeAws_restJson1Allowed(output.allowed, context)
            : undefined,
        authDecision: __expectString(output.authDecision),
        authInfo: output.authInfo !== undefined && output.authInfo !== null
            ? deserializeAws_restJson1AuthInfo(output.authInfo, context)
            : undefined,
        denied: output.denied !== undefined && output.denied !== null
            ? deserializeAws_restJson1Denied(output.denied, context)
            : undefined,
        missingContextValues: output.missingContextValues !== undefined && output.missingContextValues !== null
            ? deserializeAws_restJson1MissingContextValues(output.missingContextValues, context)
            : undefined,
    };
};
var deserializeAws_restJson1AuthResults = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AuthResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1AwsJobExecutionsRolloutConfig = function (output, context) {
    return {
        exponentialRate: output.exponentialRate !== undefined && output.exponentialRate !== null
            ? deserializeAws_restJson1AwsJobExponentialRolloutRate(output.exponentialRate, context)
            : undefined,
        maximumPerMinute: __expectInt32(output.maximumPerMinute),
    };
};
var deserializeAws_restJson1AwsJobExponentialRolloutRate = function (output, context) {
    return {
        baseRatePerMinute: __expectInt32(output.baseRatePerMinute),
        incrementFactor: __limitedParseDouble(output.incrementFactor),
        rateIncreaseCriteria: output.rateIncreaseCriteria !== undefined && output.rateIncreaseCriteria !== null
            ? deserializeAws_restJson1AwsJobRateIncreaseCriteria(output.rateIncreaseCriteria, context)
            : undefined,
    };
};
var deserializeAws_restJson1AwsJobPresignedUrlConfig = function (output, context) {
    return {
        expiresInSec: __expectLong(output.expiresInSec),
    };
};
var deserializeAws_restJson1AwsJobRateIncreaseCriteria = function (output, context) {
    return {
        numberOfNotifiedThings: __expectInt32(output.numberOfNotifiedThings),
        numberOfSucceededThings: __expectInt32(output.numberOfSucceededThings),
    };
};
var deserializeAws_restJson1Behavior = function (output, context) {
    return {
        criteria: output.criteria !== undefined && output.criteria !== null
            ? deserializeAws_restJson1BehaviorCriteria(output.criteria, context)
            : undefined,
        metric: __expectString(output.metric),
        metricDimension: output.metricDimension !== undefined && output.metricDimension !== null
            ? deserializeAws_restJson1MetricDimension(output.metricDimension, context)
            : undefined,
        name: __expectString(output.name),
        suppressAlerts: __expectBoolean(output.suppressAlerts),
    };
};
var deserializeAws_restJson1BehaviorCriteria = function (output, context) {
    return {
        comparisonOperator: __expectString(output.comparisonOperator),
        consecutiveDatapointsToAlarm: __expectInt32(output.consecutiveDatapointsToAlarm),
        consecutiveDatapointsToClear: __expectInt32(output.consecutiveDatapointsToClear),
        durationSeconds: __expectInt32(output.durationSeconds),
        mlDetectionConfig: output.mlDetectionConfig !== undefined && output.mlDetectionConfig !== null
            ? deserializeAws_restJson1MachineLearningDetectionConfig(output.mlDetectionConfig, context)
            : undefined,
        statisticalThreshold: output.statisticalThreshold !== undefined && output.statisticalThreshold !== null
            ? deserializeAws_restJson1StatisticalThreshold(output.statisticalThreshold, context)
            : undefined,
        value: output.value !== undefined && output.value !== null
            ? deserializeAws_restJson1MetricValue(output.value, context)
            : undefined,
    };
};
var deserializeAws_restJson1BehaviorModelTrainingSummaries = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BehaviorModelTrainingSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BehaviorModelTrainingSummary = function (output, context) {
    return {
        behaviorName: __expectString(output.behaviorName),
        datapointsCollectionPercentage: __limitedParseDouble(output.datapointsCollectionPercentage),
        lastModelRefreshDate: output.lastModelRefreshDate !== undefined && output.lastModelRefreshDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModelRefreshDate)))
            : undefined,
        modelStatus: __expectString(output.modelStatus),
        securityProfileName: __expectString(output.securityProfileName),
        trainingDataCollectionStartDate: output.trainingDataCollectionStartDate !== undefined && output.trainingDataCollectionStartDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.trainingDataCollectionStartDate)))
            : undefined,
    };
};
var deserializeAws_restJson1Behaviors = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Behavior(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BillingGroupMetadata = function (output, context) {
    return {
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
    };
};
var deserializeAws_restJson1BillingGroupNameAndArnList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1GroupNameAndArn(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BillingGroupProperties = function (output, context) {
    return {
        billingGroupDescription: __expectString(output.billingGroupDescription),
    };
};
var deserializeAws_restJson1Bucket = function (output, context) {
    return {
        count: __expectInt32(output.count),
        keyValue: __expectString(output.keyValue),
    };
};
var deserializeAws_restJson1Buckets = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Bucket(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1CACertificate = function (output, context) {
    return {
        certificateArn: __expectString(output.certificateArn),
        certificateId: __expectString(output.certificateId),
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        status: __expectString(output.status),
    };
};
var deserializeAws_restJson1CACertificateDescription = function (output, context) {
    return {
        autoRegistrationStatus: __expectString(output.autoRegistrationStatus),
        certificateArn: __expectString(output.certificateArn),
        certificateId: __expectString(output.certificateId),
        certificatePem: __expectString(output.certificatePem),
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        customerVersion: __expectInt32(output.customerVersion),
        generationId: __expectString(output.generationId),
        lastModifiedDate: output.lastModifiedDate !== undefined && output.lastModifiedDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate)))
            : undefined,
        ownedBy: __expectString(output.ownedBy),
        status: __expectString(output.status),
        validity: output.validity !== undefined && output.validity !== null
            ? deserializeAws_restJson1CertificateValidity(output.validity, context)
            : undefined,
    };
};
var deserializeAws_restJson1CACertificates = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1CACertificate(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1Certificate = function (output, context) {
    return {
        certificateArn: __expectString(output.certificateArn),
        certificateId: __expectString(output.certificateId),
        certificateMode: __expectString(output.certificateMode),
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        status: __expectString(output.status),
    };
};
var deserializeAws_restJson1CertificateDescription = function (output, context) {
    return {
        caCertificateId: __expectString(output.caCertificateId),
        certificateArn: __expectString(output.certificateArn),
        certificateId: __expectString(output.certificateId),
        certificateMode: __expectString(output.certificateMode),
        certificatePem: __expectString(output.certificatePem),
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        customerVersion: __expectInt32(output.customerVersion),
        generationId: __expectString(output.generationId),
        lastModifiedDate: output.lastModifiedDate !== undefined && output.lastModifiedDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate)))
            : undefined,
        ownedBy: __expectString(output.ownedBy),
        previousOwnedBy: __expectString(output.previousOwnedBy),
        status: __expectString(output.status),
        transferData: output.transferData !== undefined && output.transferData !== null
            ? deserializeAws_restJson1TransferData(output.transferData, context)
            : undefined,
        validity: output.validity !== undefined && output.validity !== null
            ? deserializeAws_restJson1CertificateValidity(output.validity, context)
            : undefined,
    };
};
var deserializeAws_restJson1Certificates = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Certificate(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1CertificateValidity = function (output, context) {
    return {
        notAfter: output.notAfter !== undefined && output.notAfter !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.notAfter)))
            : undefined,
        notBefore: output.notBefore !== undefined && output.notBefore !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.notBefore)))
            : undefined,
    };
};
var deserializeAws_restJson1Cidrs = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1ClientProperties = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1CloudwatchAlarmAction = function (output, context) {
    return {
        alarmName: __expectString(output.alarmName),
        roleArn: __expectString(output.roleArn),
        stateReason: __expectString(output.stateReason),
        stateValue: __expectString(output.stateValue),
    };
};
var deserializeAws_restJson1CloudwatchLogsAction = function (output, context) {
    return {
        logGroupName: __expectString(output.logGroupName),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1CloudwatchMetricAction = function (output, context) {
    return {
        metricName: __expectString(output.metricName),
        metricNamespace: __expectString(output.metricNamespace),
        metricTimestamp: __expectString(output.metricTimestamp),
        metricUnit: __expectString(output.metricUnit),
        metricValue: __expectString(output.metricValue),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1CodeSigning = function (output, context) {
    return {
        awsSignerJobId: __expectString(output.awsSignerJobId),
        customCodeSigning: output.customCodeSigning !== undefined && output.customCodeSigning !== null
            ? deserializeAws_restJson1CustomCodeSigning(output.customCodeSigning, context)
            : undefined,
        startSigningJobParameter: output.startSigningJobParameter !== undefined && output.startSigningJobParameter !== null
            ? deserializeAws_restJson1StartSigningJobParameter(output.startSigningJobParameter, context)
            : undefined,
    };
};
var deserializeAws_restJson1CodeSigningCertificateChain = function (output, context) {
    return {
        certificateName: __expectString(output.certificateName),
        inlineDocument: __expectString(output.inlineDocument),
    };
};
var deserializeAws_restJson1CodeSigningSignature = function (output, context) {
    return {
        inlineDocument: output.inlineDocument !== undefined && output.inlineDocument !== null
            ? context.base64Decoder(output.inlineDocument)
            : undefined,
    };
};
var deserializeAws_restJson1Configuration = function (output, context) {
    return {
        Enabled: __expectBoolean(output.Enabled),
    };
};
var deserializeAws_restJson1CustomCodeSigning = function (output, context) {
    return {
        certificateChain: output.certificateChain !== undefined && output.certificateChain !== null
            ? deserializeAws_restJson1CodeSigningCertificateChain(output.certificateChain, context)
            : undefined,
        hashAlgorithm: __expectString(output.hashAlgorithm),
        signature: output.signature !== undefined && output.signature !== null
            ? deserializeAws_restJson1CodeSigningSignature(output.signature, context)
            : undefined,
        signatureAlgorithm: __expectString(output.signatureAlgorithm),
    };
};
var deserializeAws_restJson1Denied = function (output, context) {
    return {
        explicitDeny: output.explicitDeny !== undefined && output.explicitDeny !== null
            ? deserializeAws_restJson1ExplicitDeny(output.explicitDeny, context)
            : undefined,
        implicitDeny: output.implicitDeny !== undefined && output.implicitDeny !== null
            ? deserializeAws_restJson1ImplicitDeny(output.implicitDeny, context)
            : undefined,
    };
};
var deserializeAws_restJson1Destination = function (output, context) {
    return {
        s3Destination: output.s3Destination !== undefined && output.s3Destination !== null
            ? deserializeAws_restJson1S3Destination(output.s3Destination, context)
            : undefined,
    };
};
var deserializeAws_restJson1DetailsMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1DetectMitigationActionExecution = function (output, context) {
    return {
        actionName: __expectString(output.actionName),
        errorCode: __expectString(output.errorCode),
        executionEndDate: output.executionEndDate !== undefined && output.executionEndDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.executionEndDate)))
            : undefined,
        executionStartDate: output.executionStartDate !== undefined && output.executionStartDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.executionStartDate)))
            : undefined,
        message: __expectString(output.message),
        status: __expectString(output.status),
        taskId: __expectString(output.taskId),
        thingName: __expectString(output.thingName),
        violationId: __expectString(output.violationId),
    };
};
var deserializeAws_restJson1DetectMitigationActionExecutionList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1DetectMitigationActionExecution(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1DetectMitigationActionsTaskStatistics = function (output, context) {
    return {
        actionsExecuted: __expectLong(output.actionsExecuted),
        actionsFailed: __expectLong(output.actionsFailed),
        actionsSkipped: __expectLong(output.actionsSkipped),
    };
};
var deserializeAws_restJson1DetectMitigationActionsTaskSummary = function (output, context) {
    return {
        actionsDefinition: output.actionsDefinition !== undefined && output.actionsDefinition !== null
            ? deserializeAws_restJson1MitigationActionList(output.actionsDefinition, context)
            : undefined,
        onlyActiveViolationsIncluded: __expectBoolean(output.onlyActiveViolationsIncluded),
        suppressedAlertsIncluded: __expectBoolean(output.suppressedAlertsIncluded),
        target: output.target !== undefined && output.target !== null
            ? deserializeAws_restJson1DetectMitigationActionsTaskTarget(output.target, context)
            : undefined,
        taskEndTime: output.taskEndTime !== undefined && output.taskEndTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.taskEndTime)))
            : undefined,
        taskId: __expectString(output.taskId),
        taskStartTime: output.taskStartTime !== undefined && output.taskStartTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.taskStartTime)))
            : undefined,
        taskStatistics: output.taskStatistics !== undefined && output.taskStatistics !== null
            ? deserializeAws_restJson1DetectMitigationActionsTaskStatistics(output.taskStatistics, context)
            : undefined,
        taskStatus: __expectString(output.taskStatus),
        violationEventOccurrenceRange: output.violationEventOccurrenceRange !== undefined && output.violationEventOccurrenceRange !== null
            ? deserializeAws_restJson1ViolationEventOccurrenceRange(output.violationEventOccurrenceRange, context)
            : undefined,
    };
};
var deserializeAws_restJson1DetectMitigationActionsTaskSummaryList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1DetectMitigationActionsTaskSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1DetectMitigationActionsTaskTarget = function (output, context) {
    return {
        behaviorName: __expectString(output.behaviorName),
        securityProfileName: __expectString(output.securityProfileName),
        violationIds: output.violationIds !== undefined && output.violationIds !== null
            ? deserializeAws_restJson1TargetViolationIdsForDetectMitigationActions(output.violationIds, context)
            : undefined,
    };
};
var deserializeAws_restJson1DimensionNames = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1DimensionStringValues = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1DocumentParameter = function (output, context) {
    return {
        description: __expectString(output.description),
        example: __expectString(output.example),
        key: __expectString(output.key),
        optional: __expectBoolean(output.optional),
        regex: __expectString(output.regex),
    };
};
var deserializeAws_restJson1DocumentParameters = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1DocumentParameter(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1DomainConfigurations = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1DomainConfigurationSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1DomainConfigurationSummary = function (output, context) {
    return {
        domainConfigurationArn: __expectString(output.domainConfigurationArn),
        domainConfigurationName: __expectString(output.domainConfigurationName),
        serviceType: __expectString(output.serviceType),
    };
};
var deserializeAws_restJson1DynamoDBAction = function (output, context) {
    return {
        hashKeyField: __expectString(output.hashKeyField),
        hashKeyType: __expectString(output.hashKeyType),
        hashKeyValue: __expectString(output.hashKeyValue),
        operation: __expectString(output.operation),
        payloadField: __expectString(output.payloadField),
        rangeKeyField: __expectString(output.rangeKeyField),
        rangeKeyType: __expectString(output.rangeKeyType),
        rangeKeyValue: __expectString(output.rangeKeyValue),
        roleArn: __expectString(output.roleArn),
        tableName: __expectString(output.tableName),
    };
};
var deserializeAws_restJson1DynamoDBv2Action = function (output, context) {
    return {
        putItem: output.putItem !== undefined && output.putItem !== null
            ? deserializeAws_restJson1PutItemInput(output.putItem, context)
            : undefined,
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1EffectivePolicies = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EffectivePolicy(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1EffectivePolicy = function (output, context) {
    return {
        policyArn: __expectString(output.policyArn),
        policyDocument: __expectString(output.policyDocument),
        policyName: __expectString(output.policyName),
    };
};
var deserializeAws_restJson1ElasticsearchAction = function (output, context) {
    return {
        endpoint: __expectString(output.endpoint),
        id: __expectString(output.id),
        index: __expectString(output.index),
        roleArn: __expectString(output.roleArn),
        type: __expectString(output.type),
    };
};
var deserializeAws_restJson1EnableIoTLoggingParams = function (output, context) {
    return {
        logLevel: __expectString(output.logLevel),
        roleArnForLogging: __expectString(output.roleArnForLogging),
    };
};
var deserializeAws_restJson1Environments = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1ErrorInfo = function (output, context) {
    return {
        code: __expectString(output.code),
        message: __expectString(output.message),
    };
};
var deserializeAws_restJson1EventConfigurations = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1Configuration(value, context), _b));
    }, {});
};
var deserializeAws_restJson1ExplicitDeny = function (output, context) {
    return {
        policies: output.policies !== undefined && output.policies !== null
            ? deserializeAws_restJson1Policies(output.policies, context)
            : undefined,
    };
};
var deserializeAws_restJson1ExponentialRolloutRate = function (output, context) {
    return {
        baseRatePerMinute: __expectInt32(output.baseRatePerMinute),
        incrementFactor: __limitedParseDouble(output.incrementFactor),
        rateIncreaseCriteria: output.rateIncreaseCriteria !== undefined && output.rateIncreaseCriteria !== null
            ? deserializeAws_restJson1RateIncreaseCriteria(output.rateIncreaseCriteria, context)
            : undefined,
    };
};
var deserializeAws_restJson1Field = function (output, context) {
    return {
        name: __expectString(output.name),
        type: __expectString(output.type),
    };
};
var deserializeAws_restJson1Fields = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Field(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1FileLocation = function (output, context) {
    return {
        s3Location: output.s3Location !== undefined && output.s3Location !== null
            ? deserializeAws_restJson1S3Location(output.s3Location, context)
            : undefined,
        stream: output.stream !== undefined && output.stream !== null
            ? deserializeAws_restJson1_Stream(output.stream, context)
            : undefined,
    };
};
var deserializeAws_restJson1FindingIds = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1FirehoseAction = function (output, context) {
    return {
        batchMode: __expectBoolean(output.batchMode),
        deliveryStreamName: __expectString(output.deliveryStreamName),
        roleArn: __expectString(output.roleArn),
        separator: __expectString(output.separator),
    };
};
var deserializeAws_restJson1FleetMetricNameAndArn = function (output, context) {
    return {
        metricArn: __expectString(output.metricArn),
        metricName: __expectString(output.metricName),
    };
};
var deserializeAws_restJson1FleetMetricNameAndArnList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1FleetMetricNameAndArn(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1GroupNameAndArn = function (output, context) {
    return {
        groupArn: __expectString(output.groupArn),
        groupName: __expectString(output.groupName),
    };
};
var deserializeAws_restJson1HeaderList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1HttpActionHeader(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1HttpAction = function (output, context) {
    return {
        auth: output.auth !== undefined && output.auth !== null
            ? deserializeAws_restJson1HttpAuthorization(output.auth, context)
            : undefined,
        confirmationUrl: __expectString(output.confirmationUrl),
        headers: output.headers !== undefined && output.headers !== null
            ? deserializeAws_restJson1HeaderList(output.headers, context)
            : undefined,
        url: __expectString(output.url),
    };
};
var deserializeAws_restJson1HttpActionHeader = function (output, context) {
    return {
        key: __expectString(output.key),
        value: __expectString(output.value),
    };
};
var deserializeAws_restJson1HttpAuthorization = function (output, context) {
    return {
        sigv4: output.sigv4 !== undefined && output.sigv4 !== null
            ? deserializeAws_restJson1SigV4Authorization(output.sigv4, context)
            : undefined,
    };
};
var deserializeAws_restJson1HttpUrlDestinationProperties = function (output, context) {
    return {
        confirmationUrl: __expectString(output.confirmationUrl),
    };
};
var deserializeAws_restJson1HttpUrlDestinationSummary = function (output, context) {
    return {
        confirmationUrl: __expectString(output.confirmationUrl),
    };
};
var deserializeAws_restJson1ImplicitDeny = function (output, context) {
    return {
        policies: output.policies !== undefined && output.policies !== null
            ? deserializeAws_restJson1Policies(output.policies, context)
            : undefined,
    };
};
var deserializeAws_restJson1IndexNamesList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1IotAnalyticsAction = function (output, context) {
    return {
        batchMode: __expectBoolean(output.batchMode),
        channelArn: __expectString(output.channelArn),
        channelName: __expectString(output.channelName),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1IotEventsAction = function (output, context) {
    return {
        batchMode: __expectBoolean(output.batchMode),
        inputName: __expectString(output.inputName),
        messageId: __expectString(output.messageId),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1IotSiteWiseAction = function (output, context) {
    return {
        putAssetPropertyValueEntries: output.putAssetPropertyValueEntries !== undefined && output.putAssetPropertyValueEntries !== null
            ? deserializeAws_restJson1PutAssetPropertyValueEntryList(output.putAssetPropertyValueEntries, context)
            : undefined,
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1Job = function (output, context) {
    return {
        abortConfig: output.abortConfig !== undefined && output.abortConfig !== null
            ? deserializeAws_restJson1AbortConfig(output.abortConfig, context)
            : undefined,
        comment: __expectString(output.comment),
        completedAt: output.completedAt !== undefined && output.completedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.completedAt)))
            : undefined,
        createdAt: output.createdAt !== undefined && output.createdAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdAt)))
            : undefined,
        description: __expectString(output.description),
        documentParameters: output.documentParameters !== undefined && output.documentParameters !== null
            ? deserializeAws_restJson1ParameterMap(output.documentParameters, context)
            : undefined,
        forceCanceled: __expectBoolean(output.forceCanceled),
        isConcurrent: __expectBoolean(output.isConcurrent),
        jobArn: __expectString(output.jobArn),
        jobExecutionsRetryConfig: output.jobExecutionsRetryConfig !== undefined && output.jobExecutionsRetryConfig !== null
            ? deserializeAws_restJson1JobExecutionsRetryConfig(output.jobExecutionsRetryConfig, context)
            : undefined,
        jobExecutionsRolloutConfig: output.jobExecutionsRolloutConfig !== undefined && output.jobExecutionsRolloutConfig !== null
            ? deserializeAws_restJson1JobExecutionsRolloutConfig(output.jobExecutionsRolloutConfig, context)
            : undefined,
        jobId: __expectString(output.jobId),
        jobProcessDetails: output.jobProcessDetails !== undefined && output.jobProcessDetails !== null
            ? deserializeAws_restJson1JobProcessDetails(output.jobProcessDetails, context)
            : undefined,
        jobTemplateArn: __expectString(output.jobTemplateArn),
        lastUpdatedAt: output.lastUpdatedAt !== undefined && output.lastUpdatedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedAt)))
            : undefined,
        namespaceId: __expectString(output.namespaceId),
        presignedUrlConfig: output.presignedUrlConfig !== undefined && output.presignedUrlConfig !== null
            ? deserializeAws_restJson1PresignedUrlConfig(output.presignedUrlConfig, context)
            : undefined,
        reasonCode: __expectString(output.reasonCode),
        status: __expectString(output.status),
        targetSelection: __expectString(output.targetSelection),
        targets: output.targets !== undefined && output.targets !== null
            ? deserializeAws_restJson1JobTargets(output.targets, context)
            : undefined,
        timeoutConfig: output.timeoutConfig !== undefined && output.timeoutConfig !== null
            ? deserializeAws_restJson1TimeoutConfig(output.timeoutConfig, context)
            : undefined,
    };
};
var deserializeAws_restJson1JobExecution = function (output, context) {
    return {
        approximateSecondsBeforeTimedOut: __expectLong(output.approximateSecondsBeforeTimedOut),
        executionNumber: __expectLong(output.executionNumber),
        forceCanceled: __expectBoolean(output.forceCanceled),
        jobId: __expectString(output.jobId),
        lastUpdatedAt: output.lastUpdatedAt !== undefined && output.lastUpdatedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedAt)))
            : undefined,
        queuedAt: output.queuedAt !== undefined && output.queuedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.queuedAt)))
            : undefined,
        startedAt: output.startedAt !== undefined && output.startedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startedAt)))
            : undefined,
        status: __expectString(output.status),
        statusDetails: output.statusDetails !== undefined && output.statusDetails !== null
            ? deserializeAws_restJson1JobExecutionStatusDetails(output.statusDetails, context)
            : undefined,
        thingArn: __expectString(output.thingArn),
        versionNumber: __expectLong(output.versionNumber),
    };
};
var deserializeAws_restJson1JobExecutionsRetryConfig = function (output, context) {
    return {
        criteriaList: output.criteriaList !== undefined && output.criteriaList !== null
            ? deserializeAws_restJson1RetryCriteriaList(output.criteriaList, context)
            : undefined,
    };
};
var deserializeAws_restJson1JobExecutionsRolloutConfig = function (output, context) {
    return {
        exponentialRate: output.exponentialRate !== undefined && output.exponentialRate !== null
            ? deserializeAws_restJson1ExponentialRolloutRate(output.exponentialRate, context)
            : undefined,
        maximumPerMinute: __expectInt32(output.maximumPerMinute),
    };
};
var deserializeAws_restJson1JobExecutionStatusDetails = function (output, context) {
    return {
        detailsMap: output.detailsMap !== undefined && output.detailsMap !== null
            ? deserializeAws_restJson1DetailsMap(output.detailsMap, context)
            : undefined,
    };
};
var deserializeAws_restJson1JobExecutionSummary = function (output, context) {
    return {
        executionNumber: __expectLong(output.executionNumber),
        lastUpdatedAt: output.lastUpdatedAt !== undefined && output.lastUpdatedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedAt)))
            : undefined,
        queuedAt: output.queuedAt !== undefined && output.queuedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.queuedAt)))
            : undefined,
        retryAttempt: __expectInt32(output.retryAttempt),
        startedAt: output.startedAt !== undefined && output.startedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startedAt)))
            : undefined,
        status: __expectString(output.status),
    };
};
var deserializeAws_restJson1JobExecutionSummaryForJob = function (output, context) {
    return {
        jobExecutionSummary: output.jobExecutionSummary !== undefined && output.jobExecutionSummary !== null
            ? deserializeAws_restJson1JobExecutionSummary(output.jobExecutionSummary, context)
            : undefined,
        thingArn: __expectString(output.thingArn),
    };
};
var deserializeAws_restJson1JobExecutionSummaryForJobList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1JobExecutionSummaryForJob(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1JobExecutionSummaryForThing = function (output, context) {
    return {
        jobExecutionSummary: output.jobExecutionSummary !== undefined && output.jobExecutionSummary !== null
            ? deserializeAws_restJson1JobExecutionSummary(output.jobExecutionSummary, context)
            : undefined,
        jobId: __expectString(output.jobId),
    };
};
var deserializeAws_restJson1JobExecutionSummaryForThingList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1JobExecutionSummaryForThing(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1JobProcessDetails = function (output, context) {
    return {
        numberOfCanceledThings: __expectInt32(output.numberOfCanceledThings),
        numberOfFailedThings: __expectInt32(output.numberOfFailedThings),
        numberOfInProgressThings: __expectInt32(output.numberOfInProgressThings),
        numberOfQueuedThings: __expectInt32(output.numberOfQueuedThings),
        numberOfRejectedThings: __expectInt32(output.numberOfRejectedThings),
        numberOfRemovedThings: __expectInt32(output.numberOfRemovedThings),
        numberOfSucceededThings: __expectInt32(output.numberOfSucceededThings),
        numberOfTimedOutThings: __expectInt32(output.numberOfTimedOutThings),
        processingTargets: output.processingTargets !== undefined && output.processingTargets !== null
            ? deserializeAws_restJson1ProcessingTargetNameList(output.processingTargets, context)
            : undefined,
    };
};
var deserializeAws_restJson1JobSummary = function (output, context) {
    return {
        completedAt: output.completedAt !== undefined && output.completedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.completedAt)))
            : undefined,
        createdAt: output.createdAt !== undefined && output.createdAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdAt)))
            : undefined,
        isConcurrent: __expectBoolean(output.isConcurrent),
        jobArn: __expectString(output.jobArn),
        jobId: __expectString(output.jobId),
        lastUpdatedAt: output.lastUpdatedAt !== undefined && output.lastUpdatedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedAt)))
            : undefined,
        status: __expectString(output.status),
        targetSelection: __expectString(output.targetSelection),
        thingGroupId: __expectString(output.thingGroupId),
    };
};
var deserializeAws_restJson1JobSummaryList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1JobSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1JobTargets = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1JobTemplateSummary = function (output, context) {
    return {
        createdAt: output.createdAt !== undefined && output.createdAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdAt)))
            : undefined,
        description: __expectString(output.description),
        jobTemplateArn: __expectString(output.jobTemplateArn),
        jobTemplateId: __expectString(output.jobTemplateId),
    };
};
var deserializeAws_restJson1JobTemplateSummaryList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1JobTemplateSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1KafkaAction = function (output, context) {
    return {
        clientProperties: output.clientProperties !== undefined && output.clientProperties !== null
            ? deserializeAws_restJson1ClientProperties(output.clientProperties, context)
            : undefined,
        destinationArn: __expectString(output.destinationArn),
        key: __expectString(output.key),
        partition: __expectString(output.partition),
        topic: __expectString(output.topic),
    };
};
var deserializeAws_restJson1KeyPair = function (output, context) {
    return {
        PrivateKey: __expectString(output.PrivateKey),
        PublicKey: __expectString(output.PublicKey),
    };
};
var deserializeAws_restJson1KinesisAction = function (output, context) {
    return {
        partitionKey: __expectString(output.partitionKey),
        roleArn: __expectString(output.roleArn),
        streamName: __expectString(output.streamName),
    };
};
var deserializeAws_restJson1LambdaAction = function (output, context) {
    return {
        functionArn: __expectString(output.functionArn),
    };
};
var deserializeAws_restJson1LogTarget = function (output, context) {
    return {
        targetName: __expectString(output.targetName),
        targetType: __expectString(output.targetType),
    };
};
var deserializeAws_restJson1LogTargetConfiguration = function (output, context) {
    return {
        logLevel: __expectString(output.logLevel),
        logTarget: output.logTarget !== undefined && output.logTarget !== null
            ? deserializeAws_restJson1LogTarget(output.logTarget, context)
            : undefined,
    };
};
var deserializeAws_restJson1LogTargetConfigurations = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1LogTargetConfiguration(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1MachineLearningDetectionConfig = function (output, context) {
    return {
        confidenceLevel: __expectString(output.confidenceLevel),
    };
};
var deserializeAws_restJson1ManagedJobTemplatesSummaryList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ManagedJobTemplateSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ManagedJobTemplateSummary = function (output, context) {
    return {
        description: __expectString(output.description),
        environments: output.environments !== undefined && output.environments !== null
            ? deserializeAws_restJson1Environments(output.environments, context)
            : undefined,
        templateArn: __expectString(output.templateArn),
        templateName: __expectString(output.templateName),
        templateVersion: __expectString(output.templateVersion),
    };
};
var deserializeAws_restJson1MetricDatum = function (output, context) {
    return {
        timestamp: output.timestamp !== undefined && output.timestamp !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.timestamp)))
            : undefined,
        value: output.value !== undefined && output.value !== null
            ? deserializeAws_restJson1MetricValue(output.value, context)
            : undefined,
    };
};
var deserializeAws_restJson1MetricDatumList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MetricDatum(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1MetricDimension = function (output, context) {
    return {
        dimensionName: __expectString(output.dimensionName),
        operator: __expectString(output.operator),
    };
};
var deserializeAws_restJson1MetricNames = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1MetricToRetain = function (output, context) {
    return {
        metric: __expectString(output.metric),
        metricDimension: output.metricDimension !== undefined && output.metricDimension !== null
            ? deserializeAws_restJson1MetricDimension(output.metricDimension, context)
            : undefined,
    };
};
var deserializeAws_restJson1MetricValue = function (output, context) {
    return {
        cidrs: output.cidrs !== undefined && output.cidrs !== null
            ? deserializeAws_restJson1Cidrs(output.cidrs, context)
            : undefined,
        count: __expectLong(output.count),
        number: __limitedParseDouble(output.number),
        numbers: output.numbers !== undefined && output.numbers !== null
            ? deserializeAws_restJson1NumberList(output.numbers, context)
            : undefined,
        ports: output.ports !== undefined && output.ports !== null
            ? deserializeAws_restJson1Ports(output.ports, context)
            : undefined,
        strings: output.strings !== undefined && output.strings !== null
            ? deserializeAws_restJson1StringList(output.strings, context)
            : undefined,
    };
};
var deserializeAws_restJson1MissingContextValues = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1MitigationAction = function (output, context) {
    return {
        actionParams: output.actionParams !== undefined && output.actionParams !== null
            ? deserializeAws_restJson1MitigationActionParams(output.actionParams, context)
            : undefined,
        id: __expectString(output.id),
        name: __expectString(output.name),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1MitigationActionIdentifier = function (output, context) {
    return {
        actionArn: __expectString(output.actionArn),
        actionName: __expectString(output.actionName),
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
    };
};
var deserializeAws_restJson1MitigationActionIdentifierList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MitigationActionIdentifier(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1MitigationActionList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MitigationAction(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1MitigationActionNameList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1MitigationActionParams = function (output, context) {
    return {
        addThingsToThingGroupParams: output.addThingsToThingGroupParams !== undefined && output.addThingsToThingGroupParams !== null
            ? deserializeAws_restJson1AddThingsToThingGroupParams(output.addThingsToThingGroupParams, context)
            : undefined,
        enableIoTLoggingParams: output.enableIoTLoggingParams !== undefined && output.enableIoTLoggingParams !== null
            ? deserializeAws_restJson1EnableIoTLoggingParams(output.enableIoTLoggingParams, context)
            : undefined,
        publishFindingToSnsParams: output.publishFindingToSnsParams !== undefined && output.publishFindingToSnsParams !== null
            ? deserializeAws_restJson1PublishFindingToSnsParams(output.publishFindingToSnsParams, context)
            : undefined,
        replaceDefaultPolicyVersionParams: output.replaceDefaultPolicyVersionParams !== undefined && output.replaceDefaultPolicyVersionParams !== null
            ? deserializeAws_restJson1ReplaceDefaultPolicyVersionParams(output.replaceDefaultPolicyVersionParams, context)
            : undefined,
        updateCACertificateParams: output.updateCACertificateParams !== undefined && output.updateCACertificateParams !== null
            ? deserializeAws_restJson1UpdateCACertificateParams(output.updateCACertificateParams, context)
            : undefined,
        updateDeviceCertificateParams: output.updateDeviceCertificateParams !== undefined && output.updateDeviceCertificateParams !== null
            ? deserializeAws_restJson1UpdateDeviceCertificateParams(output.updateDeviceCertificateParams, context)
            : undefined,
    };
};
var deserializeAws_restJson1NonCompliantResource = function (output, context) {
    return {
        additionalInfo: output.additionalInfo !== undefined && output.additionalInfo !== null
            ? deserializeAws_restJson1StringMap(output.additionalInfo, context)
            : undefined,
        resourceIdentifier: output.resourceIdentifier !== undefined && output.resourceIdentifier !== null
            ? deserializeAws_restJson1ResourceIdentifier(output.resourceIdentifier, context)
            : undefined,
        resourceType: __expectString(output.resourceType),
    };
};
var deserializeAws_restJson1NumberList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __limitedParseDouble(entry);
    });
    return retVal;
};
var deserializeAws_restJson1OpenSearchAction = function (output, context) {
    return {
        endpoint: __expectString(output.endpoint),
        id: __expectString(output.id),
        index: __expectString(output.index),
        roleArn: __expectString(output.roleArn),
        type: __expectString(output.type),
    };
};
var deserializeAws_restJson1OTAUpdateFile = function (output, context) {
    return {
        attributes: output.attributes !== undefined && output.attributes !== null
            ? deserializeAws_restJson1AttributesMap(output.attributes, context)
            : undefined,
        codeSigning: output.codeSigning !== undefined && output.codeSigning !== null
            ? deserializeAws_restJson1CodeSigning(output.codeSigning, context)
            : undefined,
        fileLocation: output.fileLocation !== undefined && output.fileLocation !== null
            ? deserializeAws_restJson1FileLocation(output.fileLocation, context)
            : undefined,
        fileName: __expectString(output.fileName),
        fileType: __expectInt32(output.fileType),
        fileVersion: __expectString(output.fileVersion),
    };
};
var deserializeAws_restJson1OTAUpdateFiles = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OTAUpdateFile(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1OTAUpdateInfo = function (output, context) {
    return {
        additionalParameters: output.additionalParameters !== undefined && output.additionalParameters !== null
            ? deserializeAws_restJson1AdditionalParameterMap(output.additionalParameters, context)
            : undefined,
        awsIotJobArn: __expectString(output.awsIotJobArn),
        awsIotJobId: __expectString(output.awsIotJobId),
        awsJobExecutionsRolloutConfig: output.awsJobExecutionsRolloutConfig !== undefined && output.awsJobExecutionsRolloutConfig !== null
            ? deserializeAws_restJson1AwsJobExecutionsRolloutConfig(output.awsJobExecutionsRolloutConfig, context)
            : undefined,
        awsJobPresignedUrlConfig: output.awsJobPresignedUrlConfig !== undefined && output.awsJobPresignedUrlConfig !== null
            ? deserializeAws_restJson1AwsJobPresignedUrlConfig(output.awsJobPresignedUrlConfig, context)
            : undefined,
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        description: __expectString(output.description),
        errorInfo: output.errorInfo !== undefined && output.errorInfo !== null
            ? deserializeAws_restJson1ErrorInfo(output.errorInfo, context)
            : undefined,
        lastModifiedDate: output.lastModifiedDate !== undefined && output.lastModifiedDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate)))
            : undefined,
        otaUpdateArn: __expectString(output.otaUpdateArn),
        otaUpdateFiles: output.otaUpdateFiles !== undefined && output.otaUpdateFiles !== null
            ? deserializeAws_restJson1OTAUpdateFiles(output.otaUpdateFiles, context)
            : undefined,
        otaUpdateId: __expectString(output.otaUpdateId),
        otaUpdateStatus: __expectString(output.otaUpdateStatus),
        protocols: output.protocols !== undefined && output.protocols !== null
            ? deserializeAws_restJson1Protocols(output.protocols, context)
            : undefined,
        targetSelection: __expectString(output.targetSelection),
        targets: output.targets !== undefined && output.targets !== null
            ? deserializeAws_restJson1Targets(output.targets, context)
            : undefined,
    };
};
var deserializeAws_restJson1OTAUpdatesSummary = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OTAUpdateSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1OTAUpdateSummary = function (output, context) {
    return {
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        otaUpdateArn: __expectString(output.otaUpdateArn),
        otaUpdateId: __expectString(output.otaUpdateId),
    };
};
var deserializeAws_restJson1OutgoingCertificate = function (output, context) {
    return {
        certificateArn: __expectString(output.certificateArn),
        certificateId: __expectString(output.certificateId),
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        transferDate: output.transferDate !== undefined && output.transferDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.transferDate)))
            : undefined,
        transferMessage: __expectString(output.transferMessage),
        transferredTo: __expectString(output.transferredTo),
    };
};
var deserializeAws_restJson1OutgoingCertificates = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OutgoingCertificate(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ParameterMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1Percentiles = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PercentPair(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PercentPair = function (output, context) {
    return {
        percent: __limitedParseDouble(output.percent),
        value: __limitedParseDouble(output.value),
    };
};
var deserializeAws_restJson1Policies = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Policy(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1Policy = function (output, context) {
    return {
        policyArn: __expectString(output.policyArn),
        policyName: __expectString(output.policyName),
    };
};
var deserializeAws_restJson1PolicyDocuments = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1PolicyTargets = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1PolicyVersion = function (output, context) {
    return {
        createDate: output.createDate !== undefined && output.createDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createDate)))
            : undefined,
        isDefaultVersion: __expectBoolean(output.isDefaultVersion),
        versionId: __expectString(output.versionId),
    };
};
var deserializeAws_restJson1PolicyVersionIdentifier = function (output, context) {
    return {
        policyName: __expectString(output.policyName),
        policyVersionId: __expectString(output.policyVersionId),
    };
};
var deserializeAws_restJson1PolicyVersions = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PolicyVersion(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1Ports = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectInt32(entry);
    });
    return retVal;
};
var deserializeAws_restJson1PresignedUrlConfig = function (output, context) {
    return {
        expiresInSec: __expectLong(output.expiresInSec),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1Principals = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1ProcessingTargetNameList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1Protocols = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1ProvisioningHook = function (output, context) {
    return {
        payloadVersion: __expectString(output.payloadVersion),
        targetArn: __expectString(output.targetArn),
    };
};
var deserializeAws_restJson1ProvisioningTemplateListing = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ProvisioningTemplateSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ProvisioningTemplateSummary = function (output, context) {
    return {
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        description: __expectString(output.description),
        enabled: __expectBoolean(output.enabled),
        lastModifiedDate: output.lastModifiedDate !== undefined && output.lastModifiedDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate)))
            : undefined,
        templateArn: __expectString(output.templateArn),
        templateName: __expectString(output.templateName),
    };
};
var deserializeAws_restJson1ProvisioningTemplateVersionListing = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ProvisioningTemplateVersionSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ProvisioningTemplateVersionSummary = function (output, context) {
    return {
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        isDefaultVersion: __expectBoolean(output.isDefaultVersion),
        versionId: __expectInt32(output.versionId),
    };
};
var deserializeAws_restJson1PublicKeyMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1PublishFindingToSnsParams = function (output, context) {
    return {
        topicArn: __expectString(output.topicArn),
    };
};
var deserializeAws_restJson1PutAssetPropertyValueEntry = function (output, context) {
    return {
        assetId: __expectString(output.assetId),
        entryId: __expectString(output.entryId),
        propertyAlias: __expectString(output.propertyAlias),
        propertyId: __expectString(output.propertyId),
        propertyValues: output.propertyValues !== undefined && output.propertyValues !== null
            ? deserializeAws_restJson1AssetPropertyValueList(output.propertyValues, context)
            : undefined,
    };
};
var deserializeAws_restJson1PutAssetPropertyValueEntryList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PutAssetPropertyValueEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PutItemInput = function (output, context) {
    return {
        tableName: __expectString(output.tableName),
    };
};
var deserializeAws_restJson1RateIncreaseCriteria = function (output, context) {
    return {
        numberOfNotifiedThings: __expectInt32(output.numberOfNotifiedThings),
        numberOfSucceededThings: __expectInt32(output.numberOfSucceededThings),
    };
};
var deserializeAws_restJson1ReasonForNonComplianceCodes = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1RegistrationConfig = function (output, context) {
    return {
        roleArn: __expectString(output.roleArn),
        templateBody: __expectString(output.templateBody),
    };
};
var deserializeAws_restJson1RelatedResource = function (output, context) {
    return {
        additionalInfo: output.additionalInfo !== undefined && output.additionalInfo !== null
            ? deserializeAws_restJson1StringMap(output.additionalInfo, context)
            : undefined,
        resourceIdentifier: output.resourceIdentifier !== undefined && output.resourceIdentifier !== null
            ? deserializeAws_restJson1ResourceIdentifier(output.resourceIdentifier, context)
            : undefined,
        resourceType: __expectString(output.resourceType),
    };
};
var deserializeAws_restJson1RelatedResources = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1RelatedResource(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ReplaceDefaultPolicyVersionParams = function (output, context) {
    return {
        templateName: __expectString(output.templateName),
    };
};
var deserializeAws_restJson1RepublishAction = function (output, context) {
    return {
        qos: __expectInt32(output.qos),
        roleArn: __expectString(output.roleArn),
        topic: __expectString(output.topic),
    };
};
var deserializeAws_restJson1ResourceArns = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1ResourceIdentifier = function (output, context) {
    return {
        account: __expectString(output.account),
        caCertificateId: __expectString(output.caCertificateId),
        clientId: __expectString(output.clientId),
        cognitoIdentityPoolId: __expectString(output.cognitoIdentityPoolId),
        deviceCertificateId: __expectString(output.deviceCertificateId),
        iamRoleArn: __expectString(output.iamRoleArn),
        policyVersionIdentifier: output.policyVersionIdentifier !== undefined && output.policyVersionIdentifier !== null
            ? deserializeAws_restJson1PolicyVersionIdentifier(output.policyVersionIdentifier, context)
            : undefined,
        roleAliasArn: __expectString(output.roleAliasArn),
    };
};
var deserializeAws_restJson1Resources = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1RetryCriteria = function (output, context) {
    return {
        failureType: __expectString(output.failureType),
        numberOfRetries: __expectInt32(output.numberOfRetries),
    };
};
var deserializeAws_restJson1RetryCriteriaList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1RetryCriteria(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1RoleAliasDescription = function (output, context) {
    return {
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        credentialDurationSeconds: __expectInt32(output.credentialDurationSeconds),
        lastModifiedDate: output.lastModifiedDate !== undefined && output.lastModifiedDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate)))
            : undefined,
        owner: __expectString(output.owner),
        roleAlias: __expectString(output.roleAlias),
        roleAliasArn: __expectString(output.roleAliasArn),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1RoleAliases = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1S3Action = function (output, context) {
    return {
        bucketName: __expectString(output.bucketName),
        cannedAcl: __expectString(output.cannedAcl),
        key: __expectString(output.key),
        roleArn: __expectString(output.roleArn),
    };
};
var deserializeAws_restJson1S3Destination = function (output, context) {
    return {
        bucket: __expectString(output.bucket),
        prefix: __expectString(output.prefix),
    };
};
var deserializeAws_restJson1S3FileUrlList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1S3Location = function (output, context) {
    return {
        bucket: __expectString(output.bucket),
        key: __expectString(output.key),
        version: __expectString(output.version),
    };
};
var deserializeAws_restJson1SalesforceAction = function (output, context) {
    return {
        token: __expectString(output.token),
        url: __expectString(output.url),
    };
};
var deserializeAws_restJson1ScheduledAuditMetadata = function (output, context) {
    return {
        dayOfMonth: __expectString(output.dayOfMonth),
        dayOfWeek: __expectString(output.dayOfWeek),
        frequency: __expectString(output.frequency),
        scheduledAuditArn: __expectString(output.scheduledAuditArn),
        scheduledAuditName: __expectString(output.scheduledAuditName),
    };
};
var deserializeAws_restJson1ScheduledAuditMetadataList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ScheduledAuditMetadata(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchableAttributes = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1SecurityGroupList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1SecurityProfileIdentifier = function (output, context) {
    return {
        arn: __expectString(output.arn),
        name: __expectString(output.name),
    };
};
var deserializeAws_restJson1SecurityProfileIdentifiers = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1SecurityProfileIdentifier(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SecurityProfileTarget = function (output, context) {
    return {
        arn: __expectString(output.arn),
    };
};
var deserializeAws_restJson1SecurityProfileTargetMapping = function (output, context) {
    return {
        securityProfileIdentifier: output.securityProfileIdentifier !== undefined && output.securityProfileIdentifier !== null
            ? deserializeAws_restJson1SecurityProfileIdentifier(output.securityProfileIdentifier, context)
            : undefined,
        target: output.target !== undefined && output.target !== null
            ? deserializeAws_restJson1SecurityProfileTarget(output.target, context)
            : undefined,
    };
};
var deserializeAws_restJson1SecurityProfileTargetMappings = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1SecurityProfileTargetMapping(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SecurityProfileTargets = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1SecurityProfileTarget(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ServerCertificates = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ServerCertificateSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ServerCertificateSummary = function (output, context) {
    return {
        serverCertificateArn: __expectString(output.serverCertificateArn),
        serverCertificateStatus: __expectString(output.serverCertificateStatus),
        serverCertificateStatusDetail: __expectString(output.serverCertificateStatusDetail),
    };
};
var deserializeAws_restJson1SigningProfileParameter = function (output, context) {
    return {
        certificateArn: __expectString(output.certificateArn),
        certificatePathOnDevice: __expectString(output.certificatePathOnDevice),
        platform: __expectString(output.platform),
    };
};
var deserializeAws_restJson1SigV4Authorization = function (output, context) {
    return {
        roleArn: __expectString(output.roleArn),
        serviceName: __expectString(output.serviceName),
        signingRegion: __expectString(output.signingRegion),
    };
};
var deserializeAws_restJson1SnsAction = function (output, context) {
    return {
        messageFormat: __expectString(output.messageFormat),
        roleArn: __expectString(output.roleArn),
        targetArn: __expectString(output.targetArn),
    };
};
var deserializeAws_restJson1SqsAction = function (output, context) {
    return {
        queueUrl: __expectString(output.queueUrl),
        roleArn: __expectString(output.roleArn),
        useBase64: __expectBoolean(output.useBase64),
    };
};
var deserializeAws_restJson1StartSigningJobParameter = function (output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null
            ? deserializeAws_restJson1Destination(output.destination, context)
            : undefined,
        signingProfileName: __expectString(output.signingProfileName),
        signingProfileParameter: output.signingProfileParameter !== undefined && output.signingProfileParameter !== null
            ? deserializeAws_restJson1SigningProfileParameter(output.signingProfileParameter, context)
            : undefined,
    };
};
var deserializeAws_restJson1StatisticalThreshold = function (output, context) {
    return {
        statistic: __expectString(output.statistic),
    };
};
var deserializeAws_restJson1Statistics = function (output, context) {
    return {
        average: __limitedParseDouble(output.average),
        count: __expectInt32(output.count),
        maximum: __limitedParseDouble(output.maximum),
        minimum: __limitedParseDouble(output.minimum),
        stdDeviation: __limitedParseDouble(output.stdDeviation),
        sum: __limitedParseDouble(output.sum),
        sumOfSquares: __limitedParseDouble(output.sumOfSquares),
        variance: __limitedParseDouble(output.variance),
    };
};
var deserializeAws_restJson1StepFunctionsAction = function (output, context) {
    return {
        executionNamePrefix: __expectString(output.executionNamePrefix),
        roleArn: __expectString(output.roleArn),
        stateMachineName: __expectString(output.stateMachineName),
    };
};
var deserializeAws_restJson1_Stream = function (output, context) {
    return {
        fileId: __expectInt32(output.fileId),
        streamId: __expectString(output.streamId),
    };
};
var deserializeAws_restJson1StreamFile = function (output, context) {
    return {
        fileId: __expectInt32(output.fileId),
        s3Location: output.s3Location !== undefined && output.s3Location !== null
            ? deserializeAws_restJson1S3Location(output.s3Location, context)
            : undefined,
    };
};
var deserializeAws_restJson1StreamFiles = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1StreamFile(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1StreamInfo = function (output, context) {
    return {
        createdAt: output.createdAt !== undefined && output.createdAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdAt)))
            : undefined,
        description: __expectString(output.description),
        files: output.files !== undefined && output.files !== null
            ? deserializeAws_restJson1StreamFiles(output.files, context)
            : undefined,
        lastUpdatedAt: output.lastUpdatedAt !== undefined && output.lastUpdatedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedAt)))
            : undefined,
        roleArn: __expectString(output.roleArn),
        streamArn: __expectString(output.streamArn),
        streamId: __expectString(output.streamId),
        streamVersion: __expectInt32(output.streamVersion),
    };
};
var deserializeAws_restJson1StreamsSummary = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1StreamSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1StreamSummary = function (output, context) {
    return {
        description: __expectString(output.description),
        streamArn: __expectString(output.streamArn),
        streamId: __expectString(output.streamId),
        streamVersion: __expectInt32(output.streamVersion),
    };
};
var deserializeAws_restJson1StringList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1StringMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __expectString(value), _b));
    }, {});
};
var deserializeAws_restJson1SubnetIdList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1Tag = function (output, context) {
    return {
        Key: __expectString(output.Key),
        Value: __expectString(output.Value),
    };
};
var deserializeAws_restJson1TagList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Tag(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1TargetAuditCheckNames = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1Targets = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1TargetViolationIdsForDetectMitigationActions = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1TaskIdList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1TaskStatistics = function (output, context) {
    return {
        canceledChecks: __expectInt32(output.canceledChecks),
        compliantChecks: __expectInt32(output.compliantChecks),
        failedChecks: __expectInt32(output.failedChecks),
        inProgressChecks: __expectInt32(output.inProgressChecks),
        nonCompliantChecks: __expectInt32(output.nonCompliantChecks),
        totalChecks: __expectInt32(output.totalChecks),
        waitingForDataCollectionChecks: __expectInt32(output.waitingForDataCollectionChecks),
    };
};
var deserializeAws_restJson1TaskStatisticsForAuditCheck = function (output, context) {
    return {
        canceledFindingsCount: __expectLong(output.canceledFindingsCount),
        failedFindingsCount: __expectLong(output.failedFindingsCount),
        skippedFindingsCount: __expectLong(output.skippedFindingsCount),
        succeededFindingsCount: __expectLong(output.succeededFindingsCount),
        totalFindingsCount: __expectLong(output.totalFindingsCount),
    };
};
var deserializeAws_restJson1ThingAttribute = function (output, context) {
    return {
        attributes: output.attributes !== undefined && output.attributes !== null
            ? deserializeAws_restJson1Attributes(output.attributes, context)
            : undefined,
        thingArn: __expectString(output.thingArn),
        thingName: __expectString(output.thingName),
        thingTypeName: __expectString(output.thingTypeName),
        version: __expectLong(output.version),
    };
};
var deserializeAws_restJson1ThingAttributeList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ThingAttribute(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ThingConnectivity = function (output, context) {
    return {
        connected: __expectBoolean(output.connected),
        disconnectReason: __expectString(output.disconnectReason),
        timestamp: __expectLong(output.timestamp),
    };
};
var deserializeAws_restJson1ThingDocument = function (output, context) {
    return {
        attributes: output.attributes !== undefined && output.attributes !== null
            ? deserializeAws_restJson1Attributes(output.attributes, context)
            : undefined,
        connectivity: output.connectivity !== undefined && output.connectivity !== null
            ? deserializeAws_restJson1ThingConnectivity(output.connectivity, context)
            : undefined,
        deviceDefender: __expectString(output.deviceDefender),
        shadow: __expectString(output.shadow),
        thingGroupNames: output.thingGroupNames !== undefined && output.thingGroupNames !== null
            ? deserializeAws_restJson1ThingGroupNameList(output.thingGroupNames, context)
            : undefined,
        thingId: __expectString(output.thingId),
        thingName: __expectString(output.thingName),
        thingTypeName: __expectString(output.thingTypeName),
    };
};
var deserializeAws_restJson1ThingDocumentList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ThingDocument(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ThingGroupDocument = function (output, context) {
    return {
        attributes: output.attributes !== undefined && output.attributes !== null
            ? deserializeAws_restJson1Attributes(output.attributes, context)
            : undefined,
        parentGroupNames: output.parentGroupNames !== undefined && output.parentGroupNames !== null
            ? deserializeAws_restJson1ThingGroupNameList(output.parentGroupNames, context)
            : undefined,
        thingGroupDescription: __expectString(output.thingGroupDescription),
        thingGroupId: __expectString(output.thingGroupId),
        thingGroupName: __expectString(output.thingGroupName),
    };
};
var deserializeAws_restJson1ThingGroupDocumentList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ThingGroupDocument(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ThingGroupIndexingConfiguration = function (output, context) {
    return {
        customFields: output.customFields !== undefined && output.customFields !== null
            ? deserializeAws_restJson1Fields(output.customFields, context)
            : undefined,
        managedFields: output.managedFields !== undefined && output.managedFields !== null
            ? deserializeAws_restJson1Fields(output.managedFields, context)
            : undefined,
        thingGroupIndexingMode: __expectString(output.thingGroupIndexingMode),
    };
};
var deserializeAws_restJson1ThingGroupMetadata = function (output, context) {
    return {
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        parentGroupName: __expectString(output.parentGroupName),
        rootToParentThingGroups: output.rootToParentThingGroups !== undefined && output.rootToParentThingGroups !== null
            ? deserializeAws_restJson1ThingGroupNameAndArnList(output.rootToParentThingGroups, context)
            : undefined,
    };
};
var deserializeAws_restJson1ThingGroupNameAndArnList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1GroupNameAndArn(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ThingGroupNameList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1ThingGroupNames = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1ThingGroupProperties = function (output, context) {
    return {
        attributePayload: output.attributePayload !== undefined && output.attributePayload !== null
            ? deserializeAws_restJson1AttributePayload(output.attributePayload, context)
            : undefined,
        thingGroupDescription: __expectString(output.thingGroupDescription),
    };
};
var deserializeAws_restJson1ThingIndexingConfiguration = function (output, context) {
    return {
        customFields: output.customFields !== undefined && output.customFields !== null
            ? deserializeAws_restJson1Fields(output.customFields, context)
            : undefined,
        deviceDefenderIndexingMode: __expectString(output.deviceDefenderIndexingMode),
        managedFields: output.managedFields !== undefined && output.managedFields !== null
            ? deserializeAws_restJson1Fields(output.managedFields, context)
            : undefined,
        namedShadowIndexingMode: __expectString(output.namedShadowIndexingMode),
        thingConnectivityIndexingMode: __expectString(output.thingConnectivityIndexingMode),
        thingIndexingMode: __expectString(output.thingIndexingMode),
    };
};
var deserializeAws_restJson1ThingNameList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
var deserializeAws_restJson1ThingTypeDefinition = function (output, context) {
    return {
        thingTypeArn: __expectString(output.thingTypeArn),
        thingTypeMetadata: output.thingTypeMetadata !== undefined && output.thingTypeMetadata !== null
            ? deserializeAws_restJson1ThingTypeMetadata(output.thingTypeMetadata, context)
            : undefined,
        thingTypeName: __expectString(output.thingTypeName),
        thingTypeProperties: output.thingTypeProperties !== undefined && output.thingTypeProperties !== null
            ? deserializeAws_restJson1ThingTypeProperties(output.thingTypeProperties, context)
            : undefined,
    };
};
var deserializeAws_restJson1ThingTypeList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ThingTypeDefinition(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ThingTypeMetadata = function (output, context) {
    return {
        creationDate: output.creationDate !== undefined && output.creationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate)))
            : undefined,
        deprecated: __expectBoolean(output.deprecated),
        deprecationDate: output.deprecationDate !== undefined && output.deprecationDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.deprecationDate)))
            : undefined,
    };
};
var deserializeAws_restJson1ThingTypeProperties = function (output, context) {
    return {
        searchableAttributes: output.searchableAttributes !== undefined && output.searchableAttributes !== null
            ? deserializeAws_restJson1SearchableAttributes(output.searchableAttributes, context)
            : undefined,
        thingTypeDescription: __expectString(output.thingTypeDescription),
    };
};
var deserializeAws_restJson1TimeoutConfig = function (output, context) {
    return {
        inProgressTimeoutInMinutes: __expectLong(output.inProgressTimeoutInMinutes),
    };
};
var deserializeAws_restJson1TimestreamAction = function (output, context) {
    return {
        databaseName: __expectString(output.databaseName),
        dimensions: output.dimensions !== undefined && output.dimensions !== null
            ? deserializeAws_restJson1TimestreamDimensionList(output.dimensions, context)
            : undefined,
        roleArn: __expectString(output.roleArn),
        tableName: __expectString(output.tableName),
        timestamp: output.timestamp !== undefined && output.timestamp !== null
            ? deserializeAws_restJson1TimestreamTimestamp(output.timestamp, context)
            : undefined,
    };
};
var deserializeAws_restJson1TimestreamDimension = function (output, context) {
    return {
        name: __expectString(output.name),
        value: __expectString(output.value),
    };
};
var deserializeAws_restJson1TimestreamDimensionList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1TimestreamDimension(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1TimestreamTimestamp = function (output, context) {
    return {
        unit: __expectString(output.unit),
        value: __expectString(output.value),
    };
};
var deserializeAws_restJson1TopicRule = function (output, context) {
    return {
        actions: output.actions !== undefined && output.actions !== null
            ? deserializeAws_restJson1ActionList(output.actions, context)
            : undefined,
        awsIotSqlVersion: __expectString(output.awsIotSqlVersion),
        createdAt: output.createdAt !== undefined && output.createdAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdAt)))
            : undefined,
        description: __expectString(output.description),
        errorAction: output.errorAction !== undefined && output.errorAction !== null
            ? deserializeAws_restJson1Action(output.errorAction, context)
            : undefined,
        ruleDisabled: __expectBoolean(output.ruleDisabled),
        ruleName: __expectString(output.ruleName),
        sql: __expectString(output.sql),
    };
};
var deserializeAws_restJson1TopicRuleDestination = function (output, context) {
    return {
        arn: __expectString(output.arn),
        createdAt: output.createdAt !== undefined && output.createdAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdAt)))
            : undefined,
        httpUrlProperties: output.httpUrlProperties !== undefined && output.httpUrlProperties !== null
            ? deserializeAws_restJson1HttpUrlDestinationProperties(output.httpUrlProperties, context)
            : undefined,
        lastUpdatedAt: output.lastUpdatedAt !== undefined && output.lastUpdatedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedAt)))
            : undefined,
        status: __expectString(output.status),
        statusReason: __expectString(output.statusReason),
        vpcProperties: output.vpcProperties !== undefined && output.vpcProperties !== null
            ? deserializeAws_restJson1VpcDestinationProperties(output.vpcProperties, context)
            : undefined,
    };
};
var deserializeAws_restJson1TopicRuleDestinationSummaries = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1TopicRuleDestinationSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1TopicRuleDestinationSummary = function (output, context) {
    return {
        arn: __expectString(output.arn),
        createdAt: output.createdAt !== undefined && output.createdAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdAt)))
            : undefined,
        httpUrlSummary: output.httpUrlSummary !== undefined && output.httpUrlSummary !== null
            ? deserializeAws_restJson1HttpUrlDestinationSummary(output.httpUrlSummary, context)
            : undefined,
        lastUpdatedAt: output.lastUpdatedAt !== undefined && output.lastUpdatedAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedAt)))
            : undefined,
        status: __expectString(output.status),
        statusReason: __expectString(output.statusReason),
        vpcDestinationSummary: output.vpcDestinationSummary !== undefined && output.vpcDestinationSummary !== null
            ? deserializeAws_restJson1VpcDestinationSummary(output.vpcDestinationSummary, context)
            : undefined,
    };
};
var deserializeAws_restJson1TopicRuleList = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1TopicRuleListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1TopicRuleListItem = function (output, context) {
    return {
        createdAt: output.createdAt !== undefined && output.createdAt !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdAt)))
            : undefined,
        ruleArn: __expectString(output.ruleArn),
        ruleDisabled: __expectBoolean(output.ruleDisabled),
        ruleName: __expectString(output.ruleName),
        topicPattern: __expectString(output.topicPattern),
    };
};
var deserializeAws_restJson1TransferData = function (output, context) {
    return {
        acceptDate: output.acceptDate !== undefined && output.acceptDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.acceptDate)))
            : undefined,
        rejectDate: output.rejectDate !== undefined && output.rejectDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.rejectDate)))
            : undefined,
        rejectReason: __expectString(output.rejectReason),
        transferDate: output.transferDate !== undefined && output.transferDate !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.transferDate)))
            : undefined,
        transferMessage: __expectString(output.transferMessage),
    };
};
var deserializeAws_restJson1UpdateCACertificateParams = function (output, context) {
    return {
        action: __expectString(output.action),
    };
};
var deserializeAws_restJson1UpdateDeviceCertificateParams = function (output, context) {
    return {
        action: __expectString(output.action),
    };
};
var deserializeAws_restJson1ValidationError = function (output, context) {
    return {
        errorMessage: __expectString(output.errorMessage),
    };
};
var deserializeAws_restJson1ValidationErrors = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ValidationError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ViolationEvent = function (output, context) {
    return {
        behavior: output.behavior !== undefined && output.behavior !== null
            ? deserializeAws_restJson1Behavior(output.behavior, context)
            : undefined,
        metricValue: output.metricValue !== undefined && output.metricValue !== null
            ? deserializeAws_restJson1MetricValue(output.metricValue, context)
            : undefined,
        securityProfileName: __expectString(output.securityProfileName),
        thingName: __expectString(output.thingName),
        verificationState: __expectString(output.verificationState),
        verificationStateDescription: __expectString(output.verificationStateDescription),
        violationEventAdditionalInfo: output.violationEventAdditionalInfo !== undefined && output.violationEventAdditionalInfo !== null
            ? deserializeAws_restJson1ViolationEventAdditionalInfo(output.violationEventAdditionalInfo, context)
            : undefined,
        violationEventTime: output.violationEventTime !== undefined && output.violationEventTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.violationEventTime)))
            : undefined,
        violationEventType: __expectString(output.violationEventType),
        violationId: __expectString(output.violationId),
    };
};
var deserializeAws_restJson1ViolationEventAdditionalInfo = function (output, context) {
    return {
        confidenceLevel: __expectString(output.confidenceLevel),
    };
};
var deserializeAws_restJson1ViolationEventOccurrenceRange = function (output, context) {
    return {
        endTime: output.endTime !== undefined && output.endTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.endTime)))
            : undefined,
        startTime: output.startTime !== undefined && output.startTime !== null
            ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startTime)))
            : undefined,
    };
};
var deserializeAws_restJson1ViolationEvents = function (output, context) {
    var retVal = (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ViolationEvent(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1VpcDestinationProperties = function (output, context) {
    return {
        roleArn: __expectString(output.roleArn),
        securityGroups: output.securityGroups !== undefined && output.securityGroups !== null
            ? deserializeAws_restJson1SecurityGroupList(output.securityGroups, context)
            : undefined,
        subnetIds: output.subnetIds !== undefined && output.subnetIds !== null
            ? deserializeAws_restJson1SubnetIdList(output.subnetIds, context)
            : undefined,
        vpcId: __expectString(output.vpcId),
    };
};
var deserializeAws_restJson1VpcDestinationSummary = function (output, context) {
    return {
        roleArn: __expectString(output.roleArn),
        securityGroups: output.securityGroups !== undefined && output.securityGroups !== null
            ? deserializeAws_restJson1SecurityGroupList(output.securityGroups, context)
            : undefined,
        subnetIds: output.subnetIds !== undefined && output.subnetIds !== null
            ? deserializeAws_restJson1SubnetIdList(output.subnetIds, context)
            : undefined,
        vpcId: __expectString(output.vpcId),
    };
};
var deserializeMetadata = function (output) {
    var _a;
    return ({
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"],
    });
};
var collectBody = function (streamBody, context) {
    if (streamBody === void 0) { streamBody = new Uint8Array(); }
    if (streamBody instanceof Uint8Array) {
        return Promise.resolve(streamBody);
    }
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function (streamBody, context) {
    return collectBody(streamBody, context).then(function (body) { return context.utf8Encoder(body); });
};
var isSerializableHeaderValue = function (value) {
    return value !== undefined &&
        value !== null &&
        value !== "" &&
        (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) &&
        (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function (streamBody, context) {
    return collectBodyString(streamBody, context).then(function (encoded) {
        if (encoded.length) {
            return JSON.parse(encoded);
        }
        return {};
    });
};
var loadRestJsonErrorCode = function (output, data) {
    var findKey = function (object, key) { return Object.keys(object).find(function (k) { return k.toLowerCase() === key.toLowerCase(); }); };
    var sanitizeErrorCode = function (rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) {
            cleanValue = cleanValue.split(":")[0];
        }
        if (cleanValue.indexOf("#") >= 0) {
            cleanValue = cleanValue.split("#")[1];
        }
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) {
        return sanitizeErrorCode(output.headers[headerKey]);
    }
    if (data.code !== undefined) {
        return sanitizeErrorCode(data.code);
    }
    if (data["__type"] !== undefined) {
        return sanitizeErrorCode(data["__type"]);
    }
    return "";
};
